var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g11, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _g12, _path118, _path119, _path120, _path121, _path122, _path123, _g13, _g14, _g15, _g16, _g17, _path124, _path125, _path126, _g18, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _g19, _path149, _path150, _g20, _path151, _g21, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _g22, _g23, _g24, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _g25, _g26, _path173, _path174, _g27, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _g28, _g29, _g30, _g31, _g32, _path191, _path192, _path193, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _path194, _g40, _g41, _path195, _g42, _path196, _path197, _g43, _g44, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _g45, _g46, _path205, _path206, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _path207, _g59, _rect, _path208, _rect2, _rect3, _path209, _path210, _path211, _path212, _path213, _g60, _g61, _g62, _g63, _path214, _path215, _path216, _path217, _g64, _path218, _path219, _g65, _path220, _path221, _path222, _path223, _g66, _path224, _path225, _path226, _path227, _path228, _path229, _g67, _g68, _path230, _path231, _path232, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _path233, _path234, _path235, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _path236, _g93, _path237, _g94, _path238, _g95, _path239, _path240, _path241, _g96, _g97, _g98, _g99, _g100, _path242, _g101, _g102, _g103, _g104, _g105, _g106;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10926",
    "data-name": "Group 10926",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 834.883,
    height: 427.57,
    viewBox: "0 0 834.883 427.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3228",
    "data-name": "Rectangle 3228",
    width: 834.883,
    height: 427.57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3106",
    "data-name": "Rectangle 3106",
    width: 210.71,
    height: 20.984,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3107",
    "data-name": "Rectangle 3107",
    width: 19.141,
    height: 19.723,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3108",
    "data-name": "Rectangle 3108",
    width: 14.727,
    height: 19.723,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3110",
    "data-name": "Rectangle 3110",
    width: 22.07,
    height: 19.723,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3111",
    "data-name": "Rectangle 3111",
    width: 180.739,
    height: 18.33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3112",
    "data-name": "Rectangle 3112",
    width: 16.623,
    height: 16.344,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3113",
    "data-name": "Rectangle 3113",
    width: 12.677,
    height: 16.344,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3114",
    "data-name": "Rectangle 3114",
    width: 12.678,
    height: 16.344,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3115",
    "data-name": "Rectangle 3115",
    width: 20.617,
    height: 16.344,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3116",
    "data-name": "Rectangle 3116",
    width: 10.869,
    height: 6.319,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3118",
    "data-name": "Rectangle 3118",
    width: 148.046,
    height: 113.435,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3119",
    "data-name": "Rectangle 3119",
    width: 150.644,
    height: 112.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3120",
    "data-name": "Rectangle 3120",
    width: 157.815,
    height: 83.402,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3121",
    "data-name": "Rectangle 3121",
    width: 147.064,
    height: 81.408,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3122",
    "data-name": "Rectangle 3122",
    width: 99.921,
    height: 57.343,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3123",
    "data-name": "Rectangle 3123",
    width: 150.943,
    height: 100.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3124",
    "data-name": "Rectangle 3124",
    width: 127.32,
    height: 88.551,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 43.327,
    height: 28.083,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3126",
    "data-name": "Rectangle 3126",
    width: 58.001,
    height: 44.793,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3127",
    "data-name": "Rectangle 3127",
    width: 820.647,
    height: 10.543,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3128",
    "data-name": "Rectangle 3128",
    width: 211.624,
    height: 5.666,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3129",
    "data-name": "Rectangle 3129",
    width: 319.313,
    height: 6.971,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3130",
    "data-name": "Rectangle 3130",
    width: 21.205,
    height: 17.914,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3131",
    "data-name": "Rectangle 3131",
    width: 23.315,
    height: 17.458,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3132",
    "data-name": "Rectangle 3132",
    width: 58.166,
    height: 29.921,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3133",
    "data-name": "Rectangle 3133",
    width: 520.136,
    height: 14.816,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29209",
    "data-name": "Path 29209",
    d: "M263,308.243l13.138.584.341-6.586-11.973-1.019Z",
    transform: "translate(-263.004 -301.222)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -21.352,
    y1: 2.158,
    x2: -21.271,
    y2: 2.158,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3c9b0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29214",
    "data-name": "Path 29214",
    d: "M276.846,73.666c-.754.3-1.077,2.851-1.077,2.851s-3.843,4.754-1.4,8.367,4.8,6.769,8.75,6.693a14.718,14.718,0,0,0,9.96-5.1c1.473-2.092,4.265-11.294,4.265-11.294-1.613-.647-1.618-.914-2.685-1.029-.876-.093-11.8-.571-16.105-.571a9.112,9.112,0,0,0-1.7.079",
    transform: "translate(-273.555 -73.587)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -13.825,
    y1: 18.234,
    x2: -13.774,
    y2: 18.234,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29216",
    "data-name": "Path 29216",
    d: "M276.134,90.283s5.074,8.924,7.286,8.112,9.425-9.024,9.425-9.024l.123-29.815-11.492-1.418Z",
    transform: "translate(-276.134 -58.138)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -17.436,
    y1: 8.344,
    x2: -17.373,
    y2: 8.344,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed9a66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7c9ad"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3136",
    "data-name": "Rectangle 3136",
    width: 23.476,
    height: 6.383,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3137",
    "data-name": "Rectangle 3137",
    width: 6.527,
    height: 16.758,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29222",
    "data-name": "Path 29222",
    d: "M193.741,128.205c2.106,1.445,7.454,2.294,7.454,2.294l4.729-2.577s-8.313-2.23-9.918-2.443a2.529,2.529,0,0,0-.323-.02c-1.618,0-3.911,1.391-1.942,2.745",
    transform: "translate(-192.981 -125.46)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -28.059,
    y1: 17.656,
    x2: -27.914,
    y2: 17.656,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29223",
    "data-name": "Path 29223",
    d: "M215,128.351a17.439,17.439,0,0,1-3.276-.319,20.348,20.348,0,0,0-3.045-.33c-4.668.172-7.071,2.7-13.649,2.209-3.536-.263-5.477-1.55-8.383-1.884s-3.878,2.835-1.96,4.524c1.958,1.726,5.724,3.061,9.454,4.928a6.478,6.478,0,0,0,2.108.652c1.55.188,4.616.372,7.2.5a13.982,13.982,0,0,0,7.973-2.014,6.414,6.414,0,0,1,3.564-.926l9.462.358-1.03-9.941s-2.811,1.761-8.413,2.238",
    transform: "translate(-183.692 -126.113)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -5.844,
    y1: 19.998,
    x2: -5.812,
    y2: 19.998,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29224",
    "data-name": "Path 29224",
    d: "M194.718,132.376c1.713.478,11.742-.055,10.6-.7s-2-1.139-6.442-.039c-3.041.754-7.573-.435-10.125-1.259,1.966.69,4.877,1.7,5.968,2m-5.968-2c-1.118-.392-1.93-.68-1.93-.68s.756.3,1.93.68",
    transform: "translate(-186.819 -129.697)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -18.767,
    y1: 14.449,
    x2: -18.668,
    y2: 14.449,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29225",
    "data-name": "Path 29225",
    d: "M194.908,131.6c1.713.476,11.742-.056,10.6-.7s-2-1.141-6.443-.04c-3.04.755-7.57-.435-10.124-1.259,1.966.69,4.877,1.7,5.968,2m-5.968-2c-1.118-.391-1.93-.68-1.93-.68s.756.3,1.93.68",
    transform: "translate(-187.009 -128.92)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -18.786,
    y1: 14.506,
    x2: -18.687,
    y2: 14.506,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29226",
    "data-name": "Path 29226",
    d: "M194.6,130.936c1.713.476,11.743-.056,10.6-.7s-2-1.139-6.442-.039c-3.041.754-7.572-.436-10.125-1.261,1.966.69,4.877,1.7,5.968,2m-5.968-2c-1.118-.391-1.93-.68-1.93-.68s.756.3,1.93.68",
    transform: "translate(-186.698 -128.256)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -18.754,
    y1: 14.554,
    x2: -18.655,
    y2: 14.554,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3144",
    "data-name": "Rectangle 3144",
    width: 7.582,
    height: 10.478,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3145",
    "data-name": "Rectangle 3145",
    width: 13.134,
    height: 58.329,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3146",
    "data-name": "Rectangle 3146",
    width: 3.662,
    height: 4.788,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3147",
    "data-name": "Rectangle 3147",
    width: 4.788,
    height: 6.706,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3148",
    "data-name": "Rectangle 3148",
    width: 4.55,
    height: 37.365,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3149",
    "data-name": "Rectangle 3149",
    width: 14.099,
    height: 42.545,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3150",
    "data-name": "Rectangle 3150",
    width: 18.566,
    height: 4.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29248",
    "data-name": "Path 29248",
    d: "M287.377,311.546l13.153.584-.233-8.639-12.912-.938Z",
    transform: "translate(-287.377 -302.554)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -23.376,
    y1: 1.768,
    x2: -23.295,
    y2: 1.768,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29263",
    "data-name": "Path 29263",
    d: "M292.05,6.78c-7.309.131-22.739,7.508-24.668,11.62a115.142,115.142,0,0,0-4.119,11.031s-1.69,8.748-1.025,14.95,1.551,13.513,2.125,15.666.8,3.33.8,3.33l13.064,25.785L297.143,85.9S309.1,41.379,309.681,38.114s2.284-11.359,1.423-14.689c-.856-3.312-11.643-16.646-18.949-16.647h-.105",
    transform: "translate(-262.083 -6.779)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -5.079,
    y1: 4.478,
    x2: -5.06,
    y2: 4.478,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29276",
    "data-name": "Path 29276",
    d: "M264.75,16.736c-.052.588-2.791,14.819-2.791,14.819s22.434-.98,24.118-1.5c.908-.281,7.169-4.361,12.752-8.064,1.369,2.665,8.217,16.016,8.476,17.074.288,1.174-4.86,15.666-6.1,18.408s-4.273,7.181-6.994,8.095-24.032-.391-26.521-.784L265.2,64.39s11.71,26.5,12.253,27.416,21.484-2.48,21.484-2.48l18.1-64.1-9.646-9.811a59.99,59.99,0,0,0-4.656-4.55,47.646,47.646,0,0,0-12.96-7.115h0c-.648,0-24.972,12.4-25.024,12.99",
    transform: "translate(-261.959 -3.746)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29278",
    "data-name": "Path 29278",
    d: "M296.048,42.687a59.506,59.506,0,0,0-1.107,7.094,27.219,27.219,0,0,0,5.659-2.23c1.585-1.089,3.483-3.232,3.647-7.454s-5.373-6.549-5.373-6.549a90.481,90.481,0,0,0-2.825,9.139",
    transform: "translate(-294.941 -33.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -38.461,
    y1: 23.582,
    x2: -38.331,
    y2: 23.582,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29284",
    "data-name": "Path 29284",
    d: "M281.453,35.684a3.852,3.852,0,0,0-.148,1.153,3.954,3.954,0,0,0,1.936,3.3c.694.081,1.386.144,1.961.163a16.977,16.977,0,0,0,1.866-.073h0a3.747,3.747,0,0,0,1.937-3.386,3.942,3.942,0,0,0-3.941-3.853,3.746,3.746,0,0,0-3.614,2.7",
    transform: "translate(-281.304 -32.984)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -47.872,
    y1: 49.305,
    x2: -47.702,
    y2: 49.305,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#734120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29288",
    "data-name": "Path 29288",
    d: "M264.888,34.959a3.376,3.376,0,0,0-.193,1.034,3.549,3.549,0,0,0,1.681,3.074c.652.107,1.307.2,1.85.24a16.109,16.109,0,0,0,1.772.023h0a3.344,3.344,0,0,0,1.945-3.639,3.724,3.724,0,0,0-3.506-3c-.065,0-.129,0-.195,0a3.528,3.528,0,0,0-3.356,2.273",
    transform: "translate(-264.693 -32.686)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -43.58,
    y1: 49.113,
    x2: -43.415,
    y2: 49.113,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29292",
    "data-name": "Path 29292",
    d: "M303.419,172.076c-.367,1.37-3.174,1.327-5.429,5.009s-3.942,5.672-3.3,6.569a1.926,1.926,0,0,0,3.024.205c.782-1.065,3.18-4.087,3.18-4.087a77.785,77.785,0,0,0-3.691,8.308c-1.229,3.558-2.491,7.733-2.371,8.232s1.489,1.86,3.914,1.671,7.418-2.623,8.683-4.046,3.979-9.766,4.21-15.366.7-9.71.7-9.71l-8.5-.41a19.876,19.876,0,0,1-.427,3.624",
    transform: "translate(-294.552 -168.452)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -12.768,
    y1: 5.894,
    x2: -12.724,
    y2: 5.894,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3158",
    "data-name": "Rectangle 3158",
    width: 8.269,
    height: 4.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29301",
    "data-name": "Path 29301",
    d: "M91.3,63.153c-.624,4.841-4.606,10.54-4.606,10.54s16.317,4.764,21.627,3.983,4.92-2.889,4.92-2.889a19.625,19.625,0,0,1-3.67-10.306,63.662,63.662,0,0,1-.077-10.15L91.6,46.039s.327,12.274-.3,17.114",
    transform: "translate(-86.692 -46.039)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -4.293,
    y1: 11.295,
    x2: -4.244,
    y2: 11.295,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29311",
    "data-name": "Path 29311",
    d: "M189.792,95.735c-3.558,2.655-3.6,4.5-5.384,7.47s-5.613,3.3-5.613,3.3l4.982,10.413s10.868-4.234,15.017-7.317,11.857-3.111,8.64-9.2c-1.049-1.985-1.5-3.624-3.188-5.195a8.376,8.376,0,0,0-5.728-1.77c-3.516,0-7.27,1.207-8.726,2.293",
    transform: "translate(-178.795 -93.442)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -6.291,
    y1: 9.591,
    x2: -6.255,
    y2: 9.591,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3166",
    "data-name": "Rectangle 3166",
    width: 17.435,
    height: 11.466,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29317",
    "data-name": "Path 29317",
    d: "M189.878,98.9s-5.093.375-6.175,2.21c-.528.9-1.169,2.053-1.758,3.142a1.647,1.647,0,0,0,1.881,2.378c5.551-1.527,15.526-4.331,16.528-5.024,1.4-.964,1.918-2.505.475-3.126a6.733,6.733,0,0,0-2.062-.2c-3.252,0-8.888.616-8.888.616",
    transform: "translate(-181.739 -98.284)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -11.083,
    y1: 27.517,
    x2: -11.022,
    y2: 27.517,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3169",
    "data-name": "Rectangle 3169",
    width: 70.512,
    height: 21.709,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3170",
    "data-name": "Rectangle 3170",
    width: 7.2,
    height: 29.676,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29332",
    "data-name": "Path 29332",
    d: "M67.629,167.9s2.074,7.352,2.508,9.231-.3,8.295.275,11.576,4.809,10.31,5.576,11.075,14.6-2.651,15.257-3.717-2.218-11.819-3.123-13.669-3.742-3.574-5.113-5.08S80,165.214,80,165.214Z",
    transform: "translate(-67.629 -165.214)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -2.122,
    y1: 6.8,
    x2: -2.088,
    y2: 6.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3173",
    "data-name": "Rectangle 3173",
    width: 10.362,
    height: 60.13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29337",
    "data-name": "Path 29337",
    d: "M90.675,12.721c-5.507,4.237-6.33,16.064-6.323,24.372,0,1.186,1.01,10.777,2.749,15.3s4.411,11.819,12.948,15.64c9.483,4.247,18.418,5.022,21.121,3.958s3.3-9.41,5.563-14.853a31.058,31.058,0,0,0,2.23-15.6,26.926,26.926,0,0,0-1.059-4.48,34.672,34.672,0,0,0,2.328-4.178A77.085,77.085,0,0,0,126.986,17.7c-2.455-6.391-6.937-9.435-15.734-10.318-1.562-.156-3.071-.251-4.55-.251a24.6,24.6,0,0,0-16.027,5.593",
    transform: "translate(-84.352 -7.128)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1.931,
    y1: 5.826,
    x2: -1.907,
    y2: 5.826,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29340",
    "data-name": "Path 29340",
    d: "M83.07,29.6c-2.831.928-2.36,5.417-1.386,7.692s1.9,4.95,3.148,6.343,3.562-.183,3.562-.183l.73-12.374a9.063,9.063,0,0,0-4.665-1.69,4.457,4.457,0,0,0-1.389.212",
    transform: "translate(-80.929 -29.387)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -6.047,
    y1: 22.159,
    x2: -5.969,
    y2: 22.159,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29345",
    "data-name": "Path 29345",
    d: "M99.451,29.921s-.544.173-.559.189a3.817,3.817,0,0,0-.971,3.047,3.354,3.354,0,0,0,1.414,2.68,9.1,9.1,0,0,0,1.942.219,4.646,4.646,0,0,0,2.206-.731,3.625,3.625,0,0,0,.614-2.176,4.24,4.24,0,0,0-1.49-3.375,2.438,2.438,0,0,0-1.49-.526,2.515,2.515,0,0,0-1.666.672",
    transform: "translate(-97.921 -29.249)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -19.998,
    y1: 54.494,
    x2: -19.794,
    y2: 54.494,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001a35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29350",
    "data-name": "Path 29350",
    d: "M114.879,29.038a2.566,2.566,0,0,0-1.9,1.417,3.747,3.747,0,0,0-.367,1.724,2.8,2.8,0,0,0,1.374,2.688,3.856,3.856,0,0,0,2.221-.349,2.255,2.255,0,0,0,.891-1.053l.015-.016a4.192,4.192,0,0,0,.175-1.27,3.615,3.615,0,0,0-1.038-2.789,1.58,1.58,0,0,0-1.035-.383,1.749,1.749,0,0,0-.338.032",
    transform: "translate(-112.614 -29.006)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -30.132,
    y1: 62.61,
    x2: -29.864,
    y2: 62.61,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29360",
    "data-name": "Path 29360",
    d: "M113.325,0c-7.42.032-21.24,4.243-24.992,8.087-2.1,2.152-2.575,4.119-2.488,5.615-.938.28-7.381,2.7-4.006,15.81A126.193,126.193,0,0,1,84.887,49.6l3.446-8.313,1.206-.584,4.031-10.46s2.145-3.686,2.369-5.727l.021.017s3.3-5.069,19.98-5.97c10.821-.584,10.346,8.774,10.346,8.774s4.984-10.728,4.262-14.471S121.894,2.776,116.925.539A8.885,8.885,0,0,0,113.494,0Z",
    transform: "translate(-80.869)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3183",
    "data-name": "Rectangle 3183",
    width: 9.15,
    height: 7.184,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3184",
    "data-name": "Rectangle 3184",
    width: 14.301,
    height: 7.754,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29366",
    "data-name": "Path 29366",
    d: "M293.733,155.862s.169,1.153,1.756,1.127a24.46,24.46,0,0,0,3.782-.355,16.074,16.074,0,0,1,.714-3.146,22.871,22.871,0,0,0-6.251,2.373",
    transform: "translate(-293.733 -153.489)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -57.112,
    y1: 46.859,
    x2: -56.917,
    y2: 46.859,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29367",
    "data-name": "Path 29367",
    d: "M303.7,153.966a22.739,22.739,0,0,0-9.97,2.839s.169,1.153,1.756,1.127,4.866-1.51,6.849-.987c-.472-.009-6.915,1.043-7.961,2.465l6.338,7.9c1.115-.183,1.643-.124,4-1.873,2.313-1.718,2.727-4.377,4.668-6.7a55.673,55.673,0,0,0,4.3-5.6l-2.808-2.477s-5.717,3.29-7.163,3.3",
    transform: "translate(-293.733 -150.668)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -16.961,
    y1: 11.157,
    x2: -16.903,
    y2: 11.157,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29370",
    "data-name": "Path 29370",
    d: "M334.88,59.054l-5.444,34.278a129.483,129.483,0,0,0,29.326,2.688c13.747-.2,16.253-2.627,16.253-2.627s-8.279-17.97-1.649-52.55c-2.828-3.4-6.028-4.772-9.343-4.772-13.592,0-29.144,22.982-29.144,22.982",
    transform: "translate(-329.436 -36.072)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29372",
    "data-name": "Path 29372",
    d: "M345.693,64.61s1.757,3.571,1.7,10.15-2.456,17.814-2.456,17.814,1.427,1.1,4.888.948a13.128,13.128,0,0,0,5.86-1.655,44.8,44.8,0,0,1-2.407-13.983c.111-7.05,2.008-19.127,2.455-22.275-1.981,3.5-10.042,9-10.042,9",
    transform: "translate(-344.939 -55.61)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -39.466,
    y1: 9.23,
    x2: -39.351,
    y2: 9.23,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29373",
    "data-name": "Path 29373",
    d: "M333.565,40.75c-4.569,4.762-11.826,6.661-11.826,6.661s-.419,23.462-.212,24.5,14.628,22.142,16.707,22.086c7.6-2.069,17.533-11.133,20.277-13.784a22.092,22.092,0,0,0,4.578-6.983l.388-7.161s1.913-1.709,2.947-6.158.518-6.1-.931-7.345-6.827,2.172-6.827,2.172a35.709,35.709,0,0,1-9.893-14.12c-2.276-5.9-2.831-14.327-2.831-14.327s-7.516,9.394-12.377,14.463",
    transform: "translate(-321.47 -26.287)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -5.959,
    y1: 7.76,
    x2: -5.94,
    y2: 7.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29376",
    "data-name": "Path 29376",
    d: "M334.211,49.966a2.635,2.635,0,1,0,2.619-2.917,2.78,2.78,0,0,0-2.619,2.917",
    transform: "translate(-334.211 -47.049)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -83.531,
    y1: 61.6,
    x2: -83.281,
    y2: 61.6,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29381",
    "data-name": "Path 29381",
    d: "M325.557,46.856c-1.131.071-2.03,1.307-2,2.933s1.253,2.959,2.387,2.964,2.078-.975,2.178-2.752c.129-2.3-.66-3.155-2.256-3.155-.1,0-.2,0-.307.009",
    transform: "translate(-323.555 -46.847)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -87.671,
    y1: 60.441,
    x2: -87.4,
    y2: 60.441,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29392",
    "data-name": "Path 29392",
    d: "M347.552,82.608a49.113,49.113,0,0,0-8.115,2.628s1.589,6.853,9.992,6.307,13.194-7.924,13.194-7.924a29.315,29.315,0,0,0-4.265-1.358c-.46-.025-2.282-.143-4.47-.143a33.921,33.921,0,0,0-6.336.49",
    transform: "translate(-339.437 -82.118)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -22.237,
    y1: 13.011,
    x2: -22.171,
    y2: 13.011,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3200",
    "data-name": "Rectangle 3200",
    width: 10.88,
    height: 44.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3201",
    "data-name": "Rectangle 3201",
    width: 6.461,
    height: 136.426,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3202",
    "data-name": "Rectangle 3202",
    width: 18.037,
    height: 188.934,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3203",
    "data-name": "Rectangle 3203",
    width: 19.914,
    height: 16.172,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3204",
    "data-name": "Rectangle 3204",
    width: 2.687,
    height: 25.108,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3205",
    "data-name": "Rectangle 3205",
    width: 6.969,
    height: 15.93,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3206",
    "data-name": "Rectangle 3206",
    width: 21.617,
    height: 28.806,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29406",
    "data-name": "Path 29406",
    d: "M367.537,167.218s-7.309,5.253-10.691,8.14a25.323,25.323,0,0,0-4.162,4.073s.427.5,1.9-.092,6.478-3.426,6.478-3.426-3.076,7.284-5.8,10.552-5.643,6.663-5.643,6.663a.63.63,0,0,0,.59.7,21.787,21.787,0,0,0,8.675-3.578,47.917,47.917,0,0,0,7.963-8.179c1.307-1.659,4.441-16.148,4.441-16.148l-1.61-.7Z",
    transform: "translate(-349.612 -165.214)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -13.59,
    y1: 5.875,
    x2: -13.551,
    y2: 5.875,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3209",
    "data-name": "Rectangle 3209",
    width: 24.652,
    height: 13.904,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3210",
    "data-name": "Rectangle 3210",
    width: 4.76,
    height: 3.272,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3211",
    "data-name": "Rectangle 3211",
    width: 3.668,
    height: 2.156,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29416",
    "data-name": "Path 29416",
    d: "M347.926,19.11v0c-7.562-.651-18.02,3.254-23.3,10.128-8.307,10.82-5.216,24.8-5.216,24.8a77.736,77.736,0,0,0,27.032-15.066c.712-.6,1.694-1.469,1.694-1.469A32.437,32.437,0,0,0,353.653,50.6c2.352,3.44,10.48,11.475,10.48,11.475l-.168,13.605a49.562,49.562,0,0,0,1.551,12.009c1.567,5.281,13.036,11.426,13.036,11.426s-2.038-13.425-1.68-23.407c.452-12.6,4.093-26.981-.092-38.153-2.264-6.048-9.092-17.709-25.23-18.589-.164-.009-.406-.016-.715-.016a28.43,28.43,0,0,0-2.909.164",
    transform: "translate(-318.849 -18.946)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3214",
    "data-name": "Rectangle 3214",
    width: 30.752,
    height: 20.938,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3216",
    "data-name": "Rectangle 3216",
    width: 30.754,
    height: 20.937,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3219",
    "data-name": "Rectangle 3219",
    width: 30.754,
    height: 20.938,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3220",
    "data-name": "Rectangle 3220",
    width: 30.875,
    height: 21.068,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3223",
    "data-name": "Rectangle 3223",
    width: 30.875,
    height: 21.066,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3226",
    "data-name": "Rectangle 3226",
    width: 25.368,
    height: 17.475,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29432",
    "data-name": "Path 29432",
    d: "M298.17,155.992c-.442.16-2.262.854-3.879,1.654,0,0-1.207,1.406,1.193,4.752s4.641,3.227,5.056,3.17a2.229,2.229,0,0,0,1.4-.942c1.138-1.333-1.154-6.318-2.334-7.879a1.663,1.663,0,0,0-1.186-.8.751.751,0,0,0-.253.044",
    transform: "translate(-293.987 -155.948)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -22.464,
    y1: 13.653,
    x2: -22.387,
    y2: 13.653,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10925",
    "data-name": "Group 10925",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28990",
    "data-name": "Path 28990",
    d: "M405.071,144.9l26.278,18.3-10.981,9.686L394.524,154.4Z",
    transform: "translate(131.766 48.396)",
    fill: "#4b545e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10685",
    "data-name": "Group 10685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10684",
    "data-name": "Group 10684",
    clipPath: "url(#clip-path)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28991",
    "data-name": "Path 28991",
    d: "M414.074,161.649c-13.018-5.076-17.419-9.928-18.31-10.462l-1.239,1.115L420.369,170.8,427,164.946a60.711,60.711,0,0,1-12.926-3.3",
    transform: "translate(131.766 50.495)",
    fill: "#3d454d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28992",
    "data-name": "Path 28992",
    d: "M425.2,166.751l4.017-3.543-26.278-18.3-2.042,1.838c10.016,3.231,11.172,5.359,24.3,20.008",
    transform: "translate(133.895 48.396)",
    fill: "#63707d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28993",
    "data-name": "Path 28993",
    d: "M410.129,132.522c-.444.65-19.346,35.868-22.082,39.517s.728,4.757,2.157,4.968,8.9-12.211,15.992-24.432c7.149-12.315,11.314-17.885,10.444-19.177s-6.067-1.525-6.511-.875",
    transform: "translate(129.263 44.144)",
    fill: "#535d68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28994",
    "data-name": "Path 28994",
    d: "M394.536,157.065A212.413,212.413,0,0,0,407.221,137.1c1.383-2.361,3.184-4.393,5.911-4.43-1.836-.623-4.976-.647-5.317-.148-.275.4-7.65,14.1-13.855,25.3.192-.253.384-.5.576-.758",
    transform: "translate(131.578 44.144)",
    fill: "#63707d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28995",
    "data-name": "Path 28995",
    d: "M416.445,132.931c-3.841,9.153-15.1,25.29-22.069,34.658-2.923,3.927-6.03,3.8-6.327,4.2-2.728,3.639.727,4.756,2.156,4.968s8.9-12.211,15.992-24.432c7.15-12.315,11.314-17.885,10.445-19.177a1.155,1.155,0,0,0-.2-.212",
    transform: "translate(129.263 44.397)",
    fill: "#3d454d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28996",
    "data-name": "Path 28996",
    d: "M329.562,213.32S367.13,205.335,385,201c20.347-4.936,49.827-15.7,53.952-2.588,4.138,13.153-11.171,42.053-11.171,42.053L335.206,244.1Z",
    transform: "translate(110.07 64.175)",
    fill: "#255c6e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28997",
    "data-name": "Path 28997",
    d: "M428.419,220.242c-8.711,8.291-32.484,8.775-50.985,10.963-14.116,1.669-22.81,2.649-43.448,4.125l92.315-3.618s3.059-5.779,6.074-13.351a6.117,6.117,0,0,0-3.955,1.881",
    transform: "translate(111.547 72.93)",
    fill: "#1f4b5a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28998",
    "data-name": "Path 28998",
    d: "M409.815,199.985c8.575.283,16.62,3.959,19.037,10.812,1.531,4.345.273,9.238.293,13.781,3.342-8.915,6.2-19.551,4.117-26.164-4.125-13.114-33.6-2.348-53.953,2.587-8.487,2.058-21.475,4.953-32.719,7.413,5,.2,58.718-8.578,63.224-8.429",
    transform: "translate(115.757 64.175)",
    fill: "#327a92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28999",
    "data-name": "Path 28999",
    d: "M313.337,149.041s13.317-3.918,17.316-1.062c2.148,1.533,6.11,24.288,14.854,49.834a235.38,235.38,0,0,0,17.3,38.762s4.133,14.334,4.6,15.674c1.78,5.135-7.852,6.35-17.966,6.891-10.474.56-21.489.276-22.6-2.883-2.177-6.179-33.04-89.355-31.734-95.952s18.23-11.264,18.23-11.264",
    transform: "translate(98.549 49.075)",
    fill: "#255c6e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29000",
    "data-name": "Path 29000",
    d: "M326.944,167.292c1.794,5.625,13.041,42.375,24.123,57.366a244.279,244.279,0,0,1-11.081-26.845c-8.744-25.546-12.706-48.3-14.853-49.835-2.631-1.877-9.286-.824-13.533.115,10.281-1.611,11.692,7.758,15.345,19.2",
    transform: "translate(104.07 49.075)",
    fill: "#327a92"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29001",
    "data-name": "Path 29001",
    d: "M349.082,254.4a133.191,133.191,0,0,1-29.3-42.606c-7.369-16.563-16.017-37.165-22.319-57.591a7.126,7.126,0,0,0-2.361,3.671c-1.306,6.6,29.557,89.775,31.736,95.952,1.114,3.16,12.127,3.443,22.6,2.883.336-.017.668-.039,1-.059a11.026,11.026,0,0,0-1.365-2.25",
    transform: "translate(98.548 51.503)",
    fill: "#1f4b5a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29002",
    "data-name": "Path 29002",
    d: "M344.518,205.674s-9.06,4.478-10.94,6.773-1.876,4.194-.357,4.52,3.925-3.991,5.816-5.145-1.877.291.367,4.513,5.745,5.391,5.077.922.037-11.582.037-11.582",
    transform: "translate(110.925 68.693)",
    fill: "#1f4b5a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29003",
    "data-name": "Path 29003",
    d: "M314.761,149.394c-.265-.52-3.925-.168-6.323.522-2.453.706-5.521,2.041-5.247,2.591s3.834-.044,6.279-.771c2.389-.711,5.556-1.821,5.291-2.341",
    transform: "translate(101.257 49.813)",
    fill: "#1f4b5a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29004",
    "data-name": "Path 29004",
    d: "M312.62,149.551c-.169-.333-2.736-.043-4.418.443-1.708.492-3.838,1.394-3.664,1.741s2.624-.083,4.329-.584c1.678-.495,3.923-1.265,3.754-1.6",
    transform: "translate(101.709 49.9)",
    fill: "#787877"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29005",
    "data-name": "Path 29005",
    d: "M311.794,149.568c-.254-.2-2.252.117-3.642.519-1.407.407-3.344,1.081-3.21,1.349s2.322-.04,3.728-.454c1.386-.408,3.418-1.179,3.123-1.414",
    transform: "translate(101.845 49.933)",
    fill: "#3d3d3c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29006",
    "data-name": "Path 29006",
    d: "M311.344,151.192a4.664,4.664,0,0,1-.7.463c-.2.113-.419.228-.636.332a10.346,10.346,0,0,1-4.031.883c-.288.007-.563,0-.838-.013l-.061-7.569.463-.073,1.053-.167,1.713-.277Z",
    transform: "translate(101.892 48.351)",
    fill: "#9c9c9c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29007",
    "data-name": "Path 29007",
    d: "M310.965,151.192a4.664,4.664,0,0,1-.7.463,11.614,11.614,0,0,0-4.051-6.607l1.713-.277Z",
    transform: "translate(102.271 48.351)",
    fill: "#b8b8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29008",
    "data-name": "Path 29008",
    d: "M310.006,151.874a10.322,10.322,0,0,1-4.031.883c-.288.007-.563,0-.838-.013l-.061-7.568.463-.072a11.567,11.567,0,0,0,4.468,6.77",
    transform: "translate(101.892 48.463)",
    fill: "#7b7b7b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29009",
    "data-name": "Path 29009",
    d: "M294.145,154.3c2.32,2.56,30.876-3.228,32.495-6.935,1.567-3.591-2.1-14.14-4.837-16.273-2.9-2.261-23.82-1.817-27.28,1.659-3.655,3.671-2.788,18.888-.377,21.549",
    transform: "translate(97.543 43.318)",
    fill: "#255c6e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29010",
    "data-name": "Path 29010",
    d: "M313.542,131.107c5.64.516,7.13,2.531,10.672,5.508-.991-2.5-2.221-4.68-3.3-5.521-2.691-2.094-20.429-1.872-26.187.94,5.188-.707,14.889-1.286,18.817-.927",
    transform: "translate(98.435 43.318)",
    fill: "#327a92"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29011",
    "data-name": "Path 29011",
    d: "M319.386,145.464c-9.763.044-18.538-4.673-26.078-11.945-2.172,5.552-1.246,17.211.835,19.507,2.32,2.561,30.876-3.228,32.495-6.935a5.89,5.89,0,0,0,.376-2.214,23.983,23.983,0,0,1-7.628,1.587",
    transform: "translate(97.546 44.594)",
    fill: "#1f4b5a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29012",
    "data-name": "Path 29012",
    d: "M485.337,144.727S451.484,133.3,449.255,133.4c-2.257.1-2.587.9-4.4,2.757-1.882,1.926-29.425,31.994-29.844,34.3-.43,2.362,71.954,34.752,73.423,30.229,1.4-4.294-3.094-55.958-3.094-55.958",
    transform: "translate(138.607 44.555)",
    fill: "#36393b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29013",
    "data-name": "Path 29013",
    d: "M436.128,149.344c5.389-7.867,5.417-10.584,5.2-10.872-6.276,7.13-25.939,28.214-26.317,30.291-.155.847,15.2,11.214,28.406,14.367-3.536-9.519-11.22-28.042-7.285-33.786",
    transform: "translate(138.607 46.248)",
    fill: "#252829"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29014",
    "data-name": "Path 29014",
    d: "M460.362,143.416c4.62,2.873,12.153,12.089,19.188,14.054s17.958-8.691,17.958-8.691S444.659,133.3,442.43,133.4c-2.257.1-2.587.9-4.4,2.757-.3.3-1.219,1.347-2.587,2.92,6.99-5.677,16.846-.69,24.922,4.335",
    transform: "translate(145.432 44.555)",
    fill: "#4d5357"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29015",
    "data-name": "Path 29015",
    d: "M742.268,299.061s-28.531-12.418-91.868-7.386c-42.174,3.351-46.676,6.454-46.676,6.454l-234.6-11.3L218.176,300.1a309.522,309.522,0,0,0-68.252-7.609,478.618,478.618,0,0,0-67.462,5.176s-9.366-33.85-11.052-50.134,16.736-54.407,71.949-61.717c61.061-8.084,163.343,74.457,253.87,76.264,102.724,2.05,194.154-76.113,262.636-78.633,52.2-1.92,65.834,9.084,72.342,15.85,29.376,30.539,42.247,76.9,42.247,76.9Z",
    transform: "translate(23.815 61.196)",
    fill: "#25292e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29016",
    "data-name": "Path 29016",
    d: "M202.57,211.884s37.568-7.985,55.437-12.318c20.347-4.936,49.827-15.7,53.952-2.588,4.138,13.153-11.171,42.053-11.171,42.053l-92.573,3.628Z",
    transform: "translate(67.656 63.695)",
    fill: "#255c6e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29017",
    "data-name": "Path 29017",
    d: "M301.427,218.806c-8.711,8.291-32.484,8.775-50.985,10.963-14.116,1.669-22.81,2.649-43.448,4.126l92.315-3.619s3.059-5.779,6.074-13.351a6.114,6.114,0,0,0-3.955,1.881",
    transform: "translate(69.134 72.45)",
    fill: "#1f4b5a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29018",
    "data-name": "Path 29018",
    d: "M282.823,198.548c8.575.283,16.62,3.959,19.037,10.812,1.531,4.345.273,9.238.293,13.781,3.342-8.915,6.2-19.551,4.117-26.164-4.125-13.114-33.6-2.348-53.953,2.587-8.487,2.06-21.475,4.953-32.719,7.413,5,.2,58.718-8.578,63.224-8.429",
    transform: "translate(73.344 63.695)",
    fill: "#327a92"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29019",
    "data-name": "Path 29019",
    d: "M186.345,147.6s13.319-3.918,17.317-1.062c2.148,1.533,6.11,24.288,14.854,49.834a235.381,235.381,0,0,0,17.3,38.762s4.133,14.334,4.6,15.674c1.78,5.135-7.852,6.35-17.966,6.891-10.474.56-21.489.276-22.6-2.883-2.178-6.179-33.042-89.355-31.736-95.954s18.23-11.263,18.23-11.263",
    transform: "translate(56.135 48.595)",
    fill: "#255c6e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29020",
    "data-name": "Path 29020",
    d: "M199.951,165.856c1.8,5.625,13.042,42.375,24.124,57.365a244.293,244.293,0,0,1-11.081-26.845c-8.744-25.546-12.706-48.3-14.853-49.835-2.631-1.877-9.286-.824-13.533.115,10.281-1.611,11.691,7.758,15.344,19.2",
    transform: "translate(61.657 48.595)",
    fill: "#327a92"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29021",
    "data-name": "Path 29021",
    d: "M222.091,252.966a133.153,133.153,0,0,1-29.3-42.606c-7.369-16.563-16.017-37.165-22.319-57.591a7.127,7.127,0,0,0-2.361,3.671c-1.306,6.6,29.557,89.775,31.736,95.952,1.113,3.16,12.127,3.443,22.6,2.883.336-.017.668-.039,1-.057a11,11,0,0,0-1.365-2.252",
    transform: "translate(56.135 51.023)",
    fill: "#1f4b5a"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29022",
    "data-name": "Path 29022",
    d: "M217.526,204.238s-9.06,4.478-10.94,6.773-1.876,4.194-.358,4.52,3.925-3.991,5.816-5.145-1.877.291.367,4.513,5.745,5.391,5.077.922.037-11.582.037-11.582",
    transform: "translate(68.511 68.213)",
    fill: "#1f4b5a"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29023",
    "data-name": "Path 29023",
    d: "M187.769,147.957c-.265-.52-3.925-.167-6.323.522-2.453.707-5.521,2.041-5.247,2.592s3.834-.045,6.279-.772c2.389-.711,5.556-1.82,5.291-2.341",
    transform: "translate(58.843 49.333)",
    fill: "#1f4b5a"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29024",
    "data-name": "Path 29024",
    d: "M185.628,148.115c-.169-.333-2.736-.043-4.417.442-1.709.494-3.839,1.4-3.666,1.742s2.624-.083,4.329-.584c1.678-.495,3.923-1.265,3.754-1.6",
    transform: "translate(59.295 49.421)",
    fill: "#787877"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29025",
    "data-name": "Path 29025",
    d: "M184.8,148.132c-.253-.2-2.252.117-3.642.519-1.407.407-3.344,1.081-3.21,1.349s2.322-.04,3.729-.454c1.386-.407,3.418-1.179,3.123-1.414",
    transform: "translate(59.432 49.453)",
    fill: "#3d3d3c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29026",
    "data-name": "Path 29026",
    d: "M184.352,149.756a4.558,4.558,0,0,1-.7.462c-.2.115-.419.229-.636.332a10.3,10.3,0,0,1-4.031.883c-.288.008-.563,0-.838-.012l-.061-7.569.463-.073,1.053-.167,1.713-.277Z",
    transform: "translate(59.478 47.872)",
    fill: "#9c9c9c"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29027",
    "data-name": "Path 29027",
    d: "M183.973,149.756a4.557,4.557,0,0,1-.7.462,11.615,11.615,0,0,0-4.051-6.606l1.713-.277Z",
    transform: "translate(59.857 47.872)",
    fill: "#b8b8b8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29028",
    "data-name": "Path 29028",
    d: "M183.016,150.438a10.358,10.358,0,0,1-4.033.883c-.288.007-.562,0-.838-.013l-.061-7.568.463-.073a11.572,11.572,0,0,0,4.469,6.771",
    transform: "translate(59.478 47.983)",
    fill: "#7b7b7b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29029",
    "data-name": "Path 29029",
    d: "M167.154,152.866c2.32,2.56,30.876-3.228,32.495-6.935,1.567-3.591-2.1-14.14-4.837-16.273-2.9-2.261-23.82-1.817-27.28,1.658-3.655,3.672-2.788,18.889-.378,21.551",
    transform: "translate(55.13 42.838)",
    fill: "#255c6e"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29030",
    "data-name": "Path 29030",
    d: "M186.55,129.67c5.64.516,7.13,2.531,10.672,5.508-.991-2.5-2.221-4.68-3.3-5.521-2.691-2.1-20.429-1.872-26.188.94,5.188-.707,14.889-1.287,18.817-.927",
    transform: "translate(56.021 42.837)",
    fill: "#327a92"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29031",
    "data-name": "Path 29031",
    d: "M192.394,144.028c-9.763.044-18.538-4.673-26.078-11.945-2.172,5.552-1.246,17.211.835,19.507,2.32,2.561,30.876-3.228,32.495-6.935a5.89,5.89,0,0,0,.376-2.214,23.984,23.984,0,0,1-7.628,1.587",
    transform: "translate(55.132 44.114)",
    fill: "#1f4b5a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10602",
    "data-name": "Group 10602",
    transform: "translate(407.794 202.938)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10601",
    "data-name": "Group 10601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10600",
    "data-name": "Group 10600",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29032",
    "data-name": "Path 29032",
    d: "M497.44,152.555,305.7,152.129l3.414,18.332,207.3,2.653s-1.259-5.759-7.292-11.3c-1.346-1.238-6.428-4.816-11.674-9.258",
    transform: "translate(-305.695 -152.129)",
    fill: "#65b1b8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10605",
    "data-name": "Group 10605",
    transform: "translate(444.592 203.168)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10604",
    "data-name": "Group 10604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10603",
    "data-name": "Group 10603",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29033",
    "data-name": "Path 29033",
    d: "M333.28,172.024h7L352.422,152.3h-8.009Z",
    transform: "translate(-333.28 -152.301)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10608",
    "data-name": "Group 10608",
    transform: "translate(464.02 203.168)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10607",
    "data-name": "Group 10607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10606",
    "data-name": "Group 10606",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29034",
    "data-name": "Path 29034",
    d: "M347.844,172.024h3.5L362.57,152.3h-3.624Z",
    transform: "translate(-347.844 -152.301)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10611",
    "data-name": "Group 10611",
    transform: "translate(513.847 203.168)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10610",
    "data-name": "Group 10610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10609",
    "data-name": "Group 10609",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29035",
    "data-name": "Path 29035",
    d: "M385.2,172.024h3.5L399.923,152.3H396.3Z",
    transform: "translate(-385.196 -152.301)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10614",
    "data-name": "Group 10614",
    transform: "translate(494.629 203.168)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10613",
    "data-name": "Group 10613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10612",
    "data-name": "Group 10612",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29036",
    "data-name": "Path 29036",
    d: "M370.79,172.024h10.841L392.86,152.3H381.892Z",
    transform: "translate(-370.79 -152.301)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10617",
    "data-name": "Group 10617",
    transform: "translate(230.468 202.938)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10616",
    "data-name": "Group 10616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615",
    "data-name": "Group 10615",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29037",
    "data-name": "Path 29037",
    d: "M175.964,152.129c-1.91,6.555-3.2,10.955-3.2,10.955l180.741,7.376-3.414-18.33Z",
    transform: "translate(-172.766 -152.129)",
    fill: "#65b1b8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10620",
    "data-name": "Group 10620",
    transform: "translate(258.059 202.938)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10619",
    "data-name": "Group 10619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10618",
    "data-name": "Group 10618",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29038",
    "data-name": "Path 29038",
    d: "M202.326,152.129l-8.878,16.345h7.566l9.056-16.345Z",
    transform: "translate(-193.449 -152.129)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10623",
    "data-name": "Group 10623",
    transform: "translate(279.066 202.938)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10622",
    "data-name": "Group 10622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10621",
    "data-name": "Group 10621",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29039",
    "data-name": "Path 29039",
    d: "M218.068,152.129,209.2,168.474h3.783l8.894-16.345Z",
    transform: "translate(-209.197 -152.129)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10626",
    "data-name": "Group 10626",
    transform: "translate(332.942 202.938)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10625",
    "data-name": "Group 10625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10624",
    "data-name": "Group 10624",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29040",
    "data-name": "Path 29040",
    d: "M258.456,152.129l-8.871,16.345h3.783l8.894-16.345Z",
    transform: "translate(-249.584 -152.129)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10629",
    "data-name": "Group 10629",
    transform: "translate(312.164 202.938)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10628",
    "data-name": "Group 10628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10627",
    "data-name": "Group 10627",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29041",
    "data-name": "Path 29041",
    d: "M242.879,152.129l-8.871,16.345H245.73l8.9-16.345Z",
    transform: "translate(-234.008 -152.129)",
    fill: "#151f21"
  }))))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29042",
    "data-name": "Path 29042",
    d: "M600.417,280.36c15.854-33.7.384-71.376-33.931-83.426-33.435-11.74-71.655,5.607-85.961,38.072C469.161,260.795,476,289,495.608,305.753c4.821,4.118,8.392,7.57,14.7,10.129,9.092,2.269,17.357,2.459,25.147,2.62,8.345.173,17.04.183,24.507-1.892a70.5,70.5,0,0,0,40.457-36.25",
    transform: "translate(158.653 64.545)",
    fill: "#36393b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29043",
    "data-name": "Path 29043",
    d: "M533.718,270.729c13.057-5.681,25.108-12.045,36.218-20.677,9.731-7.562,19.563-16.295,30.723-22.965a59.376,59.376,0,0,0-34.174-30.155c-33.434-11.74-71.655,5.608-85.961,38.073-10.156,23.046-5.752,47.96,9.242,64.943,13.428-10.767,26.867-21.785,43.952-29.22",
    transform: "translate(158.654 64.545)",
    fill: "#272a2b"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29044",
    "data-name": "Path 29044",
    d: "M539.009,203.015c-27.5,0-50.944,22.694-52.344,50.669s19.772,50.668,47.271,50.668c27.515,0,50.944-22.679,52.344-50.668s-19.758-50.669-47.271-50.669m-.252,52.969-.819.488-.967.275h-.946l-.82-.229-.774-.436-.642-.652-.47-.888-.2-.915.049-1,.276-.878.438-.764.724-.751.822-.487.963-.276h.947l.82.229.774.436.642.652.471.888.2.915-.049,1-.276.878-.438.764Zm42-1.119a46.844,46.844,0,0,1-1.275,7.839l-34.677-8.75Zm-36.366-3.106,35.622-9.235a44.855,44.855,0,0,1,.879,8.313Zm34.676-13.072-34.8,10.863,31.981-18a42.9,42.9,0,0,1,2.819,7.134m-4.726-10.528-31.6,19.819,26.605-26.272a41.816,41.816,0,0,1,4.99,6.453m-7.732-9.13-25.055,27.157,19.009-31.612a41.581,41.581,0,0,1,6.046,4.454m-26.018,24.5L551.811,210.6a41.169,41.169,0,0,1,5.393,2.148Zm7.517-33.926-10.2,35.241,2.681-36.238a42.9,42.9,0,0,1,7.517,1m-12.35,35.557L528.8,209.7a44.481,44.481,0,0,1,7.915-1.089ZM525,210.744l8.634,34.812-15.845-31.793A46.3,46.3,0,0,1,525,210.744m7,36.414-24.461-26.144a48.27,48.27,0,0,1,6.781-5.241Zm-27.341-23.267,25.466,24.532-30.371-18.209a48.451,48.451,0,0,1,4.905-6.323m23.017,25.769L495.033,239.6a48.149,48.149,0,0,1,2.644-5.867Zm-33.9-6.168,34.778,8.775-36.267-.919a46.717,46.717,0,0,1,1.489-7.856m35.192,10.969-36.214,9.389a45.43,45.43,0,0,1-.686-8.456Zm-35.351,13.283L529.1,256.667l-32.751,18.449a42.814,42.814,0,0,1-2.732-7.373m4.6,10.82,32.4-20.323-27.378,27.035a41.988,41.988,0,0,1-5.022-6.711m7.768,9.461L531.8,260.032l-19.63,32.644a41.44,41.44,0,0,1-6.192-4.653m26.786-25.33-11.616,34.093a41.41,41.41,0,0,1-5.579-2.236Zm-7.857,35.1,10.537-36.418-2.768,37.409a42.942,42.942,0,0,1-7.769-.991m12.69-36.734,7.159,36.482a44.48,44.48,0,0,1-8.144,1.215Zm11,35.364-8.868-35.762L555.948,293.2a46.217,46.217,0,0,1-7.346,3.223m10.817-5.312L541.362,259.06l24.849,26.56a47.873,47.873,0,0,1-6.793,5.495m9.623-8.46-25.8-24.858,30.6,18.346a48.865,48.865,0,0,1-4.8,6.511M545.687,256.56l32.647,10.058a47.7,47.7,0,0,1-2.5,5.946Z",
    transform: "translate(162.518 67.805)",
    fill: "#b1b8c2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29045",
    "data-name": "Path 29045",
    d: "M574.874,254.266a65.165,65.165,0,0,1-9.917,7.238,49.4,49.4,0,0,1-3.172,4.1l-1.641-1.579q-1.909.9-3.889,1.662l2.7,2.884a47.858,47.858,0,0,1-6.793,5.493l-3.383-6.006c-.966.243-1.929.491-2.924.7l-.77.161,3.606,7.237a46.327,46.327,0,0,1-7.346,3.222l-2.273-9.17q-1.709.38-3.432.8L537.5,280.5a44.592,44.592,0,0,1-8.144,1.217l.237-9.1q-1.8.534-3.583,1.143l-.591,7.979a42.826,42.826,0,0,1-7.769-.991l1.175-4.061a48.771,48.771,0,0,0-4.8,2.647l-.138.4c-.112-.035-.219-.081-.331-.117a39.1,39.1,0,0,0-5.236,4.033,47.463,47.463,0,0,0,18.35,3.651c21.5,0,40.492-13.851,48.442-33.256l-.247.216",
    transform: "translate(169.776 84.85)",
    fill: "#8e939c"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29046",
    "data-name": "Path 29046",
    d: "M492.561,262.582a44.935,44.935,0,0,1-.494-7.19l6.994-.177c1.2-1.218,2.421-2.424,3.675-3.6l-10.449-.264a46.468,46.468,0,0,1,1.489-7.857l14.127,3.564q1.569-1.295,3.19-2.505L495.034,239.6a47.838,47.838,0,0,1,2.643-5.867l16.387,8.7c.968-.651,1.946-1.282,2.941-1.876l-17.252-10.344a48.167,48.167,0,0,1,4.906-6.323l15.5,14.93q1.379-.71,2.795-1.333l-15.413-16.475a48.171,48.171,0,0,1,6.779-5.241l11.571,20.538q1.331-.484,2.693-.882l-10.8-21.667a46.235,46.235,0,0,1,7.21-3.019l5.966,24.054c.879-.2,1.766-.382,2.665-.523l-4.825-24.58a44.493,44.493,0,0,1,7.915-1.089l-.663,25.379c.883-.083,1.776-.125,2.673-.148l1.868-25.235a42.769,42.769,0,0,1,7.517,1L541.1,233.841c.915.029,1.833.076,2.748.144l7.968-23.385a41.267,41.267,0,0,1,5.395,2.148l-11.542,21.384q1.485.134,2.971.284l11.931-19.84a41.473,41.473,0,0,1,6.046,4.453L552.117,234.74c1.275.105,2.548.177,3.825.211l13.412-13.245a41.817,41.817,0,0,1,4.992,6.452l-8.4,5.268a63.065,63.065,0,0,0,8.83-4.612c1.586-.944,3.163-1.92,4.734-2.911a46.725,46.725,0,0,0-40.5-22.89c-27.5,0-50.944,22.694-52.344,50.669a50.528,50.528,0,0,0,1.471,15c1.4-2.074,2.863-4.114,4.425-6.106",
    transform: "translate(162.518 67.804)",
    fill: "#cad2de"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29047",
    "data-name": "Path 29047",
    d: "M535.049,208.331l.839.235-6.015,17.653Z",
    transform: "translate(176.971 69.58)",
    fill: "#b1b8c2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29048",
    "data-name": "Path 29048",
    d: "M541.953,245.35l17.543,4.426-.28.892Z",
    transform: "translate(181.006 81.944)",
    fill: "#cad2de"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29049",
    "data-name": "Path 29049",
    d: "M513.9,277.047l6.015-17.653-5.176,17.887Z",
    transform: "translate(171.637 86.635)",
    fill: "#cad2de"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29050",
    "data-name": "Path 29050",
    d: "M493.179,232.69l.28-.892,17.263,5.319Z",
    transform: "translate(164.716 77.418)",
    fill: "#b1b8c2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29051",
    "data-name": "Path 29051",
    d: "M550.4,215.959l.612.622L537.674,229.75Z",
    transform: "translate(179.577 72.128)",
    fill: "#b1b8c2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29052",
    "data-name": "Path 29052",
    d: "M537.231,253.569l12.93,12.454-.65.671Z",
    transform: "translate(179.429 84.689)",
    fill: "#cad2de"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29053",
    "data-name": "Path 29053",
    d: "M500.611,268.007l13.336-13.169-12.724,13.791Z",
    transform: "translate(167.198 85.113)",
    fill: "#cad2de"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29054",
    "data-name": "Path 29054",
    d: "M501.359,218.4l.65-.671,12.277,13.122Z",
    transform: "translate(167.448 72.718)",
    fill: "#b1b8c2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29055",
    "data-name": "Path 29055",
    d: "M560.08,231.017l.2.884-17.87,4.632Z",
    transform: "translate(181.157 77.157)",
    fill: "#cad2de"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29056",
    "data-name": "Path 29056",
    d: "M528.466,259.163l4.381,17.665-.866.247Z",
    transform: "translate(176.501 86.557)",
    fill: "#cad2de"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29057",
    "data-name": "Path 29057",
    d: "M492.481,250.615l17.878-4.634L492.677,251.5Z",
    transform: "translate(164.483 82.155)",
    fill: "#cad2de"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29058",
    "data-name": "Path 29058",
    d: "M516.533,208.792l.864-.248,3.516,17.911Z",
    transform: "translate(172.516 69.651)",
    fill: "#b1b8c2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29059",
    "data-name": "Path 29059",
    d: "M563.839,278.628c-14.128,10.547-32.9,14.071-49.313,7.6-18.337-7.218-28.706-24.906-27.942-43.755.666,17.17,11.584,33.408,29.577,40.641a52.705,52.705,0,0,0,47.678-4.486",
    transform: "translate(162.5 80.983)",
    fill: "#81858d"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29060",
    "data-name": "Path 29060",
    d: "M560.65,203.827c-27.333-9.7-60.782,5.974-72.582,32.568-11.651,26.31,1.45,57.3,27.762,67.853,26.861,10.761,57.58-3.666,70.268-30.766,12.822-27.416,2.467-59.731-25.447-69.656m20.84,68.04c-11.5,24.733-41.228,37.073-65.818,27.344-24.213-9.566-34.634-37.073-23.841-61.259,10.881-24.385,40.114-38.24,65.037-29.241,25.319,9.144,36.214,38.185,24.621,63.156",
    transform: "translate(161.58 67.11)",
    fill: "#4f4f4e"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29061",
    "data-name": "Path 29061",
    d: "M500.5,294.573q1.515-1.261,3.032-2.517c-15.24-12.634-20.465-34.465-11.7-54.1,10.881-24.387,40.114-38.241,65.036-29.242a43.542,43.542,0,0,1,22.216,17.814q2.469-2,5.01-3.921a45.1,45.1,0,0,0-23.444-18.776c-27.333-9.7-60.781,5.974-72.582,32.567-9.086,20.519-3.116,43.88,12.431,58.179",
    transform: "translate(161.58 67.11)",
    fill: "#454544"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29062",
    "data-name": "Path 29062",
    d: "M540.4,244.353a12.5,12.5,0,0,0-12.456-13.4,14.1,14.1,0,0,0-13.8,13.4,12.5,12.5,0,0,0,12.455,13.4,14.1,14.1,0,0,0,13.8-13.4",
    transform: "translate(171.714 77.134)",
    fill: "#b1b8c2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29063",
    "data-name": "Path 29063",
    d: "M535.158,235.532a17.408,17.408,0,0,1,.24,4.716,19.141,19.141,0,0,1-10.817,15.892,14.164,14.164,0,0,0,12.333-13.316,13.053,13.053,0,0,0-1.756-7.292",
    transform: "translate(175.204 78.665)",
    fill: "#81858d"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29064",
    "data-name": "Path 29064",
    d: "M521.879,241.1a17.965,17.965,0,0,1,12.411-5.14,16.7,16.7,0,0,1,3.977.506,12.286,12.286,0,0,0-10.32-5.516,14.1,14.1,0,0,0-13.8,13.4,12.969,12.969,0,0,0,2.2,7.98,18.773,18.773,0,0,1,5.531-11.234",
    transform: "translate(171.714 77.134)",
    fill: "#cad2de"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29065",
    "data-name": "Path 29065",
    d: "M531.234,242.479a5.517,5.517,0,0,0-5.5-5.918,6.225,6.225,0,0,0-6.091,5.918,5.517,5.517,0,0,0,5.5,5.918,6.226,6.226,0,0,0,6.091-5.918",
    transform: "translate(173.552 79.009)",
    fill: "#4d545a"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29066",
    "data-name": "Path 29066",
    d: "M530.416,242.311a4.9,4.9,0,0,0-4.878-5.249,5.524,5.524,0,0,0-5.4,5.249,4.894,4.894,0,0,0,4.878,5.249,5.523,5.523,0,0,0,5.4-5.249",
    transform: "translate(173.716 79.176)",
    fill: "#555d63"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29067",
    "data-name": "Path 29067",
    d: "M529.893,242.2a4.5,4.5,0,0,0-4.481-4.822,5.074,5.074,0,0,0-4.965,4.822,4.5,4.5,0,0,0,4.482,4.822,5.076,5.076,0,0,0,4.964-4.822",
    transform: "translate(173.821 79.283)",
    fill: "#4d545a"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29068",
    "data-name": "Path 29068",
    d: "M531.912,241.3a2.283,2.283,0,0,0,.947-2.98,2.05,2.05,0,0,0-2.877-.815,2.283,2.283,0,0,0-.947,2.98,2.05,2.05,0,0,0,2.877.815",
    transform: "translate(176.614 79.227)",
    fill: "#4d545a"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29069",
    "data-name": "Path 29069",
    d: "M531.768,241.214a2.034,2.034,0,0,0,.73-2.685,1.828,1.828,0,0,0-2.525-.843,2.033,2.033,0,0,0-.729,2.685,1.826,1.826,0,0,0,2.524.843",
    transform: "translate(176.684 79.309)",
    fill: "#3b4045"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29070",
    "data-name": "Path 29070",
    d: "M527.015,234.474a2.038,2.038,0,0,0-2.03-2.185,2.3,2.3,0,0,0-2.249,2.185,2.037,2.037,0,0,0,2.03,2.185,2.3,2.3,0,0,0,2.249-2.185",
    transform: "translate(174.587 77.582)",
    fill: "#4d545a"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29071",
    "data-name": "Path 29071",
    d: "M525.64,236.335a2.035,2.035,0,0,0,.73-2.685,1.828,1.828,0,0,0-2.525-.843,2.033,2.033,0,0,0-.728,2.685,1.826,1.826,0,0,0,2.524.843",
    transform: "translate(174.637 77.679)",
    fill: "#3b4045"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29072",
    "data-name": "Path 29072",
    d: "M517.151,237.585a2.287,2.287,0,0,0-.991,2.968,2.047,2.047,0,0,0,2.863.859,2.285,2.285,0,0,0,.991-2.967,2.049,2.049,0,0,0-2.863-.86",
    transform: "translate(172.319 79.26)",
    fill: "#4d545a"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29073",
    "data-name": "Path 29073",
    d: "M518.9,241.412a2.035,2.035,0,0,0,.73-2.685,1.828,1.828,0,0,0-2.525-.843,2.033,2.033,0,0,0-.728,2.685,1.826,1.826,0,0,0,2.524.843",
    transform: "translate(172.387 79.375)",
    fill: "#3b4045"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29074",
    "data-name": "Path 29074",
    d: "M518.123,247.838a2.038,2.038,0,0,0,2.765,1.117,2.3,2.3,0,0,0,1.238-2.881,2.037,2.037,0,0,0-2.765-1.117,2.3,2.3,0,0,0-1.238,2.881",
    transform: "translate(173 81.75)",
    fill: "#4d545a"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29075",
    "data-name": "Path 29075",
    d: "M521.688,248.219a1.935,1.935,0,0,0-.423-2.693,1.914,1.914,0,0,0-2.693.328,1.935,1.935,0,0,0,.423,2.693,1.911,1.911,0,0,0,2.693-.328",
    transform: "translate(173.073 81.867)",
    fill: "#3b4045"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29076",
    "data-name": "Path 29076",
    d: "M527.4,249a2.178,2.178,0,0,0,2.97-.77,2.153,2.153,0,0,0-.6-2.992,2.177,2.177,0,0,0-2.968.77,2.152,2.152,0,0,0,.6,2.992",
    transform: "translate(175.826 81.805)",
    fill: "#4d545a"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29077",
    "data-name": "Path 29077",
    d: "M529.406,248.979a2.035,2.035,0,0,0,.73-2.685,1.827,1.827,0,0,0-2.524-.843,2.032,2.032,0,0,0-.73,2.685,1.827,1.827,0,0,0,2.524.843",
    transform: "translate(175.895 81.902)",
    fill: "#3b4045"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29078",
    "data-name": "Path 29078",
    d: "M527,245.792a4.308,4.308,0,0,0,1.545-5.689,3.868,3.868,0,0,0-5.348-1.788A4.309,4.309,0,0,0,521.655,244,3.87,3.87,0,0,0,527,245.792",
    transform: "translate(174.063 79.434)",
    fill: "#3b4045"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10632",
    "data-name": "Group 10632",
    transform: "translate(693.553 316.071)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10631",
    "data-name": "Group 10631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29079",
    "data-name": "Path 29079",
    d: "M522.323,241.019c2.791-1.266,4.638,2.5,8.455,1.259-.255-4.986-3.979-5.341-5.161-5.341a5.83,5.83,0,0,0-5.7,5.543,5.546,5.546,0,0,0,.037.776,5.749,5.749,0,0,1,2.373-2.237",
    transform: "translate(-519.909 -236.937)",
    fill: "#252629"
  }))))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29080",
    "data-name": "Path 29080",
    d: "M579.752,251.611a46.676,46.676,0,0,0-30.586-41.8c-15.892-5.876-33.2-2.9-46.392,5.677,13.7-10.332,31.65-14.047,47.874-8.232,19.043,6.837,29.853,24.911,29.1,44.354",
    transform: "translate(167.921 68.303)",
    fill: "#d5deeb"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29081",
    "data-name": "Path 29081",
    d: "M210.145,280.36c15.853-33.7.384-71.376-33.933-83.426-33.434-11.74-71.654,5.607-85.96,38.072C78.889,260.795,85.724,289,105.336,305.753c4.821,4.118,8.392,7.57,14.7,10.129,9.092,2.269,17.355,2.459,25.147,2.62,8.345.173,17.04.183,24.507-1.892a70.5,70.5,0,0,0,40.457-36.25",
    transform: "translate(28.307 64.545)",
    fill: "#36393b"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29082",
    "data-name": "Path 29082",
    d: "M143.445,270.729c13.057-5.681,25.108-12.045,36.218-20.677,9.731-7.562,19.563-16.295,30.723-22.965a59.38,59.38,0,0,0-34.174-30.155c-33.434-11.74-71.655,5.608-85.961,38.073-10.156,23.046-5.752,47.96,9.242,64.943,13.428-10.767,26.867-21.785,43.952-29.22",
    transform: "translate(28.308 64.545)",
    fill: "#272a2b"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29083",
    "data-name": "Path 29083",
    d: "M148.735,203.015c-27.5,0-50.942,22.694-52.343,50.669s19.772,50.668,47.271,50.668c27.515,0,50.944-22.679,52.344-50.668s-19.758-50.669-47.273-50.669m-.251,52.969-.819.488-.967.275h-.946l-.82-.229-.774-.436-.642-.652-.47-.888-.2-.915.049-1,.276-.878.436-.764.726-.751.822-.487.963-.276h.947l.82.229.774.436.642.652.471.888.2.915-.049,1-.276.878-.438.764Zm42-1.119a46.821,46.821,0,0,1-1.275,7.839l-34.677-8.75Zm-36.366-3.106,35.621-9.235a44.853,44.853,0,0,1,.879,8.313ZM188.8,238.687,154,249.55l31.981-18a42.907,42.907,0,0,1,2.819,7.134m-4.726-10.528-31.6,19.819,26.605-26.272a41.822,41.822,0,0,1,4.99,6.453m-7.732-9.13-25.055,27.157,19.009-31.612a41.584,41.584,0,0,1,6.046,4.454m-26.019,24.5L161.539,210.6a41.174,41.174,0,0,1,5.393,2.148Zm7.518-33.926-10.2,35.241,2.68-36.238a42.9,42.9,0,0,1,7.517,1m-12.35,35.557L138.529,209.7a44.482,44.482,0,0,1,7.915-1.089Zm-10.765-34.413,8.634,34.812-15.844-31.793a46.234,46.234,0,0,1,7.21-3.019m7,36.414-24.461-26.144a48.266,48.266,0,0,1,6.781-5.241Zm-27.34-23.267,25.464,24.532L109.48,230.214a48.349,48.349,0,0,1,4.906-6.323M137.4,249.659,104.761,239.6a48.149,48.149,0,0,1,2.644-5.867Zm-33.9-6.168,34.778,8.775-36.267-.919a46.718,46.718,0,0,1,1.489-7.856m35.191,10.969-36.212,9.389a45.434,45.434,0,0,1-.686-8.456Zm-35.349,13.283,35.483-11.076-32.751,18.449a42.812,42.812,0,0,1-2.732-7.373m4.6,10.82,32.4-20.323-27.377,27.035a41.991,41.991,0,0,1-5.022-6.711m7.768,9.461,25.822-27.991L121.9,292.676a41.433,41.433,0,0,1-6.192-4.653m26.786-25.33-11.616,34.093a41.41,41.41,0,0,1-5.579-2.236Zm-7.857,35.1,10.537-36.418-2.768,37.409a42.925,42.925,0,0,1-7.769-.991m12.69-36.734,7.16,36.482a44.481,44.481,0,0,1-8.144,1.215Zm11,35.364-8.868-35.762L165.676,293.2a46.217,46.217,0,0,1-7.346,3.223m10.817-5.312L151.09,259.06l24.85,26.56a47.869,47.869,0,0,1-6.793,5.495m9.623-8.46-25.8-24.858,30.6,18.346a48.878,48.878,0,0,1-4.8,6.511M155.415,256.56l32.647,10.058a47.9,47.9,0,0,1-2.5,5.946Z",
    transform: "translate(32.172 67.805)",
    fill: "#b1b8c2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29084",
    "data-name": "Path 29084",
    d: "M184.6,254.266a65.1,65.1,0,0,1-9.917,7.238,49.412,49.412,0,0,1-3.172,4.1l-1.641-1.579q-1.907.9-3.889,1.662l2.7,2.884a47.786,47.786,0,0,1-6.793,5.493l-3.383-6.006c-.966.243-1.928.491-2.924.7l-.77.161,3.606,7.237a46.325,46.325,0,0,1-7.346,3.222l-2.273-9.17q-1.709.38-3.432.8l1.864,9.491a44.593,44.593,0,0,1-8.144,1.217l.237-9.1q-1.8.534-3.583,1.143l-.591,7.979a42.824,42.824,0,0,1-7.769-.991l1.175-4.061a48.784,48.784,0,0,0-4.8,2.647l-.137.4c-.112-.035-.219-.081-.329-.117a39.018,39.018,0,0,0-5.237,4.033,47.463,47.463,0,0,0,18.35,3.651c21.5,0,40.492-13.851,48.442-33.256-.081.073-.164.144-.247.216",
    transform: "translate(39.429 84.85)",
    fill: "#8e939c"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29085",
    "data-name": "Path 29085",
    d: "M102.288,262.582a44.935,44.935,0,0,1-.494-7.19l6.994-.177c1.2-1.218,2.421-2.424,3.675-3.6l-10.449-.264a46.468,46.468,0,0,1,1.489-7.857l14.127,3.564q1.569-1.295,3.19-2.505L104.761,239.6a47.853,47.853,0,0,1,2.643-5.867l16.387,8.7c.968-.651,1.946-1.282,2.943-1.876l-17.254-10.344a48.172,48.172,0,0,1,4.906-6.323l15.5,14.93q1.379-.71,2.795-1.333l-15.413-16.475a48.173,48.173,0,0,1,6.779-5.241l11.571,20.538q1.331-.484,2.693-.882l-10.8-21.667a46.241,46.241,0,0,1,7.21-3.019l5.966,24.054c.879-.2,1.766-.382,2.665-.523l-4.825-24.58a44.494,44.494,0,0,1,7.915-1.089l-.663,25.379c.883-.083,1.776-.125,2.673-.148l1.868-25.235a42.769,42.769,0,0,1,7.517,1l-7.015,24.241c.915.029,1.833.076,2.748.144l7.968-23.385a41.265,41.265,0,0,1,5.395,2.148l-11.542,21.384q1.485.134,2.971.284l11.931-19.84a41.481,41.481,0,0,1,6.046,4.453l-14.5,15.712q1.913.158,3.825.211l13.412-13.245a41.827,41.827,0,0,1,4.992,6.452l-8.4,5.268a63.065,63.065,0,0,0,8.83-4.612c1.586-.944,3.163-1.92,4.734-2.911a46.725,46.725,0,0,0-40.5-22.89c-27.5,0-50.944,22.694-52.344,50.669a50.53,50.53,0,0,0,1.471,15c1.4-2.074,2.863-4.114,4.425-6.106",
    transform: "translate(32.172 67.804)",
    fill: "#cad2de"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29086",
    "data-name": "Path 29086",
    d: "M144.777,208.331l.839.235L139.6,226.219Z",
    transform: "translate(46.625 69.58)",
    fill: "#b1b8c2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29087",
    "data-name": "Path 29087",
    d: "M151.681,245.35l17.543,4.426-.28.892Z",
    transform: "translate(50.66 81.944)",
    fill: "#cad2de"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29088",
    "data-name": "Path 29088",
    d: "M123.628,277.047l6.015-17.653-5.176,17.887Z",
    transform: "translate(41.29 86.635)",
    fill: "#cad2de"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29089",
    "data-name": "Path 29089",
    d: "M102.907,232.69l.28-.892,17.263,5.319Z",
    transform: "translate(34.37 77.418)",
    fill: "#b1b8c2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29090",
    "data-name": "Path 29090",
    d: "M160.125,215.959l.612.622L147.4,229.75Z",
    transform: "translate(49.23 72.128)",
    fill: "#b1b8c2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29091",
    "data-name": "Path 29091",
    d: "M146.958,253.569l12.93,12.454-.65.671Z",
    transform: "translate(49.082 84.689)",
    fill: "#cad2de"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29092",
    "data-name": "Path 29092",
    d: "M110.339,268.007l13.336-13.169-12.724,13.791Z",
    transform: "translate(36.852 85.113)",
    fill: "#cad2de"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29093",
    "data-name": "Path 29093",
    d: "M111.087,218.4l.65-.671,12.277,13.122Z",
    transform: "translate(37.102 72.718)",
    fill: "#b1b8c2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29094",
    "data-name": "Path 29094",
    d: "M169.807,231.017l.2.884-17.87,4.632Z",
    transform: "translate(50.811 77.157)",
    fill: "#cad2de"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29095",
    "data-name": "Path 29095",
    d: "M138.193,259.163l4.381,17.665-.866.247Z",
    transform: "translate(46.155 86.557)",
    fill: "#cad2de"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29096",
    "data-name": "Path 29096",
    d: "M102.208,250.615l17.878-4.634L102.4,251.5Z",
    transform: "translate(34.136 82.155)",
    fill: "#cad2de"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29097",
    "data-name": "Path 29097",
    d: "M126.261,208.792l.864-.248,3.516,17.911Z",
    transform: "translate(42.17 69.651)",
    fill: "#b1b8c2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29098",
    "data-name": "Path 29098",
    d: "M173.566,278.628c-14.128,10.547-32.9,14.071-49.314,7.6-18.336-7.218-28.706-24.906-27.942-43.755.666,17.17,11.584,33.408,29.577,40.641a52.705,52.705,0,0,0,47.678-4.486",
    transform: "translate(32.154 80.983)",
    fill: "#81858d"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29099",
    "data-name": "Path 29099",
    d: "M170.378,203.827C143.045,194.125,109.6,209.8,97.8,236.4c-11.652,26.31,1.449,57.3,27.76,67.853,26.861,10.761,57.58-3.666,70.268-30.766,12.822-27.416,2.467-59.731-25.447-69.656m20.84,68.04c-11.5,24.733-41.228,37.073-65.818,27.344-24.213-9.566-34.634-37.073-23.841-61.259,10.881-24.385,40.114-38.24,65.037-29.241,25.319,9.144,36.214,38.185,24.621,63.156",
    transform: "translate(31.234 67.11)",
    fill: "#4f4f4e"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29100",
    "data-name": "Path 29100",
    d: "M110.227,294.573q1.515-1.261,3.032-2.517c-15.239-12.634-20.465-34.465-11.7-54.1,10.881-24.387,40.114-38.241,65.037-29.242a43.542,43.542,0,0,1,22.216,17.814q2.469-2,5.009-3.921a45.1,45.1,0,0,0-23.443-18.776c-27.333-9.7-60.781,5.974-72.582,32.567-9.086,20.519-3.116,43.88,12.431,58.179",
    transform: "translate(31.234 67.11)",
    fill: "#454544"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29101",
    "data-name": "Path 29101",
    d: "M150.13,244.353a12.5,12.5,0,0,0-12.455-13.4,14.1,14.1,0,0,0-13.8,13.4,12.5,12.5,0,0,0,12.455,13.4,14.1,14.1,0,0,0,13.8-13.4",
    transform: "translate(41.368 77.134)",
    fill: "#b1b8c2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29102",
    "data-name": "Path 29102",
    d: "M144.885,235.532a17.411,17.411,0,0,1,.24,4.716,19.144,19.144,0,0,1-10.817,15.892,14.164,14.164,0,0,0,12.333-13.316,13.053,13.053,0,0,0-1.756-7.292",
    transform: "translate(44.857 78.665)",
    fill: "#81858d"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29103",
    "data-name": "Path 29103",
    d: "M131.606,241.1a17.965,17.965,0,0,1,12.411-5.14,16.7,16.7,0,0,1,3.977.506,12.288,12.288,0,0,0-10.321-5.516,14.1,14.1,0,0,0-13.8,13.4,12.962,12.962,0,0,0,2.2,7.98,18.773,18.773,0,0,1,5.531-11.234",
    transform: "translate(41.368 77.134)",
    fill: "#cad2de"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29104",
    "data-name": "Path 29104",
    d: "M140.961,242.479a5.517,5.517,0,0,0-5.5-5.918,6.225,6.225,0,0,0-6.091,5.918,5.517,5.517,0,0,0,5.5,5.918,6.226,6.226,0,0,0,6.091-5.918",
    transform: "translate(43.206 79.009)",
    fill: "#4d545a"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29105",
    "data-name": "Path 29105",
    d: "M140.143,242.311a4.9,4.9,0,0,0-4.878-5.249,5.524,5.524,0,0,0-5.4,5.249,4.9,4.9,0,0,0,4.878,5.249,5.524,5.524,0,0,0,5.4-5.249",
    transform: "translate(43.37 79.176)",
    fill: "#555d63"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29106",
    "data-name": "Path 29106",
    d: "M139.619,242.2a4.5,4.5,0,0,0-4.481-4.822,5.074,5.074,0,0,0-4.964,4.822,4.5,4.5,0,0,0,4.481,4.822,5.074,5.074,0,0,0,4.964-4.822",
    transform: "translate(43.475 79.283)",
    fill: "#4d545a"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29107",
    "data-name": "Path 29107",
    d: "M141.64,241.3a2.283,2.283,0,0,0,.947-2.98,2.051,2.051,0,0,0-2.877-.815,2.285,2.285,0,0,0-.948,2.98,2.052,2.052,0,0,0,2.879.815",
    transform: "translate(46.268 79.227)",
    fill: "#4d545a"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29108",
    "data-name": "Path 29108",
    d: "M141.5,241.214a2.033,2.033,0,0,0,.728-2.685,1.826,1.826,0,0,0-2.524-.843,2.033,2.033,0,0,0-.728,2.685,1.826,1.826,0,0,0,2.524.843",
    transform: "translate(46.338 79.309)",
    fill: "#3b4045"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29109",
    "data-name": "Path 29109",
    d: "M136.743,234.474a2.038,2.038,0,0,0-2.03-2.185,2.3,2.3,0,0,0-2.249,2.185,2.037,2.037,0,0,0,2.03,2.185,2.3,2.3,0,0,0,2.249-2.185",
    transform: "translate(44.24 77.582)",
    fill: "#4d545a"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29110",
    "data-name": "Path 29110",
    d: "M135.367,236.335a2.034,2.034,0,0,0,.73-2.685,1.828,1.828,0,0,0-2.525-.843,2.033,2.033,0,0,0-.728,2.685,1.826,1.826,0,0,0,2.524.843",
    transform: "translate(44.291 77.679)",
    fill: "#3b4045"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29111",
    "data-name": "Path 29111",
    d: "M126.878,237.585a2.287,2.287,0,0,0-.991,2.968,2.047,2.047,0,0,0,2.863.859,2.285,2.285,0,0,0,.991-2.967,2.049,2.049,0,0,0-2.863-.86",
    transform: "translate(41.973 79.26)",
    fill: "#4d545a"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29112",
    "data-name": "Path 29112",
    d: "M128.631,241.412a2.033,2.033,0,0,0,.728-2.685,1.826,1.826,0,0,0-2.524-.843,2.033,2.033,0,0,0-.728,2.685,1.826,1.826,0,0,0,2.524.843",
    transform: "translate(42.041 79.375)",
    fill: "#3b4045"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29113",
    "data-name": "Path 29113",
    d: "M127.85,247.838a2.037,2.037,0,0,0,2.765,1.117,2.3,2.3,0,0,0,1.238-2.881,2.038,2.038,0,0,0-2.765-1.117,2.3,2.3,0,0,0-1.238,2.881",
    transform: "translate(42.653 81.75)",
    fill: "#4d545a"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29114",
    "data-name": "Path 29114",
    d: "M131.416,248.219a1.935,1.935,0,0,0-.423-2.693,1.914,1.914,0,0,0-2.693.328,1.935,1.935,0,0,0,.423,2.693,1.911,1.911,0,0,0,2.693-.328",
    transform: "translate(42.727 81.867)",
    fill: "#3b4045"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29115",
    "data-name": "Path 29115",
    d: "M137.132,249a2.178,2.178,0,0,0,2.969-.77,2.153,2.153,0,0,0-.6-2.992,2.177,2.177,0,0,0-2.968.77,2.152,2.152,0,0,0,.6,2.992",
    transform: "translate(45.48 81.805)",
    fill: "#4d545a"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29116",
    "data-name": "Path 29116",
    d: "M139.134,248.979a2.033,2.033,0,0,0,.728-2.685,1.826,1.826,0,0,0-2.524-.843,2.033,2.033,0,0,0-.728,2.685,1.826,1.826,0,0,0,2.524.843",
    transform: "translate(45.549 81.902)",
    fill: "#3b4045"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29117",
    "data-name": "Path 29117",
    d: "M136.731,245.792a4.308,4.308,0,0,0,1.545-5.689,3.868,3.868,0,0,0-5.348-1.788A4.307,4.307,0,0,0,131.383,244a3.868,3.868,0,0,0,5.348,1.788",
    transform: "translate(43.716 79.434)",
    fill: "#3b4045"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10635",
    "data-name": "Group 10635",
    transform: "translate(172.934 316.071)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10634",
    "data-name": "Group 10634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10633",
    "data-name": "Group 10633",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29118",
    "data-name": "Path 29118",
    d: "M132.051,241.019c2.791-1.266,4.638,2.5,8.455,1.259-.255-4.986-3.979-5.341-5.161-5.341a5.831,5.831,0,0,0-5.7,5.543,5.539,5.539,0,0,0,.037.776,5.75,5.75,0,0,1,2.373-2.237",
    transform: "translate(-129.637 -236.937)",
    fill: "#252629"
  }))))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29119",
    "data-name": "Path 29119",
    d: "M189.479,251.611a46.676,46.676,0,0,0-30.586-41.8c-15.892-5.876-33.2-2.9-46.392,5.677,13.7-10.332,31.65-14.047,47.874-8.232,19.043,6.837,29.853,24.911,29.1,44.354",
    transform: "translate(37.574 68.303)",
    fill: "#d5deeb"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29120",
    "data-name": "Path 29120",
    d: "M55.975,267.286l-54.726.59C.567,267.884,0,267.665,0,267.4l.183-14.486c0-.271.587-.482,1.275-.462L56.2,254.086c.64.019,1.138.229,1.135.48l-.155,12.241c0,.261-.532.472-1.2.479",
    transform: "translate(0 84.315)",
    fill: "#b1b8c2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29121",
    "data-name": "Path 29121",
    d: "M27.214,254.038c20.227.631,20.98,2.94,29.192,7.3l.087-6.786c0-.249-.495-.46-1.135-.479L2.509,252.492s4.577.918,24.705,1.546",
    transform: "translate(0.838 84.329)",
    fill: "#cad2de"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29122",
    "data-name": "Path 29122",
    d: "M56.082,265.448c-22.532-1-44.937-1.241-55.949-9.7L0,266.295c0,.269.567.488,1.25.48,0,0,53.533-.622,54.726-.612s1.2-.67,1.2-.67c-.359-.016-.74-.029-1.1-.045",
    transform: "translate(0 85.416)",
    fill: "#9398a1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29123",
    "data-name": "Path 29123",
    d: "M470.169,263.945l-7.22,13.328s.052,1.377,1.686.91c3.634-1.041,14.781-14.174,14.781-14.174Z",
    transform: "translate(154.62 88.155)",
    fill: "#272a2b"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29124",
    "data-name": "Path 29124",
    d: "M76.237,267.3,68.4,276.909s-.378,1.213,2.145,1.439,12.841-8.779,12.841-8.779Z",
    transform: "translate(22.837 89.274)",
    fill: "#272a2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10638",
    "data-name": "Group 10638",
    transform: "translate(625.35 246.821)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10637",
    "data-name": "Group 10637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10636",
    "data-name": "Group 10636",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29125",
    "data-name": "Path 29125",
    d: "M609.515,298.461s3.272-37.144-12.393-60.99c-12.293-18.712-27-25.529-59.957-20.6-56.484,8.453-62.591,77.848-66.194,80.654-.562-4.115-10.6-68.2,17.587-89.8s55.058-27.233,83.975-19.235,40.074,30.424,42.616,39.9,3.255,56.108-5.633,70.073",
    transform: "translate(-468.782 -185.025)",
    fill: "#9ea5ad"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10641",
    "data-name": "Group 10641",
    transform: "translate(101.91 248.677)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10640",
    "data-name": "Group 10640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10639",
    "data-name": "Group 10639",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29126",
    "data-name": "Path 29126",
    d: "M216.476,299.036S232.2,214.5,164.108,211.36c-73.52-3.394-79.743,82.4-83.346,85.211-.562-4.117-8.088-34.756-2.006-56.288,8.34-29.529,21.272-46.213,57.3-51.945,30.768-4.9,58.734-2.811,84.83,35.083,11.846,22.259,4.477,61.65-4.411,75.616",
    transform: "translate(-76.395 -186.416)",
    fill: "#9ea5ad"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10644",
    "data-name": "Group 10644",
    transform: "translate(481.794 113.033)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10643",
    "data-name": "Group 10643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10642",
    "data-name": "Group 10642",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29127",
    "data-name": "Path 29127",
    d: "M371.512,84.733S408.5,100,461.422,130.3c39.539,22.636,57.562,32.519,57.562,32.519s-1.936,2.591-7.309,3.955a55.3,55.3,0,0,1-11.66,1.365L361.167,87.177Z",
    transform: "translate(-361.168 -84.733)",
    fill: "#65b1b8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10647",
    "data-name": "Group 10647",
    transform: "translate(489.384 113.772)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10646",
    "data-name": "Group 10646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10645",
    "data-name": "Group 10645",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29128",
    "data-name": "Path 29128",
    d: "M430.733,118.17c-14.164-8.544-52.024-28.908-62.725-32.883-.02.036-1.13.494-1.15.53,11.663,5.048,44.067,23.976,61.738,33.915,24.8,13.945,80.732,46.963,80.732,46.963s2.643-.063,3.51-.851a5.01,5.01,0,0,0,1.085-1.225s-65.683-35.89-83.189-46.449",
    transform: "translate(-366.858 -85.287)",
    fill: "#151f21"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10650",
    "data-name": "Group 10650",
    transform: "translate(528.558 138.923)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10649",
    "data-name": "Group 10649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10648",
    "data-name": "Group 10648",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29129",
    "data-name": "Path 29129",
    d: "M396.224,104.141l95.882,57.343,4.039-.446Z",
    transform: "translate(-396.224 -104.141)",
    fill: "#151f21"
  }))))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29130",
    "data-name": "Path 29130",
    d: "M470.1,147.569s20.334,9.585,35.984,12.79,65.271,4.88,93.649,7.8c48.368,4.981,50.166,15.223,50.994,17.822.948,2.975-71.766,22.732-71.766,22.732s-23.323-8.1-52.123,1.079c-61.151,19.486-51.018,89.025-51.018,89.025l-16.275-1.1s12.4-47.663,13.761-71.139c1.433-24.648-1.182-41.949-3.986-60.979-1.226-8.319-18.58-19.295-18.58-19.295Z",
    transform: "translate(150.542 48.866)",
    fill: "#105b9f"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29131",
    "data-name": "Path 29131",
    d: "M467.084,178.284c27.016-3.067,59.273-6.326,86.292-5.676,84.894,2.038,92.906,7.752,92.544,7.49-7.556-5.452-17.191-7.1-39.581-9.377a1370.856,1370.856,0,0,0-141.207-6.79c.278,1.9,1.561,10.991,1.952,14.352",
    transform: "translate(155.349 54.751)",
    fill: "#115ea9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29132",
    "data-name": "Path 29132",
    d: "M632.817,299.826c-12.133,1.1-49.375,1.222-49.375,1.222s5.687-27.019,4.615-50.928a49.709,49.709,0,0,0-7.3-23.925c-.256-.438-.527-.86-.8-1.267-.259-.423-.529-.815-.815-1.222s-.544-.815-.846-1.207c-.844-1.177-1.734-2.308-2.655-3.394-.287-.363-.588-.724-.921-1.071-.287-.363-.6-.71-.919-1.04h-.017a78.6,78.6,0,0,0-26.927-18.616l25.254-21.1s52.958,28.2,56.517,29.78c3.959,1.762,5.356,2.106,8.6,4.106a11.319,11.319,0,0,1,4.251,5.592,22.637,22.637,0,0,1,.6,3.334c.632,5.385.691,11.558,1.7,19.068,1.071,8,2.867,23.818,2.867,23.818s-5.06,27.856-5.06,29.531c1,1.106,9.515,5.665-8.774,7.324",
    transform: "translate(182.645 59.207)",
    fill: "#105ba1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10653",
    "data-name": "Group 10653",
    transform: "translate(616.548 246.821)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10652",
    "data-name": "Group 10652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10651",
    "data-name": "Group 10651",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29133",
    "data-name": "Path 29133",
    d: "M602.578,215.093c3.474-.051,7-.3,10.549-.559-8.894-12.958-27.051-29.5-61.794-29.509-51.805-.007-72.336,34.118-76.2,41.933-13.7,27.688-12.941,58.934-12.941,58.934H472s-10.134-69.539,51.018-89.026c22.95-7.312,47.37-6.758,67.444,7.417a70.163,70.163,0,0,1,12.118,10.811",
    transform: "translate(-462.184 -185.025)",
    fill: "#fff"
  }))))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29134",
    "data-name": "Path 29134",
    d: "M635.345,210.2c-5.763-.316-24.265,1.071-61.329,6.11H574c-.256-.423-.527-.844-.783-1.267q-.408-.61-.815-1.222c-.287-.407-.558-.8-.846-1.207-.86-1.177-1.75-2.308-2.655-3.394-.3-.362-.618-.724-.92-1.071s-.619-.694-.935-1.041h.016c13.7.2,58.3-.211,67.679-.241a22.629,22.629,0,0,1,.6,3.334",
    transform: "translate(189.387 69.091)",
    fill: "#1160aa"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29135",
    "data-name": "Path 29135",
    d: "M598.137,205.783c26.294,12.833,27.179,5.256,25.551,2.765-2.137-3.268-14.609-5.531-29.853-13.325a171.2,171.2,0,0,1-28.681-19.209c1.837,6.378,9.287,18.2,32.983,29.769",
    transform: "translate(188.755 58.787)",
    fill: "#115ea6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29136",
    "data-name": "Path 29136",
    d: "M645.879,187.263s-.674-5.239-7.462-11.236-39.533-12.318-75.668-18.333c-25.643-4.269-51.531-8.468-66.746-11.551a100.955,100.955,0,0,1-13.471-3.662,3.993,3.993,0,0,1-1.661,3.09c-6.318,3.866-15.62,3.278-15.62,3.278s21.477,13.172,41.735,15.934c3.837.524,47.142,3.867,111.065,9.773,24.723,2.284,27.827,12.708,27.827,12.708",
    transform: "translate(155.389 47.587)",
    fill: "#1160a9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29137",
    "data-name": "Path 29137",
    d: "M632.057,244.269c.195-.053,4.953-1.869,4.953-1.869l-.409-3.539c-20.317,2.23-46.491,6.934-58.624,11.092a165.068,165.068,0,0,1-2.246,19.7c2.488-2.771,32.9-18.873,56.326-25.386",
    transform: "translate(192.287 79.777)",
    fill: "#1160aa"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29138",
    "data-name": "Path 29138",
    d: "M576.216,261.945c-.732,4.988-1.936,10.825-1.936,10.825s37.258-.081,49.379-1.226c15.5-1.463,12.954-4.23,8.775-7.32.4,1.107,2.486,2.883-5.54,2.9-10.624.021-39.141-1.157-50.678-5.179",
    transform: "translate(191.803 87.487)",
    fill: "#0f5292"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29139",
    "data-name": "Path 29139",
    d: "M465.252,148.848a83.065,83.065,0,0,0,13.5.956c8.395,0,16.265-1.325,12.964-3.662-2.216-1.569-9.182-3.662-9.182-3.662s.627,2.377-3.735,3.931a45.373,45.373,0,0,1-13.545,2.436",
    transform: "translate(155.389 47.587)",
    fill: "#0e4d89"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29140",
    "data-name": "Path 29140",
    d: "M181.729,153.871l183.716,5.235s12,42.644,10.028,80.418-9.114,57.442-9.114,57.442l-169.152,5.551s7.632-48.923-5-66.333-25.292-35.759-25.725-52.043c-.507-19.076,15.25-30.27,15.25-30.27",
    transform: "translate(55.598 51.391)",
    fill: "#1160a9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29141",
    "data-name": "Path 29141",
    d: "M277.683,193.1c-36.234,2.33-72.506,3.933-108.792,5.164,6.917,12.519,16.7,25.8,24.116,36.012,12.634,17.41,3.388,57.688,3.388,57.688l169.152-5.551s7.14-19.667,9.114-57.442c.768-14.7-.583-30.136-2.519-43.512-31.469,2.8-62.935,5.612-94.46,7.64",
    transform: "translate(56.408 61.942)",
    fill: "#105ba1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29142",
    "data-name": "Path 29142",
    d: "M277.051,170.376c27.464.448,62.583-.3,90.046,0-1.575-7.007-2.772-11.272-2.772-11.272l-183.716-5.233a74.706,74.706,0,0,0-10.787,11.53c32.588,5.122,76.3,4.471,107.229,4.976",
    transform: "translate(56.719 51.391)",
    fill: "#1160aa"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29143",
    "data-name": "Path 29143",
    d: "M185.432,216.019c3.614-2.627,174.246,30.54,187.2,32.827.35-2.785.682-5.723.979-8.839-30.846-5.1-61.469-11.328-92.045-18.286-24.1-5.484-48.144-11.207-72.209-16.839-13.344-3.123-26.808-7.4-40.449-9.8,3.671,6.642,8.149,13.485,12.652,19.983,1.3.3,2.584.634,3.875.955",
    transform: "translate(56.412 65.155)",
    fill: "#1160a9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29144",
    "data-name": "Path 29144",
    d: "M220.889,168.914c-1.314-1.246-12.07-1.9-16.846-2.1-4.794-.2-13.844.164-14.612.588s-1.547,5.919,2.823,5.632c4.354-.287,24.759-.484,26.9-1.515s3.044-1.361,1.732-2.607",
    transform: "translate(63.068 55.696)",
    fill: "#1160ab"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29145",
    "data-name": "Path 29145",
    d: "M205.733,169.99c4.906-1.052,10.241-.658,15.119-1.51,1.086,1.125.193,1.481-1.86,2.467-2.145,1.03-22.55,1.23-26.9,1.515a2.9,2.9,0,0,1-2.765-1.126,74.8,74.8,0,0,0,16.409-1.346",
    transform: "translate(63.232 56.27)",
    fill: "#1160a9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29146",
    "data-name": "Path 29146",
    d: "M315.367,157.791l197.328,3.568s4.588,2.465,6.569,15.361,2.082,68.9-3.951,85.134-10.492,32.293-10.492,32.293l-189.106-.289s10.909-34.606,9.311-70.476c-.783-17.559-9.658-65.591-9.658-65.591",
    transform: "translate(105.329 52.7)",
    fill: "#115ea9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29147",
    "data-name": "Path 29147",
    d: "M377.62,184.429c-18.707,1.489-37.4,3.148-56.093,4.809,1.68,11.039,3.116,21.94,3.41,28.539,1.6,35.868-9.31,70.475-9.31,70.475l189.1.289s4.46-16.063,10.493-32.293c5.6-15.058,5.912-64.33,4.348-81.672q-71.021,4.256-141.952,9.853",
    transform: "translate(105.416 58.306)",
    fill: "#105ba1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29148",
    "data-name": "Path 29148",
    d: "M419.933,248.36c29.477,2.08,58.966,3.608,88.481,4.285.718-2.188-87.551-11.021-132.249-16.269q-27.189-3.192-54.085-7.705c-.332,3.039-.718,5.971-1.134,8.8,10.077,1.79,76.095,9.275,98.987,10.891",
    transform: "translate(107.192 76.373)",
    fill: "#1160aa"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29149",
    "data-name": "Path 29149",
    d: "M342.319,169.49c15.266.4,131.586-1.437,172.833-3.506-.335-2.28-.619-4.21-.619-4.21l-199.166-3.983s.834,4.514,2.009,11.263c8.315.085,16.63.216,24.943.436",
    transform: "translate(105.329 52.7)",
    fill: "#1160aa"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29150",
    "data-name": "Path 29150",
    d: "M444.812,140.957l-9.394,25.384,35.964,1.728s-2.876-7.342-12.069-15.632c-4.482-4.042-14.5-11.48-14.5-11.48",
    transform: "translate(145.424 47.078)",
    fill: "#0b3e6f"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29151",
    "data-name": "Path 29151",
    d: "M359.647,168.914c-1.314-1.246-12.07-1.9-16.846-2.1-4.794-.2-13.844.164-14.613.588s-1.547,5.919,2.823,5.632c4.354-.287,24.759-.484,26.9-1.515s3.044-1.361,1.731-2.607",
    transform: "translate(109.411 55.696)",
    fill: "#1160ab"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29152",
    "data-name": "Path 29152",
    d: "M344.491,169.99c4.906-1.052,10.241-.658,15.119-1.51,1.086,1.125.193,1.481-1.86,2.467-2.145,1.03-22.55,1.23-26.9,1.515a2.9,2.9,0,0,1-2.765-1.126,74.8,74.8,0,0,0,16.409-1.346",
    transform: "translate(109.576 56.27)",
    fill: "#1160a9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29153",
    "data-name": "Path 29153",
    d: "M19.145,303.137A21.686,21.686,0,0,1,3.022,284.269c-1.012-10.132.908-56.9,3.17-70.469,1.077-6.462,9.435-5.437,11.631-11.527C24.412,184,31.436,157.74,42.839,151.01c4.778-1.746,11.025,1.746,15.84.376,27.866-7.924,97.889-16.5,97.889-16.5l39.689,16.631,39.579,8.295s-11.323,9.478-12.6,30.486c-.924,15.189,17.735,35.643,20.948,40.92,18.149,29.821,11.934,56.408,11.934,56.408l-9.426-.344s8.331-24.648-10.389-52.452c-10.049-14.926-27.832-23.629-42.4-25.486-46.812-5.964-69.993,15.538-82.2,38.552s-6.338,65.892-6.338,65.892Z",
    transform: "translate(0.917 45.049)",
    fill: "#115ea9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29154",
    "data-name": "Path 29154",
    d: "M101.672,201.717c-16.107-1.386-36.833-6.947-45.957-14.007-7.274-5.627-10-14.645-11.71-23.56a142.837,142.837,0,0,0-4.122-15.485c-9.7,9.111-16.061,32.367-22.059,49-2.2,6.09-10.556,5.066-11.632,11.528-2.26,13.565-4.181,60.338-3.17,70.468a21.685,21.685,0,0,0,16.123,18.868l86.214,10.647S99.488,266.3,111.7,243.286c7.73-14.57,19.87-28.526,39.61-35.3-12.676-2.5-33.239-4.861-49.635-6.271",
    transform: "translate(0.917 49.653)",
    fill: "#0f5799"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29155",
    "data-name": "Path 29155",
    d: "M46.973,190.485c-10.485-.355-19.97-2.146-30.471-2.913-4,2.316-8.892,3.789-9.7,8.63-1.066,6.392-5.124,19.411-5.767,33.243-.722,15.52,2.062,31.869,2.6,37.225a21.685,21.685,0,0,0,16.123,18.868l86.214,10.647s-5.871-42.878,6.338-65.892c7.863-14.819,20.287-29,40.631-35.636-16.774-1.087-89.248-3.6-105.965-4.17",
    transform: "translate(0.306 62.647)",
    fill: "#105b9f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10656",
    "data-name": "Group 10656",
    transform: "translate(130.739 244.118)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10655",
    "data-name": "Group 10655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10654",
    "data-name": "Group 10654",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29156",
    "data-name": "Path 29156",
    d: "M212.365,215.141c-1.945-3.2-16.792-34.581-70.246-31.99-18.344.888-32.808,6.436-44.112,14.19,5.951.149,11.9.355,17.858.551,12.069-4.917,27.181-7.05,46.219-4.624,14.568,1.857,32.352,10.56,42.4,25.486,18.72,27.8,10.389,52.452,10.389,52.452l9.426.343s6.215-26.586-11.934-56.408",
    transform: "translate(-98.006 -182.999)",
    fill: "#fff"
  }))))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29157",
    "data-name": "Path 29157",
    d: "M73.152,198.34c9.255,1.039,50.066,5.427,59.352,6.051a66.237,66.237,0,0,1,18.96-9.735c-16.774-1.087-84.473-4.488-101.191-5.052-10.485-.355-32.025.3-35.245-2.032-4,2.314-8.882,3.79-9.7,8.618,2.322-6.3,34.134-1.634,67.821,2.15",
    transform: "translate(1.78 62.647)",
    fill: "#1160aa"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29158",
    "data-name": "Path 29158",
    d: "M19.958,247.61C5.483,240.821,2.015,237.035,1.764,237.1c.563,3.821,1.035,8.955,1.586,13.034,1.217,9.014,7.318,16.588,16.123,18.869l86.216,10.645s-1.071-23.8-1.341-30.51c-12.206-3.543-62.563,8.712-84.389-1.525",
    transform: "translate(0.589 79.187)",
    fill: "#0f5292"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10659",
    "data-name": "Group 10659",
    transform: "translate(122.855 210.837)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10658",
    "data-name": "Group 10658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10657",
    "data-name": "Group 10657",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29159",
    "data-name": "Path 29159",
    d: "M127.5,186.132l-29.488-.375a6.1,6.1,0,0,1-5.914-6.539l.68-14.568a6.824,6.824,0,0,1,6.663-6.6l30.137.384a6.045,6.045,0,0,1,5.816,6.757l-1.166,14.561a6.9,6.9,0,0,1-6.73,6.379",
    transform: "translate(-92.096 -158.05)",
    fill: "#fff"
  }))))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29160",
    "data-name": "Path 29160",
    d: "M126.647,185.238l-28.1-.355a5.794,5.794,0,0,1-5.633-6.2l.648-13.8a6.485,6.485,0,0,1,6.348-6.252l28.717.364a5.739,5.739,0,0,1,5.541,6.4l-1.111,13.8a6.559,6.559,0,0,1-6.412,6.044",
    transform: "translate(31.03 52.981)",
    fill: "#105ba1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10662",
    "data-name": "Group 10662",
    transform: "translate(18.563 205.877)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10661",
    "data-name": "Group 10661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10660",
    "data-name": "Group 10660",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29161",
    "data-name": "Path 29161",
    d: "M13.915,196.243s.24,4.892,12.4,1.928S71.769,167.2,71.9,165.412c.148-1.969-1.061-4.017-2.664-6.044a16.658,16.658,0,0,0-6.384-5.034Z",
    transform: "translate(-13.915 -154.332)",
    fill: "#fff"
  }))))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29162",
    "data-name": "Path 29162",
    d: "M28.032,181.5c8.926-9.371,13.805-9.837,28.41-13.184,65.622-15.045,160.293,2.253,167.262,3.915a105.871,105.871,0,0,0,7.963-12.581L194.639,146.6l-42.319-11.719S82.3,143.461,54.431,151.387c-4.814,1.369-11.061-2.124-15.84-.379C28.269,157.1,21.534,179.2,15.464,196.884c3.9-1.523,9.7-12.377,12.568-15.385",
    transform: "translate(5.165 45.049)",
    fill: "#1160aa"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29163",
    "data-name": "Path 29163",
    d: "M444.346,132.991c-31.074-20.77-75.638-42.616-77.258-43.779s7.69-3.543,7.69-3.543-10.362-3.921-15.806-3.731-7.58.91-7.58,4.816v4.584c56.4,14.188,127.78,73.312,132.529,76.478l19.359,1.257s-34.61-19.822-58.934-36.08",
    transform: "translate(117.361 27.364)",
    fill: "#115ea9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29164",
    "data-name": "Path 29164",
    d: "M450.767,147.972s6.414,8.359,6.476,10.8c.044,1.707-1.353,4.59-10.31,4.269-8.4-.3-10.752-.047-10.947-1.078s2.524-10.64,2.524-10.64Z",
    transform: "translate(145.611 49.421)",
    fill: "#0e4f89"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29165",
    "data-name": "Path 29165",
    d: "M420.5,164.548c-2.891,0-2.262-1.3-2.515-3.41s7.277-26.4,18.062-26.837c1.351-.087,19.044,6.566,21.684,20.366s-34.341,9.881-37.232,9.881",
    transform: "translate(139.599 44.855)",
    fill: "#0f5999"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29166",
    "data-name": "Path 29166",
    d: "M437.357,155.339c-8.4-.045-18.983,1.565-17.151-6.861-1.507,3.986-2.309,7.217-2.224,7.927.251,2.109-.378,3.41,2.513,3.41,2.781,0,37.084,3.616,37.348-8.387-3.515,4.281-14.438,3.945-20.486,3.911",
    transform: "translate(139.599 49.59)",
    fill: "#0f5494"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29167",
    "data-name": "Path 29167",
    d: "M455.831,153.948a16.336,16.336,0,0,0-2.329-5.659c-5.676-9.471-18.08-14.06-19.2-13.987-4.321.175-8.117,4.182-11.1,9.055,10.089-7.742,26.369-1.438,32.633,10.591",
    transform: "translate(141.343 44.855)",
    fill: "#105ba1"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29168",
    "data-name": "Path 29168",
    d: "M188.966,240.809s84.707,17.311,177.511,17.283c87.981-.025,198.365-1.543,198.365-1.543l2.109,22.348-154.727-1.774L181.4,280.87Z",
    transform: "translate(60.587 80.427)",
    fill: "#115ea7"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29169",
    "data-name": "Path 29169",
    d: "M187.207,240.809s84.707,17.311,177.511,17.283c87.98-.025,198.365-1.543,198.365-1.543a91.123,91.123,0,0,1-25.962,6.851c-14.035,1.342-180.341-.015-265.956-5.4-73.778-4.64-84.495-14.363-84.495-14.363Z",
    transform: "translate(62.346 80.427)",
    fill: "#1163ac"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29170",
    "data-name": "Path 29170",
    d: "M187.781,266.6c2.294.676,68.986-5.555,163.594-3.056,54.035,1.427,145.618,5.629,185.527,2.416,26.332-2.121,27.94-13.356,27.94-13.356l2.11,22.348s-129.026-1.109-156.7-1.825c-28.12-.727-228.848,3.8-228.848,3.8l4.5-23.892s-.418,12.89,1.877,13.567",
    transform: "translate(60.586 84.368)",
    fill: "#0f5292"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10665",
    "data-name": "Group 10665",
    transform: "translate(14.236 374.833)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10664",
    "data-name": "Group 10664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10663",
    "data-name": "Group 10663",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29171",
    "data-name": "Path 29171",
    d: "M831.319,285.413c0-3.378-234.07-5.149-476.348-4.149-202.732.838-344.3,3.4-344.3,5.844s141.567,4.421,344.3,4.421c242.279,0,476.348-2.739,476.348-6.116",
    transform: "translate(-10.672 -280.987)",
    fill: "#d1dbe6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10668",
    "data-name": "Group 10668",
    transform: "translate(68.855 378.081)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10667",
    "data-name": "Group 10667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10666",
    "data-name": "Group 10666",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29172",
    "data-name": "Path 29172",
    d: "M263.24,286.036c0-1.634-50.9-2.791-110.761-2.592-56.843.188-100.864,1.541-100.864,3.03s44.022,2.659,100.864,2.612c59.856-.048,110.761-1.415,110.761-3.049",
    transform: "translate(-51.616 -283.421)",
    fill: "#d1dbe6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671",
    transform: "translate(512.047 376.145)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10669",
    "data-name": "Group 10669",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29173",
    "data-name": "Path 29173",
    d: "M703.16,285.126c0-2.029-78.061-3.416-168.824-3.115-85.183.283-150.489,1.965-150.489,3.775s65.305,3.222,150.489,3.152c90.763-.075,168.824-1.784,168.824-3.813",
    transform: "translate(-383.847 -281.97)",
    fill: "#d1dbe6"
  }))))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29174",
    "data-name": "Path 29174",
    d: "M381.92,102.955l-2.692,14.112,2.11,4.516,2.868-16.525Z",
    transform: "translate(126.658 34.386)",
    fill: "#778696"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29175",
    "data-name": "Path 29175",
    d: "M381.25,106.392c.007-.367.045-.731.085-1.1l-2.108,10.988,2.112,4.517.037-.195c-.488-2.569-.171-11.559-.127-14.215",
    transform: "translate(126.658 35.168)",
    fill: "#697685"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29176",
    "data-name": "Path 29176",
    d: "M379.521,110.169s3.746,12.674,3.192,12.928a12.97,12.97,0,0,1-4.459-.718c-.177-.221-1.022-12.525-.5-12.629a4.756,4.756,0,0,1,1.764.419",
    transform: "translate(126.11 36.651)",
    fill: "#596470"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29177",
    "data-name": "Path 29177",
    d: "M378.751,118.216c-.048-.484-.428-6.315-.368-8.3-.007-.041-.009-.083-.016-.123a1.615,1.615,0,0,0-.608-.047c-.527.1.319,12.407.5,12.629a14.1,14.1,0,0,0,3.4.727c-1.96-1.1-2.516-1.043-2.9-4.89",
    transform: "translate(126.11 36.651)",
    fill: "#4b545f"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29178",
    "data-name": "Path 29178",
    d: "M615.473,246.12a82.587,82.587,0,0,0-11.743,3.963c-8.156,3.667-11.868,4.193-17.243,7.712,2.945,1.321,22.45,3.57,27.172,2.028s1.814-13.7,1.814-13.7",
    transform: "translate(195.88 82.201)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29179",
    "data-name": "Path 29179",
    d: "M580.869,150.249s3.436,10.673,4.365,13.657a4.2,4.2,0,0,0,1.933,2.236c2.9,1.546,5.729,2.989,5.729,2.989l-22.056-5.356a.863.863,0,0,1,1.177-.967c1.307.312,7.307.592,8.035.224,3.013-1.525-2.573-14.1-2.573-14.1Z",
    transform: "translate(190.653 49.74)",
    fill: "#aab1ba"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29180",
    "data-name": "Path 29180",
    d: "M580.408,164.482c3.935.231,3.192-2.989,1.812-5.724-1.334-2.643-.948-4.629-2.186-5.492l.835-3.348a27.066,27.066,0,0,0,2.219,8.587c1.642,3.543,2.749,6.6,4.079,7.306,2.9,1.546,5.825,2.992,5.825,2.992l-22.152-5.359a3.2,3.2,0,0,1,.044-.447,41.526,41.526,0,0,0,9.525,1.485",
    transform: "translate(190.654 50.071)",
    fill: "#878c94"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29181",
    "data-name": "Path 29181",
    d: "M576.321,157.014l2.916-.24a.59.59,0,0,0,.542-.6l-.317-13.868a.617.617,0,0,0-.6-.6l-3.685-.072a.59.59,0,0,0-.6.638l1.087,14.179a.616.616,0,0,0,.662.567",
    transform: "translate(191.9 47.303)",
    fill: "#b2bdc4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29182",
    "data-name": "Path 29182",
    d: "M576.759,155.411c-1.215-3.052-1.894-11.974-1.808-13.749a.589.589,0,0,0-.379.595l1.087,14.179a.616.616,0,0,0,.662.567l2.625-.216c-1.251-.119-1.849-.524-2.188-1.375",
    transform: "translate(191.9 47.313)",
    fill: "#878c94"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29183",
    "data-name": "Path 29183",
    d: "M579.089,142.3a.618.618,0,0,0-.6-.6l-2.8-.055a26.444,26.444,0,0,1,2.469,7.408c.327,2.189.558,4.371.8,6.561.052.37.091.734.127,1.1a.586.586,0,0,0,.327-.542Z",
    transform: "translate(192.272 47.307)",
    fill: "#96a5b0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29184",
    "data-name": "Path 29184",
    d: "M584.961,194.879c8.108,5.217,31.126,13.873,34.758,14.08s4.118-.567,4.494-1.635S618.4,185.45,617.08,182.5s-2.672-4.465-4.511-5.081-11.234-4.315-28.917-5.259c-10.877-.58-16.1.095-18.238,2.8-3.087,3.9,11.44,14.707,19.548,19.924",
    transform: "translate(188.7 57.434)",
    fill: "#c8ebeb"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29185",
    "data-name": "Path 29185",
    d: "M596.383,178.411c6.726,2.074,20.993,6.977,23.25,12.067-.261-.748-2.515-7.644-2.665-7.981-1.319-2.955-2.672-4.465-4.512-5.081s-11.234-4.315-28.917-5.259c-10.84-.579-16.062.091-18.214,2.769.259,1.379,1.076,1.091,2.1.907,13.2-2.388,18.691-.59,28.961,2.577",
    transform: "translate(188.812 57.434)",
    fill: "#daf2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10674",
    "data-name": "Group 10674",
    transform: "translate(758.019 234.274)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29186",
    "data-name": "Path 29186",
    d: "M584.035,176.2c1.492-.063,3.106,1.147,3.731,4.29.656,3.291,1.674,13.038,1.674,13.038s-10.429-5.651-14.582-9.563a39,39,0,0,1-6.623-8.351s14.308.648,15.8.586",
    transform: "translate(-568.235 -175.619)",
    fill: "#cef0e8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10677",
    "data-name": "Group 10677",
    transform: "translate(778.848 243.832)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10676",
    "data-name": "Group 10676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10675",
    "data-name": "Group 10675",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29187",
    "data-name": "Path 29187",
    d: "M601.42,183.435c1.658-.069,3.454,1.277,4.15,4.772.73,3.659,1.594,12.035,1.594,12.035s-11.331-3.821-15.949-8.172a43.357,43.357,0,0,1-7.366-9.286s15.913.72,17.571.651",
    transform: "translate(-583.849 -182.784)",
    fill: "#cef0e8"
  }))))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29188",
    "data-name": "Path 29188",
    d: "M587.626,180.157c-.675-2.88-2.213-4.015-3.646-3.955-1.386.059-13.835-.5-15.582-.575a165.944,165.944,0,0,0,19.228,4.53",
    transform: "translate(189.838 58.657)",
    fill: "#f0f5f5"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29189",
    "data-name": "Path 29189",
    d: "M605.546,188.871c-.043-.237-.084-.464-.125-.672-.7-3.494-2.491-4.84-4.15-4.77-1.469.061-14.1-.495-16.979-.624,7.1,1.917,14.228,3.845,21.254,6.067",
    transform: "translate(195.147 61.054)",
    fill: "#f0f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10680",
    "data-name": "Group 10680",
    transform: "translate(754.787 236.505)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10679",
    "data-name": "Group 10679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10678",
    "data-name": "Group 10678",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29190",
    "data-name": "Path 29190",
    d: "M614.637,195.74a9.658,9.658,0,0,0-7.7-1.383c-9.493,2.612-15.936-4.11-23.63-8.963a93.693,93.693,0,0,0-17.5-8.1c3.22,4.926,12.83,11.919,18.875,15.809,8.108,5.217,31.125,13.875,34.758,14.079s4.118-.566,4.5-1.634c.2-.578-.443-2.949-1.137-5.316-4.066-1.283-6.536-3.446-8.167-4.489",
    transform: "translate(-565.812 -177.292)",
    fill: "#cef0e8"
  }))))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29191",
    "data-name": "Path 29191",
    d: "M579.573,174.709c26.917,1.76,31.019,4.9,35.451,14.9.947,2.138,4.147,9.239,4.752,8.143.518-.938-3.911-13.056-4.624-14.65-1.253-2.8-2.536-4.237-4.283-4.822s-10.659-4.1-27.443-4.992c-9.925-.528-14.316-.145-16.487,2.178-1.178.99,3.9-1.325,12.634-.754",
    transform: "translate(189.295 57.805)",
    fill: "#f0f5f5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29192",
    "data-name": "Path 29192",
    d: "M29.459,158.344c2.121-.612,10.488-2.026,21.939-3.727,12.069-1.792,11.974.187,13.923,1.744s4.525,6.962,4.085,8.345-38.027,25.33-43.684,27.467-11.806,4.211-11.806,4.211,3.67-14.114,6.746-23.287c5.187-15.462,6.677-14.14,8.8-14.753",
    transform: "translate(4.647 51.403)",
    fill: "#d91e18"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29193",
    "data-name": "Path 29193",
    d: "M45.677,174.5c1.37-.844,4.317-2.735,6.067-3.853-5.659-.152-11.319-.236-16.959.007-5.411.232-10.915.915-16.4,1.285-.638,2.061-1.271,4.2-1.869,6.278A241.054,241.054,0,0,1,45.677,174.5",
    transform: "translate(5.517 56.945)",
    fill: "#ff3e38"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29194",
    "data-name": "Path 29194",
    d: "M21.355,164.084c-.634,1.591-1.339,3.514-2.138,5.855,14.323-2.188,29.281-3.579,43.433-4.462,1.523-1.038,2.763-1.912,3.627-2.559a433.017,433.017,0,0,0-44.922,1.166",
    transform: "translate(6.418 54.373)",
    fill: "#ff3e38"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29195",
    "data-name": "Path 29195",
    d: "M63.712,156.786a45.028,45.028,0,0,0-8.815-.366c-4.179.157-18.094.907-30.587,2.652-.9.824-2.545,2.828-2.026,3.394,10.37-1.6,38.559-3.056,43.814-1.354a19.831,19.831,0,0,0-2.385-4.326",
    transform: "translate(7.41 52.228)",
    fill: "#ff3e38"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29196",
    "data-name": "Path 29196",
    d: "M65.917,162.959c-6.819,4.454-17.483,11.288-24.7,15.241-10.013,5.481-16.311,8.627-25.331,9.483-1.1,3.99-1.968,7.3-1.968,7.3s6.148-2.074,11.806-4.211S68.965,164.685,69.4,163.3c.267-.839-.578-3.155-1.717-5.2-.3.22.153,3.6-1.772,4.852",
    transform: "translate(4.647 52.806)",
    fill: "#ba140f"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29197",
    "data-name": "Path 29197",
    d: "M19.2,187.758c1.357-4.279,4.666-16.659,7.5-21.968S40.557,158.8,52.152,156c3.59-.867,8.774-1.989,11.983-.715-1.355-1.182-3.419-2.048-12.738-.664-11.451,1.7-19.818,3.114-21.939,3.727s-3.611-.71-8.8,14.753c-3.076,9.174-6.745,23.287-6.745,23.287s.313-.105.843-.287a22.283,22.283,0,0,0,4.441-8.34",
    transform: "translate(4.648 51.403)",
    fill: "#ff3e38"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29198",
    "data-name": "Path 29198",
    d: "M176.794,156.393l186.018,5.944-1.163-3.1-183.865-5.792Z",
    transform: "translate(59.047 51.25)",
    fill: "#c6ced9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29199",
    "data-name": "Path 29199",
    d: "M316.531,160.888l198.28,2.78-.354-2.517-199.09-3.36Z",
    transform: "translate(105.329 52.7)",
    fill: "#c6ced9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29200",
    "data-name": "Path 29200",
    d: "M499.539,178.586c-4.445-5.516-12.181-14.164-28.146-24.88-19.04-12.781-47.793-32.923-83.4-50.9a185.749,185.749,0,0,0-36.6-13.868s-.47,3.159,3.938,4.146,20.607,6.787,33.29,13.556c36.039,19.24,64.007,39.5,79.911,49.686,25.362,16.249,29.907,28.33,29.907,28.33l4.065.115s.394-2.016-2.965-6.184",
    transform: "translate(117.357 29.704)",
    fill: "#c6ced9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29201",
    "data-name": "Path 29201",
    d: "M422.174,144.333a67.738,67.738,0,0,0-2.921,6.977H445.6a2.074,2.074,0,0,0,2.074-2.074,4.9,4.9,0,0,0-4.9-4.9Z",
    transform: "translate(140.026 48.206)",
    fill: "#f26a44"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29202",
    "data-name": "Path 29202",
    d: "M445.47,145.452a4.824,4.824,0,0,0-3.09-1.119h-20.6c-.556,1.143-.874,1.854-1.339,2.964,2.2-1.238,13.117-2.069,18.947-2.281a16.588,16.588,0,0,1,6.084.436",
    transform: "translate(140.422 48.206)",
    fill: "#ff844f"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29203",
    "data-name": "Path 29203",
    d: "M438.772,149.184c-5.519.135-11.586.147-17.091-.207-.787-.051-1.1-1.994-1.1-1.994s-1.139,2.911-1.326,3.442H445.6a2.075,2.075,0,0,0,2.074-2.073c0-.139-.029-.269-.04-.4a41.553,41.553,0,0,1-8.867,1.237",
    transform: "translate(140.026 49.091)",
    fill: "#e3562d"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29204",
    "data-name": "Path 29204",
    d: "M197.9,163.321,118.056,137.99s4.926-10.305,10.432-12.337,69.41,37.668,69.41,37.668",
    transform: "translate(39.429 41.941)",
    fill: "#36393b"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29205",
    "data-name": "Path 29205",
    d: "M152.383,143.544c-11.643-3.742-18.6-8-34.279-8.646l79.777,25.31s-33.854-12.922-45.5-16.664",
    transform: "translate(39.445 45.054)",
    fill: "#252729"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29206",
    "data-name": "Path 29206",
    d: "M197.546,163.1c-4.841-3-63.781-39.4-69.058-37.449-5.5,2.032-10.432,12.337-10.432,12.337l4.778-5.375c12.994-8.863,66.534,27.964,74.711,30.487",
    transform: "translate(39.429 41.941)",
    fill: "#494c4f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10683",
    "data-name": "Group 10683",
    transform: "translate(29.594 412.754)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10682",
    "data-name": "Group 10682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10681",
    "data-name": "Group 10681",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29207",
    "data-name": "Path 29207",
    d: "M542.32,315.634c0-4.746-148.355-7.236-301.915-5.83-128.494,1.178-218.22,4.781-218.22,8.212s89.727,6.212,218.22,6.212c153.559,0,301.915-3.847,301.915-8.595",
    transform: "translate(-22.184 -309.414)",
    fill: "#d1dbe6"
  }))))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10687",
    "data-name": "Group 10687",
    transform: "translate(350.844 401.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10686",
    "data-name": "Group 10686",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29208",
    "data-name": "Path 29208",
    d: "M263.927,299.093l-2,10.128,14.36,3.157,2-10.128Z",
    transform: "translate(-263.365 -301.933)",
    fill: "url(#linear-gradient)"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10689",
    "data-name": "Group 10689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10688",
    "data-name": "Group 10688",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29210",
    "data-name": "Path 29210",
    d: "M285.585,316.278s.093-10.137-.259-10.481-8.983-.228-11.3-.354a50.267,50.267,0,0,1-7.241-1.5s-13.3,4.089-17.206,5.215-6.87,1.838-6.869,2.989-.412,4.342-.412,4.342-.742,2.461,10.242,1.622,11.2-2.629,16.872-2.569,16.168.731,16.168.731",
    transform: "translate(80.923 101.515)",
    fill: "#361313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29211",
    "data-name": "Path 29211",
    d: "M286.635,312.794l-.061,6.106-16.208-.38s-1.558-4-2.258-4.277-7.007,3.287-9.179,3.835a62.755,62.755,0,0,1-13.4.47,21.959,21.959,0,0,1-3.966-1.042l.131-4.72s1.635,1.916,5.773,1.965,17.817-2.188,21.628-2.305,17.545.348,17.545.348",
    transform: "translate(80.678 104.347)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29212",
    "data-name": "Path 29212",
    d: "M296.213,69.367a13.41,13.41,0,0,0-6.09-2.435c-3.406-.354-11.133.914-11.133.914l-7.744,7.2a64.17,64.17,0,0,0,14.336,1.622c8.316.051,13.936-.3,13.936-.3Z",
    transform: "translate(90.593 22.334)",
    fill: "#105e34"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10691",
    "data-name": "Group 10691",
    transform: "translate(364.919 98.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10690",
    "data-name": "Group 10690",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29213",
    "data-name": "Path 29213",
    d: "M297.852,73.587H272.021l.417,18.065H298.27Z",
    transform: "translate(-274.067 -73.587)",
    fill: "url(#linear-gradient-2)"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10693",
    "data-name": "Group 10693",
    transform: "translate(368.36 77.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10692",
    "data-name": "Group 10692",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29215",
    "data-name": "Path 29215",
    d: "M274.57,58.313l2.11,41.479,18.9-.525-2.11-41.479Z",
    transform: "translate(-276.656 -58.255)",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10701",
    "data-name": "Group 10701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10700",
    "data-name": "Group 10700",
    clipPath: "url(#clip-path)"
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29217",
    "data-name": "Path 29217",
    d: "M277.25,73.037l-18.665,4.825s2.849,34.825,2.895,45.574.851,54.353,1.083,55.571,4.448,8.163,4.448,8.163l24,5.172L288.92,88.755s-6.629-3.8-8.538-7.454a46.589,46.589,0,0,1-3.132-8.264",
    transform: "translate(86.364 24.394)",
    fill: "#147541"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29218",
    "data-name": "Path 29218",
    d: "M279.335,150.787a1.475,1.475,0,0,1,1.271-1.661,1.56,1.56,0,0,1,1.349,1.661,1.477,1.477,0,0,1-1.273,1.661,1.559,1.559,0,0,1-1.347-1.661",
    transform: "translate(93.294 49.806)",
    fill: "#adedde"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29219",
    "data-name": "Path 29219",
    d: "M293.927,73.949l23.278,4.133s-6.08,29.23-6.386,35.771-1.161,41.83-.395,48.675,1.258,21.448,1.258,21.448l-4.578,5.932s-16.547,1.522-19.281,1.674a39.274,39.274,0,0,0-4.4.456l-1.737-75.144c-.53-22.969-.352-28.445-.352-28.445s7.5-4.714,9-5.475,3.594-9.026,3.594-9.026",
    transform: "translate(93.952 24.698)",
    fill: "#17854a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10696",
    "data-name": "Group 10696",
    transform: "translate(380.176 205.924)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10695",
    "data-name": "Group 10695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10694",
    "data-name": "Group 10694",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29220",
    "data-name": "Path 29220",
    d: "M308.415,154.367a3.581,3.581,0,0,1-1.829,4.019c-2.076.962-20.746,2.272-21.531,2.36a89.963,89.963,0,0,1,10.085-2.272c4.265-.7,13.275-4.107,13.275-4.107",
    transform: "translate(-284.992 -154.367)",
    fill: "#f2f2f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10699",
    "data-name": "Group 10699",
    transform: "translate(349.389 192.592)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10698",
    "data-name": "Group 10698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10697",
    "data-name": "Group 10697",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29221",
    "data-name": "Path 29221",
    d: "M261.942,144.379c.125-.263,1.707,7.733,3.5,11.316,2.024,4.058,3.415,4.44,2.892,5.112-.339.438-1.05.574-2.568-.524-1.178-.852-2.193-3.19-2.719-4.217-.959-1.872-1.226-11.426-1.1-11.687",
    transform: "translate(-261.913 -144.373)",
    fill: "#f2f2f2"
  }))))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10703",
    "data-name": "Group 10703",
    transform: "translate(257.435 167.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10702",
    "data-name": "Group 10702",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3139",
    "data-name": "Rectangle 3139",
    width: 9.22,
    height: 15.019,
    transform: "translate(-2.708 4.545) rotate(-71.743)",
    fill: "url(#linear-gradient-4)"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10705",
    "data-name": "Group 10705",
    transform: "translate(245.044 168.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10704",
    "data-name": "Group 10704",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3140",
    "data-name": "Rectangle 3140",
    width: 41.768,
    height: 12.976,
    transform: "translate(-1.019 0.001) rotate(-0.424)",
    fill: "url(#linear-gradient-5)"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10707",
    "data-name": "Group 10707",
    transform: "translate(249.214 173.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10706",
    "data-name": "Group 10706",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3141",
    "data-name": "Rectangle 3141",
    width: 13.444,
    height: 18.135,
    transform: "translate(-1.45 2.2) rotate(-56.609)",
    fill: "url(#linear-gradient-6)"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10709",
    "data-name": "Group 10709",
    transform: "translate(249.468 171.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10708",
    "data-name": "Group 10708",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3142",
    "data-name": "Rectangle 3142",
    width: 13.444,
    height: 18.135,
    transform: "translate(-1.45 2.2) rotate(-56.609)",
    fill: "url(#linear-gradient-7)"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10711",
    "data-name": "Group 10711",
    transform: "translate(249.053 171.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10710",
    "data-name": "Group 10710",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3143",
    "data-name": "Rectangle 3143",
    width: 13.445,
    height: 18.136,
    transform: "translate(-1.45 2.2) rotate(-56.609)",
    fill: "url(#linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10734",
    "data-name": "Group 10734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10733",
    "data-name": "Group 10733",
    clipPath: "url(#clip-path)"
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29227",
    "data-name": "Path 29227",
    d: "M275.852,76.654S262.338,98.03,258.191,109.6s-10.6,28.557-10.6,28.557a46.743,46.743,0,0,0-15.618-.508c-9.427,1.094-25.09,5.551-25.09,5.551l.676,10.3,44.42-.655c4.57-.041,7.224-1.443,9.627-5.291,5.471-8.751,14.782-24,16.441-28.98a65.713,65.713,0,0,0,3.143-16.255c.144-2.583-5.344-25.669-5.344-25.669",
    transform: "translate(69.098 25.602)",
    fill: "#1e824c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10714",
    "data-name": "Group 10714",
    transform: "translate(318.214 163.052)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10713",
    "data-name": "Group 10713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10712",
    "data-name": "Group 10712",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29228",
    "data-name": "Path 29228",
    d: "M238.543,122.229c.124.2,1.888,3.134,2.655,4.521a66.244,66.244,0,0,0,3.64,5.955A16.419,16.419,0,0,0,243.117,128c-.866-1.4-1.041-2.125.039-2.021s4.241-.37,2.409-.7-7.022-3.041-7.022-3.041",
    transform: "translate(-238.543 -122.229)",
    fill: "#f2f2f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10717",
    "data-name": "Group 10717",
    transform: "translate(373.598 112.685)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10716",
    "data-name": "Group 10716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10715",
    "data-name": "Group 10715",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29229",
    "data-name": "Path 29229",
    d: "M293.2,86.962c-.215.175-6.354,2.971-6.354,2.971a3.918,3.918,0,0,1,.207,1.4,54.161,54.161,0,0,1-3.33,5.288l6.967,32.987-6.25,13.2-4.377-7.909,1.8-46.882,9.793-3.539Z",
    transform: "translate(-280.061 -84.472)",
    fill: "#f2f2f2"
  }))))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29230",
    "data-name": "Path 29230",
    d: "M292.188,83.224s-5.519,4.716-6.38,4.766a29.046,29.046,0,0,1-3.963-.406c-.56-.1-5.018-6.49-5.018-6.49L272.9,84.39s4.577,4.969,6.778,5.882,4.261,2.282,7.486,1.421,8.544-5.425,8.544-5.425Z",
    transform: "translate(91.144 27.085)",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10720",
    "data-name": "Group 10720",
    transform: "translate(380.364 112.108)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10719",
    "data-name": "Group 10719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10718",
    "data-name": "Group 10718",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29231",
    "data-name": "Path 29231",
    d: "M287.557,84.04c-.039.06-2.424,4.786-2.424,4.786s3.478-1.85,3.647-2.312-1.223-2.475-1.223-2.475",
    transform: "translate(-285.133 -84.04)",
    fill: "#f2f2f2"
  }))))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29232",
    "data-name": "Path 29232",
    d: "M284.534,85.407s3.548,4.361,3.154,4.817-2.56,3.295-3.4,4.057-4.091.71-4.091.71-1.964-3.8-2.186-4.665,1.973-4.564,2.268-4.969,4.261.051,4.261.051",
    transform: "translate(92.845 28.452)",
    fill: "#454545"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29233",
    "data-name": "Path 29233",
    d: "M281.453,91.357s-4.841,32.958-4.918,33.971,7.093,16.225,7.093,16.225,6.934-12.6,7.118-13.411-7.373-37.09-7.373-37.09Z",
    transform: "translate(92.359 30.411)",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10723",
    "data-name": "Group 10723",
    transform: "translate(374.883 115.386)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10722",
    "data-name": "Group 10722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10721",
    "data-name": "Group 10721",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29234",
    "data-name": "Path 29234",
    d: "M285.808,89.639a9.968,9.968,0,0,1-3.148,3.383c-1.01.407-1.774.087-1.614-.554s2.857-2.36,2.721-3.234a18.667,18.667,0,0,1-.035-2.737c.751.992,2.164,2.672,2.076,3.142",
    transform: "translate(-281.024 -86.497)",
    fill: "#f2f2f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10726",
    "data-name": "Group 10726",
    transform: "translate(375.125 123.345)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10725",
    "data-name": "Group 10725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10724",
    "data-name": "Group 10724",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29235",
    "data-name": "Path 29235",
    d: "M281.206,92.463s4.269,27.788,4.517,30.934a11.927,11.927,0,0,1-1.267,6.292c-.782,1.485-1.329-9.393-1.707-13.982-.424-5.156-1.542-23.245-1.542-23.245",
    transform: "translate(-281.206 -92.463)",
    fill: "#f2f2f2"
  }))))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29236",
    "data-name": "Path 29236",
    d: "M286.6,81.627l-5.276,4.259,7.152-2.08Z",
    transform: "translate(93.959 27.262)",
    fill: "#105e34"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29237",
    "data-name": "Path 29237",
    d: "M291.525,68.742s7.236,8.112,7.388,8.112-5.289,19.065-5.289,19.065l-8.343-9.989a16.858,16.858,0,0,0,5.38-8.519,27.917,27.917,0,0,0,.864-8.67",
    transform: "translate(95.281 22.959)",
    fill: "#229456"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29238",
    "data-name": "Path 29238",
    d: "M279.355,67.6l-8.827,6.388L270.152,92.8l10.62-7.757a9.888,9.888,0,0,1-2.567-5.78c-.548-3.955,1.15-11.662,1.15-11.662",
    transform: "translate(90.228 22.578)",
    fill: "#229456"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29239",
    "data-name": "Path 29239",
    d: "M302.63,98.485s-.049,11.028-.415,11.636-9.538,5.248-9.538,5.248l-5.988-5.7L286.6,95.824Z",
    transform: "translate(95.72 32.004)",
    fill: "#229456"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29240",
    "data-name": "Path 29240",
    d: "M303.1,94.037l.305,6.617-16.994-1.445.019-5.78Z",
    transform: "translate(95.659 31.204)",
    fill: "#1e824c"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29241",
    "data-name": "Path 29241",
    d: "M265.873,97.187s-.65,10.995-.323,11.642,9.171,6.272,9.171,6.272l6.33-5.029.968-13.784Z",
    transform: "translate(88.66 32.159)",
    fill: "#229456"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29242",
    "data-name": "Path 29242",
    d: "M265.85,93.369l-.391,6.6,17.007-.44.055-5.78Z",
    transform: "translate(88.66 31.184)",
    fill: "#1e824c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10729",
    "data-name": "Group 10729",
    transform: "translate(389.613 134.269)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10728",
    "data-name": "Group 10728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10727",
    "data-name": "Group 10727",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29243",
    "data-name": "Path 29243",
    d: "M304,100.652s-1.041,11.256-2.1,13.194c-1.4,2.564-4.9,3.583-6.463,3.933s-2.967.175-3.36.758,7.32,1.661,7.557,1.836,1.84-1.049,2.663,4.31,1.443,15.944,1.543,16.341c.32,1.282,1.233,2.913,1.557,1.806s1.126-31.9.578-35.449A29.608,29.608,0,0,0,304,100.652",
    transform: "translate(-292.066 -100.652)",
    fill: "#f2f2f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10732",
    "data-name": "Group 10732",
    transform: "translate(349.134 172.453)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10731",
    "data-name": "Group 10731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10730",
    "data-name": "Group 10730",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29244",
    "data-name": "Path 29244",
    d: "M280.288,133.211s-10.679-.787-12.207-.743-6.358.907-6.358.907,6.718-4.227,8.076-4.1,10.489,3.933,10.489,3.933",
    transform: "translate(-261.722 -129.276)",
    fill: "#f2f2f2"
  }))))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29245",
    "data-name": "Path 29245",
    d: "M283,86.2l-4.286-5.527-2.383,1.647Z",
    transform: "translate(92.29 26.945)",
    fill: "#105e34"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29246",
    "data-name": "Path 29246",
    d: "M290.09,161.2l-25.33-3.3s.568,25.67.149,38.538-4.161,154.889-4.161,154.889,6.673,3.679,9.586,3.634,7.59-.547,7.59-.547,13.9-77.721,14.09-79.292-10.121-15.165-10.121-15.165,7.066-19.868,10.285-38.858a207.609,207.609,0,0,0,3.188-31.79Z",
    transform: "translate(87.087 52.736)",
    fill: "#613922"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10736",
    "data-name": "Group 10736",
    transform: "translate(383.358 403.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10735",
    "data-name": "Group 10735",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29247",
    "data-name": "Path 29247",
    d: "M288.252,300.476l-2.066,12,14.265,3.119,2.066-12Z",
    transform: "translate(-287.775 -303.248)",
    fill: "url(#linear-gradient-9)"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10738",
    "data-name": "Group 10738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10737",
    "data-name": "Group 10737",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29249",
    "data-name": "Path 29249",
    d: "M302.561,307l-.651,10.04-16.83-.456,1.964-11.18Z",
    transform: "translate(95.214 102.002)",
    fill: "#2e1909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29250",
    "data-name": "Path 29250",
    d: "M303.229,316.35a10.305,10.305,0,0,0-5.688-7.453c-5.062-2.434-7.955-4.031-11.747-2.282s-5.424,10.42-5.424,10.42Z",
    transform: "translate(93.64 102.159)",
    fill: "#361313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29251",
    "data-name": "Path 29251",
    d: "M303.5,318.6s-21.676,0-22.751-.228-1.458-4.944-.93-5.02,24.022-.228,24.272.228a12.941,12.941,0,0,1,.358,4.183,1.89,1.89,0,0,1-.948.836",
    transform: "translate(93.376 104.627)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29252",
    "data-name": "Path 29252",
    d: "M272.156,345.29a.7.7,0,0,1-.105-.008.675.675,0,0,1-.562-.77l.115-.734a.682.682,0,0,1,.77-.562.674.674,0,0,1,.562.77l-.115.734a.674.674,0,0,1-.664.57m.532-3.419a.944.944,0,0,1-.105-.007.676.676,0,0,1-.562-.771l.419-2.685a.674.674,0,0,1,1.331.208l-.419,2.687a.672.672,0,0,1-.664.568m.836-5.372a.718.718,0,0,1-.105-.008.674.674,0,0,1-.562-.77l.419-2.687a.674.674,0,1,1,1.331.209l-.419,2.685a.673.673,0,0,1-.664.57m.838-5.372a.717.717,0,0,1-.105-.008.674.674,0,0,1-.562-.77l.419-2.685a.674.674,0,1,1,1.331.208l-.419,2.685a.674.674,0,0,1-.664.57m.836-5.372a.714.714,0,0,1-.105-.008.673.673,0,0,1-.562-.77l.419-2.685a.674.674,0,1,1,1.331.208l-.419,2.687a.673.673,0,0,1-.664.568m.836-5.372a.7.7,0,0,1-.105-.008.674.674,0,0,1-.562-.77l.419-2.685a.674.674,0,0,1,1.331.208l-.419,2.685a.674.674,0,0,1-.664.57m.838-5.371a.7.7,0,0,1-.105-.008.674.674,0,0,1-.562-.77l.419-2.687a.674.674,0,0,1,1.331.208l-.419,2.687a.674.674,0,0,1-.664.57m.836-5.373a.7.7,0,0,1-.105-.008.673.673,0,0,1-.562-.77l.419-2.684a.674.674,0,1,1,1.331.208l-.419,2.684a.673.673,0,0,1-.664.57m.836-5.371a.7.7,0,0,1-.105-.008.675.675,0,0,1-.562-.77l.419-2.687a.674.674,0,0,1,1.333.208l-.42,2.687a.674.674,0,0,1-.664.57m.838-5.372a.7.7,0,0,1-.105-.008.674.674,0,0,1-.562-.77l.419-2.685a.68.68,0,0,1,.77-.562.673.673,0,0,1,.56.77l-.418,2.685a.674.674,0,0,1-.664.57m.836-5.372a.705.705,0,0,1-.105-.008.672.672,0,0,1-.562-.77l.418-2.687a.685.685,0,0,1,.771-.56.673.673,0,0,1,.562.77l-.419,2.685a.674.674,0,0,1-.664.57m.836-5.372a.7.7,0,0,1-.105-.008.674.674,0,0,1-.562-.77l.419-2.687a.674.674,0,1,1,1.331.208l-.419,2.687a.674.674,0,0,1-.664.57m.838-5.372a.905.905,0,0,1-.105-.007.674.674,0,0,1-.562-.771l.418-2.685a.681.681,0,0,1,.77-.562.673.673,0,0,1,.562.77l-.418,2.687a.673.673,0,0,1-.664.568m.836-5.372a.692.692,0,0,1-.105-.008.673.673,0,0,1-.562-.77l.418-2.687a.674.674,0,0,1,1.331.209l-.418,2.685a.674.674,0,0,1-.664.57m.838-5.371a.691.691,0,0,1-.105-.008.673.673,0,0,1-.562-.77l.418-2.687a.674.674,0,1,1,1.331.208l-.418,2.687a.674.674,0,0,1-.664.57m-.807-5.108a.671.671,0,0,1-.6-.367l-1.241-2.419a.674.674,0,1,1,1.2-.615l1.241,2.418a.675.675,0,0,1-.6.982m-2.481-4.838a.67.67,0,0,1-.6-.367l-1.241-2.417a.673.673,0,1,1,1.2-.615l1.241,2.417a.673.673,0,0,1-.292.907.664.664,0,0,1-.307.075m-2.481-4.837a.671.671,0,0,1-.6-.367l-1.239-2.419a.673.673,0,1,1,1.2-.615l1.241,2.419a.675.675,0,0,1-.6.982m-1.355-4.977a.724.724,0,0,1-.167-.021.672.672,0,0,1-.486-.82l.668-2.643a.674.674,0,1,1,1.307.331l-.671,2.645a.673.673,0,0,1-.652.508m1.335-5.288a.777.777,0,0,1-.164-.02.674.674,0,0,1-.49-.819l.662-2.641a.674.674,0,0,1,1.307.326l-.662,2.645a.675.675,0,0,1-.654.51M279.1,241.7a.627.627,0,0,1-.163-.021.673.673,0,0,1-.491-.816l.655-2.644a.674.674,0,0,1,1.309.323l-.656,2.647a.676.676,0,0,1-.654.512m1.307-5.292a.609.609,0,0,1-.161-.02.673.673,0,0,1-.494-.815l.647-2.644a.674.674,0,1,1,1.31.319l-.648,2.648a.674.674,0,0,1-.654.512m1.289-5.293a.634.634,0,0,1-.157-.019.675.675,0,0,1-.5-.812l.635-2.648a.673.673,0,1,1,1.31.312l-.634,2.651a.675.675,0,0,1-.656.516m1.259-5.3a.768.768,0,0,1-.153-.016.673.673,0,0,1-.5-.81c.219-.939.422-1.829.607-2.649a.674.674,0,1,1,1.315.295c-.185.826-.391,1.718-.61,2.66a.674.674,0,0,1-.656.52m1.19-5.32a.686.686,0,0,1-.137-.013.674.674,0,0,1-.524-.8c.145-.7.26-1.283.339-1.744l.152-.912a.685.685,0,0,1,.775-.556.675.675,0,0,1,.556.775l-.155.924c-.081.471-.2,1.074-.346,1.786a.675.675,0,0,1-.66.536m.92-5.376a.674.674,0,0,1-.667-.776l.407-2.693a.69.69,0,0,1,.768-.567.676.676,0,0,1,.566.768l-.41,2.7a.672.672,0,0,1-.664.571m.811-5.391a.632.632,0,0,1-.1-.007.674.674,0,0,1-.568-.766l.4-2.7a.666.666,0,0,1,.766-.568.675.675,0,0,1,.568.767l-.4,2.7a.674.674,0,0,1-.666.575m.8-5.392a.617.617,0,0,1-.1-.007.674.674,0,0,1-.57-.764l.394-2.7a.674.674,0,1,1,1.334.193l-.393,2.7a.675.675,0,0,1-.666.576m.786-5.4a.617.617,0,0,1-.1-.007.673.673,0,0,1-.57-.763l.389-2.7a.684.684,0,0,1,.763-.571.675.675,0,0,1,.571.764l-.389,2.695a.673.673,0,0,1-.666.578m.772-5.432a.669.669,0,0,1-.088-.007.642.642,0,0,1-.575-.724l.388-2.7a.674.674,0,0,1,1.334.191l-.376,2.62a.721.721,0,0,1-.683.616m.779-5.355a.585.585,0,0,1-.1-.007.673.673,0,0,1-.571-.763l.387-2.7a.684.684,0,0,1,.762-.571.671.671,0,0,1,.572.762l-.387,2.7a.673.673,0,0,1-.666.578m.772-5.4a.571.571,0,0,1-.1-.007.673.673,0,0,1-.572-.762l.387-2.712a.674.674,0,1,1,1.334.189l-.387,2.712a.674.674,0,0,1-.666.579",
    transform: "translate(90.671 59.682)",
    fill: "#52301c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29253",
    "data-name": "Path 29253",
    d: "M309.544,158.519s3.787,25.655,4.207,30.675-1.852,38.332-3.2,45.785-6.262,25.251-6.262,25.251,8.332,18.253,8.371,19.926-8.053,76.984-8.053,76.984l-18.042-4.31s-1.561-71.458-1.231-96.707-2.447-66.319-2.447-66.319l-2.277-2.029.647-26.726s14.039-.349,19.5-.856a40.3,40.3,0,0,0,8.784-1.673",
    transform: "translate(93.72 52.943)",
    fill: "#6f4127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29254",
    "data-name": "Path 29254",
    d: "M296.888,354.511a.506.506,0,0,1-.064,0,.675.675,0,0,1-.608-.734l.257-2.728a.689.689,0,0,1,.732-.608.672.672,0,0,1,.608.734l-.256,2.728a.673.673,0,0,1-.67.611m.512-5.449a.522.522,0,0,1-.064,0,.675.675,0,0,1-.608-.734l.256-2.72a.673.673,0,1,1,1.341.127l-.255,2.719a.673.673,0,0,1-.67.611m.511-5.437a.527.527,0,0,1-.065,0,.673.673,0,0,1-.607-.734l.256-2.716a.674.674,0,1,1,1.342.128l-.256,2.715a.674.674,0,0,1-.67.61m.512-5.429a.522.522,0,0,1-.065,0,.672.672,0,0,1-.607-.735l.255-2.713a.674.674,0,1,1,1.342.128l-.255,2.713a.674.674,0,0,1-.67.61m.508-5.428a.516.516,0,0,1-.064,0,.674.674,0,0,1-.607-.735l.255-2.711a.691.691,0,0,1,.734-.608.673.673,0,0,1,.608.732l-.256,2.715a.673.673,0,0,1-.67.61m.51-5.427a.549.549,0,0,1-.065,0,.673.673,0,0,1-.607-.734l.256-2.713a.668.668,0,0,1,.735-.607.675.675,0,0,1,.607.735l-.256,2.712a.672.672,0,0,1-.67.61m.508-5.424a.537.537,0,0,1-.065,0,.674.674,0,0,1-.607-.735l.256-2.711a.687.687,0,0,1,.732-.608.671.671,0,0,1,.608.734l-.255,2.713a.673.673,0,0,1-.67.61m.511-5.425a.506.506,0,0,1-.064,0,.675.675,0,0,1-.608-.734l.253-2.711a.692.692,0,0,1,.734-.61.673.673,0,0,1,.608.734l-.253,2.712a.674.674,0,0,1-.67.611m.508-5.425a.532.532,0,0,1-.065,0,.674.674,0,0,1-.607-.735l.253-2.711a.674.674,0,0,1,1.342.125l-.253,2.713a.673.673,0,0,1-.67.61m.506-5.427a.5.5,0,0,1-.064,0,.674.674,0,0,1-.608-.734l.253-2.712a.691.691,0,0,1,.734-.608.673.673,0,0,1,.608.734l-.253,2.712a.675.675,0,0,1-.67.611m.506-5.427a.533.533,0,0,1-.065,0,.672.672,0,0,1-.607-.734l.253-2.713a.682.682,0,0,1,.734-.608.675.675,0,0,1,.608.734l-.254,2.715a.674.674,0,0,1-.67.61m.507-5.427a.464.464,0,0,1-.061,0,.672.672,0,0,1-.61-.732l.251-2.717a.654.654,0,0,1,.734-.608.674.674,0,0,1,.608.734l-.252,2.715a.672.672,0,0,1-.67.612m.5-5.433a.469.469,0,0,1-.061,0,.673.673,0,0,1-.61-.732l.249-2.719a.66.66,0,0,1,.734-.608.673.673,0,0,1,.608.734l-.251,2.716a.673.673,0,0,1-.67.612m.5-5.436a.506.506,0,0,1-.063,0,.674.674,0,0,1-.608-.734l.245-2.724a.665.665,0,0,1,.731-.611.673.673,0,0,1,.611.731l-.247,2.729a.673.673,0,0,1-.67.611m0-5.412a.673.673,0,0,1-.636-.456c-.225-.655-.538-1.538-.908-2.563a.675.675,0,0,1,1.269-.459c.374,1.035.688,1.924.914,2.584a.673.673,0,0,1-.418.856.706.706,0,0,1-.22.037m-1.844-5.136a.676.676,0,0,1-.634-.442l-.943-2.555a.674.674,0,1,1,1.263-.468l.946,2.557a.674.674,0,0,1-.632.907m-1.941-5.149a.605.605,0,0,1-.584-.4l-.955-2.553a.675.675,0,0,1,1.265-.471l.919,2.46a.717.717,0,0,1-.378.914.766.766,0,0,1-.267.049m-1.868-5.066a.678.678,0,0,1-.631-.438l-.962-2.555a.674.674,0,0,1,1.261-.476l.963,2.557a.676.676,0,0,1-.631.911m-.724-5.259a.565.565,0,0,1-.095-.007.673.673,0,0,1-.574-.76l.381-2.705a.674.674,0,0,1,1.334.188l-.381,2.7a.673.673,0,0,1-.666.58m.754-5.457a.57.57,0,0,1-.081-.005.631.631,0,0,1-.58-.71l.371-2.7a.689.689,0,0,1,.759-.576.675.675,0,0,1,.578.759l-.36,2.6a.73.73,0,0,1-.686.631m.75-5.351a.671.671,0,0,1-.67-.762l.364-2.7a.674.674,0,0,1,1.337.179l-.364,2.7a.674.674,0,0,1-.667.584m.723-5.4a.7.7,0,0,1-.091-.005.675.675,0,0,1-.579-.758l.359-2.7a.685.685,0,0,1,.756-.58.674.674,0,0,1,.58.756L300,241.1a.672.672,0,0,1-.667.583m.71-5.4a.653.653,0,0,1-.088-.005.676.676,0,0,1-.582-.756l.349-2.7a.674.674,0,1,1,1.337.172l-.35,2.7a.673.673,0,0,1-.667.587m.694-5.4a.627.627,0,0,1-.087-.005.674.674,0,0,1-.583-.754l.339-2.7a.673.673,0,0,1,1.337.167l-.339,2.7a.674.674,0,0,1-.667.59m.671-5.4q-.042,0-.084,0a.675.675,0,0,1-.587-.751l.328-2.708a.7.7,0,0,1,.75-.59.674.674,0,0,1,.59.748l-.328,2.713a.676.676,0,0,1-.668.591m.648-5.415a.777.777,0,0,1-.079,0,.674.674,0,0,1-.592-.747l.314-2.7a.69.69,0,0,1,.746-.594.672.672,0,0,1,.592.747l-.312,2.705a.673.673,0,0,1-.668.595m.618-5.411a.734.734,0,0,1-.076,0,.673.673,0,0,1-.595-.744l.3-2.7a.7.7,0,0,1,.74-.6.671.671,0,0,1,.6.74l-.3,2.711a.673.673,0,0,1-.668.6m.582-5.416a.614.614,0,0,1-.071,0,.673.673,0,0,1-.6-.739l.272-2.709a.664.664,0,0,1,.738-.6.675.675,0,0,1,.6.738l-.272,2.713a.675.675,0,0,1-.67.6m.528-5.421a.519.519,0,0,1-.064,0,.675.675,0,0,1-.608-.734q.13-1.391.237-2.708a.675.675,0,1,1,1.345.112q-.112,1.321-.24,2.721a.673.673,0,0,1-.67.611m.451-5.433h-.049a.673.673,0,0,1-.624-.72q.1-1.423.177-2.711a.7.7,0,0,1,.712-.634.676.676,0,0,1,.635.712c-.051.863-.111,1.776-.18,2.729a.674.674,0,0,1-.671.624m.307-5.444h-.023a.672.672,0,0,1-.65-.7c.028-.823.044-1.582.044-2.266l0-.431a.672.672,0,0,1,.667-.679.637.637,0,0,1,.68.667l0,.443c0,.7-.016,1.471-.045,2.313a.672.672,0,0,1-.674.65m-.072-5.441a.675.675,0,0,1-.674-.635c-.049-.908-.107-1.813-.168-2.708a.674.674,0,0,1,1.345-.091c.061.9.119,1.81.171,2.723a.677.677,0,0,1-.636.711Zm-.371-5.427a.675.675,0,0,1-.671-.62q-.108-1.375-.224-2.705a.671.671,0,0,1,.612-.73.686.686,0,0,1,.728.612c.08.888.156,1.8.228,2.716a.675.675,0,0,1-.619.726H304.1m-.475-5.419a.674.674,0,0,1-.67-.607c-.092-.932-.184-1.836-.275-2.7a.678.678,0,0,1,.6-.742.687.687,0,0,1,.742.6c.091.871.183,1.777.275,2.712a.675.675,0,0,1-.6.736.586.586,0,0,1-.068,0m-.571-5.412a.674.674,0,0,1-.668-.6c-.111-.968-.217-1.873-.318-2.7a.675.675,0,0,1,.588-.75.686.686,0,0,1,.751.588c.1.828.207,1.736.318,2.705a.674.674,0,0,1-.592.747.778.778,0,0,1-.079,0m-.656-5.4a.673.673,0,0,1-.667-.586c-.223-1.7-.367-2.687-.367-2.689a.674.674,0,0,1,1.334-.2s.144.994.37,2.711a.673.673,0,0,1-.582.755.635.635,0,0,1-.088.005",
    transform: "translate(98.927 54.035)",
    fill: "#52301c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29255",
    "data-name": "Path 29255",
    d: "M265.847,184.372a.673.673,0,0,1-.6-.975,48.875,48.875,0,0,0,2.407-5.762c.83-2.588,1.5-12.988,1.506-13.093a.693.693,0,0,1,.715-.63.673.673,0,0,1,.63.715c-.027.434-.687,10.673-1.567,13.42A49.669,49.669,0,0,1,266.45,184a.674.674,0,0,1-.6.372",
    transform: "translate(88.564 54.744)",
    fill: "#52301c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29256",
    "data-name": "Path 29256",
    d: "M305.754,190.792a.67.67,0,0,1-.487-.208c-.256-.265-6.271-6.586-8.575-10.989-1.357-2.589-4.5-12.958-4.638-13.4a.674.674,0,0,1,1.29-.392c.033.108,3.246,10.688,4.542,13.166,2.216,4.234,8.293,10.619,8.355,10.683a.674.674,0,0,1-.487,1.139",
    transform: "translate(97.533 55.217)",
    fill: "#52301c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29257",
    "data-name": "Path 29257",
    d: "M316.694,159.289s-13.149,3.651-22.969,3.271-19.031-2.627-22.973-3.423c-3.9-.788-6.957-1.255-6.957-1.255l-.911,8.448s16.572,4.139,24.942,4.291,29.374-2.587,29.374-2.587Z",
    transform: "translate(87.801 52.731)",
    fill: "#b2744d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29258",
    "data-name": "Path 29258",
    d: "M272.007,158.967l-.718,10.6-2.851-.456,1.431-10.5Z",
    transform: "translate(89.655 52.975)",
    fill: "#89452e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29259",
    "data-name": "Path 29259",
    d: "M297.329,159.707l1.283,9.431-2.732.3-.678-9.583Z",
    transform: "translate(98.594 53.34)",
    fill: "#80402b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29260",
    "data-name": "Path 29260",
    d: "M282.979,189.088a.674.674,0,0,1-.574-.318l-2.439-3.937.822-17.949a.664.664,0,0,1,.706-.642.674.674,0,0,1,.642.7l-.8,17.531,2.22,3.58a.672.672,0,0,1-.574,1.029",
    transform: "translate(93.506 55.523)",
    fill: "#52301c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29261",
    "data-name": "Path 29261",
    d: "M292.624,161.333l.157,9.026a54.252,54.252,0,0,1-9.071.152c-3.508-.406-6.559-.762-6.559-.762l.18-9.785s7.176,1.166,9.154,1.217,6.139.152,6.139.152",
    transform: "translate(92.565 53.426)",
    fill: "#653b22"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10740",
    "data-name": "Group 10740",
    transform: "translate(349.615 9.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10739",
    "data-name": "Group 10739",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29262",
    "data-name": "Path 29262",
    d: "M322.529,9.387,264.43,2.1l-8.986,87.573,58.1,7.283Z",
    transform: "translate(-264.3 -8.34)",
    fill: "url(#linear-gradient-10)"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10742",
    "data-name": "Group 10742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10741",
    "data-name": "Group 10741",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29264",
    "data-name": "Path 29264",
    d: "M298.126,87.218l18.1-64.1L303.392,10.059l-5.616,9.357s8.429,16.363,8.718,17.538-4.86,15.666-6.1,18.409-4.273,7.18-6.994,8.095-24.032-.392-26.521-.784l-2.489-.391s11.71,26.5,12.253,27.416,21.485-2.48,21.485-2.48",
    transform: "translate(88.302 3.36)",
    fill: "#89452e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29265",
    "data-name": "Path 29265",
    d: "M279.789,27.839c-.261,0-.519,0-.768-.012-5-.164-13.715-3.135-14.083-3.262a.3.3,0,0,1,.2-.576c.088.031,9,3.068,13.9,3.228,3.913.144,9.585-.827,13.329-1.462.99-.167,1.837-.311,2.471-.4a.29.29,0,0,1,.346.256.3.3,0,0,1-.256.346c-.632.092-1.475.235-2.458.4a84.946,84.946,0,0,1-12.682,1.483",
    transform: "translate(88.418 8.007)",
    fill: "#de9d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29266",
    "data-name": "Path 29266",
    d: "M279.122,24.623q-.39,0-.763-.012c-5-.165-13.715-3.136-14.083-3.263a.3.3,0,1,1,.2-.576c.088.031,9,3.068,13.9,3.23,3.927.119,9.6-.83,13.343-1.465.984-.167,1.826-.309,2.458-.4a.291.291,0,0,1,.346.256.305.305,0,0,1-.257.346c-.628.092-1.466.235-2.445.4a85.152,85.152,0,0,1-12.7,1.486",
    transform: "translate(88.196 6.932)",
    fill: "#de9d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29267",
    "data-name": "Path 29267",
    d: "M307.88,15.932s-20.118,13.6-21.8,14.122-24.118,1.5-24.118,1.5,2.739-14.231,2.791-14.818,24.5-13.056,25.028-12.992a47.606,47.606,0,0,1,12.958,7.115,70.724,70.724,0,0,1,5.144,5.07",
    transform: "translate(87.491 1.251)",
    fill: "#89452e"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10744",
    "data-name": "Group 10744",
    transform: "translate(349.45 4.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10743",
    "data-name": "Group 10743",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29268",
    "data-name": "Path 29268",
    d: "M289.65,20.176a.306.306,0,0,1-.228-.507l7.558-8.527a.308.308,0,0,1,.43-.025.3.3,0,0,1,.027.43l-7.558,8.527a.306.306,0,0,1-.228.1",
    transform: "translate(-252.812 -1.309)",
    fill: "#753612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29269",
    "data-name": "Path 29269",
    d: "M304.268,33.53a.306.306,0,0,1-.277-.179,85.789,85.789,0,0,0-4.353-8.3c-2-3.13-7.17-10.448-7.222-10.521a.3.3,0,1,1,.5-.352c.052.075,5.229,7.4,7.238,10.545a87.376,87.376,0,0,1,4.394,8.373.305.305,0,0,1-.277.431",
    transform: "translate(-251.805 -0.304)",
    fill: "#753612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29270",
    "data-name": "Path 29270",
    d: "M295.461,55.861a.307.307,0,0,1-.267-.157l-5.281-9.571a.3.3,0,0,1,.12-.414.308.308,0,0,1,.414.119l5.281,9.571a.305.305,0,0,1-.12.415.324.324,0,0,1-.147.037",
    transform: "translate(-252.636 10.26)",
    fill: "#753612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29271",
    "data-name": "Path 29271",
    d: "M291.13,74.854a.308.308,0,0,1-.3-.243l-5.187-24.48a.305.305,0,0,1,.236-.362.309.309,0,0,1,.36.236l5.188,24.481a.305.305,0,0,1-.236.36.333.333,0,0,1-.063.007",
    transform: "translate(-254.051 11.623)",
    fill: "#753612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29272",
    "data-name": "Path 29272",
    d: "M285.329,76.023a.306.306,0,0,1-.293-.223L277.9,50.108a.3.3,0,0,1,.211-.375.307.307,0,0,1,.375.211l7.141,25.691a.3.3,0,0,1-.212.375.287.287,0,0,1-.081.012",
    transform: "translate(-256.64 11.61)",
    fill: "#753612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29273",
    "data-name": "Path 29273",
    d: "M280.052,77.15a.308.308,0,0,1-.292-.212l-8.716-27.231a.306.306,0,0,1,.2-.383.31.31,0,0,1,.384.2l8.715,27.231a.305.305,0,0,1-.2.383.3.3,0,0,1-.091.015",
    transform: "translate(-258.93 11.472)",
    fill: "#753612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29274",
    "data-name": "Path 29274",
    d: "M270.329,22.02c-4.279,0-7.513-.243-7.581-.248a.3.3,0,0,1-.28-.327.29.29,0,0,1,.328-.28c.141.011,14.288,1.067,22.582-1.283,8.251-2.337,15.721-11.763,15.8-11.858a.305.305,0,0,1,.427-.052.3.3,0,0,1,.052.427c-.075.1-7.666,9.677-16.108,12.07-4.419,1.251-10.462,1.551-15.215,1.551",
    transform: "translate(-261.789 -2.356)",
    fill: "#753612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29275",
    "data-name": "Path 29275",
    d: "M263.823,16.714a.3.3,0,0,1,0-.61c.125,0,12.644-.193,16.143-.78,7.549-1.266,14.93-10.025,15-10.113a.3.3,0,1,1,.466.391c-.305.367-7.6,9.02-15.369,10.324-3.546.594-15.718.78-16.236.788Z",
    transform: "translate(-261.438 -3.293)",
    fill: "#753612"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10746",
    "data-name": "Group 10746",
    transform: "translate(393.448 44.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10745",
    "data-name": "Group 10745",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29277",
    "data-name": "Path 29277",
    d: "M304.5,33.548H294.66l.375,16.233h9.845Z",
    transform: "translate(-295.035 -33.548)",
    fill: "url(#linear-gradient-11)"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10748",
    "data-name": "Group 10748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10747",
    "data-name": "Group 10747",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29279",
    "data-name": "Path 29279",
    d: "M298.243,36.924s1.475-1.341,1.806-1.3,2.635,2.433,2.33,4.436-.723,3.506-2.182,4.641a28.827,28.827,0,0,1-3.763,2.31s3.33-3.176,3.758-4.331.707-4.209-.067-4.622-1.882-1.134-1.882-1.134",
    transform: "translate(99.005 11.898)",
    fill: "#de9d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29280",
    "data-name": "Path 29280",
    d: "M275.134,33.583s-2.584,9.661-3.376,13.513-1.179,6.135-.979,6.315,8.347,1.061,8.51,1.029.2-.659-.3-.979c-.548-.349-4.355-.776-5.424-.947-1.229-.2-1.4-.44-1.4-.44a95.785,95.785,0,0,1,1.929-9.71c1.067-4.094,1.94-8.824,1.934-9.052s-.412-.424-.519-.338a3.743,3.743,0,0,0-.378.61",
    transform: "translate(90.419 11.006)",
    fill: "#89452e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29281",
    "data-name": "Path 29281",
    d: "M282.978,56.157s-3.778,4.57-5.008,5.06-3.853-.033-4.5-1.143-2.977-5.972-2.977-5.972Z",
    transform: "translate(90.342 18.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29282",
    "data-name": "Path 29282",
    d: "M280.253,39.446s1.668.295,3.338.491c.694.081,1.387.144,1.962.161a16.3,16.3,0,0,0,1.865-.073h0c1.89-.156,3.983-.5,3.983-.5a14.565,14.565,0,0,0-2.133-3.622,5.57,5.57,0,0,0-4.13-2.332,4.024,4.024,0,0,0-3.336,1.917,10.693,10.693,0,0,0-1.551,3.958",
    transform: "translate(93.601 11.212)",
    fill: "#fff"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10750",
    "data-name": "Group 10750",
    transform: "translate(375.257 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10749",
    "data-name": "Group 10749",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29283",
    "data-name": "Path 29283",
    d: "M289.053,40.6l.048-7.555-7.79-.229-.048,7.555Z",
    transform: "translate(-281.318 -33.041)",
    fill: "url(#linear-gradient-12)"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10752",
    "data-name": "Group 10752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10751",
    "data-name": "Group 10751",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29285",
    "data-name": "Path 29285",
    d: "M292.47,40.1s-1.363-6.723-6.4-7.181-6.9,6.691-6.9,6.691l1.438.065s1.474-5.419,5.164-5.353,4.736,5.777,4.736,5.777Z",
    transform: "translate(93.241 10.987)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29286",
    "data-name": "Path 29286",
    d: "M263.6,38.289s1.566.346,3.14.6c.654.105,1.307.2,1.852.24a16.772,16.772,0,0,0,1.77.023h0c1.8-.052,3.8-.264,3.8-.264a13,13,0,0,0-1.853-3.375,5.337,5.337,0,0,0-3.8-2.305,3.857,3.857,0,0,0-3.251,1.574,9.423,9.423,0,0,0-1.654,3.5",
    transform: "translate(88.039 11.091)",
    fill: "#fff"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10754",
    "data-name": "Group 10754",
    transform: "translate(353.097 43.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10753",
    "data-name": "Group 10753",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29287",
    "data-name": "Path 29287",
    d: "M272.069,40.078l.41-7.217-7.683-.613-.41,7.217Z",
    transform: "translate(-264.796 -32.832)",
    fill: "url(#linear-gradient-13)"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10756",
    "data-name": "Group 10756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10755",
    "data-name": "Group 10755",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29289",
    "data-name": "Path 29289",
    d: "M275.154,39.442s-.979-6.143-5.73-6.8-6.845,5.721-6.845,5.721l1.359.127s1.649-4.828,5.141-4.593,4.218,5.448,4.218,5.448Z",
    transform: "translate(87.699 10.888)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29290",
    "data-name": "Path 29290",
    d: "M276.112,34.094s-10.286-6.354-10.773-6.7-1.266-.131-1.254.348-.654,5.613-.654,5.613,1.83-1.74,2.791-1.61,8.285,4.44,8.764,4.484,1.126-2.133,1.126-2.133",
    transform: "translate(87.983 9.091)",
    fill: "#4f240b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29291",
    "data-name": "Path 29291",
    d: "M277.706,32.023a.589.589,0,0,1,.38-.592c1.986-.742,10.705-3.983,11.515-3.983.914,0,2.428,2.437,3.005,4.83a25.525,25.525,0,0,1,.358,3.22s-3.654-3.7-4.485-3.873-10.133,2.176-10.442,1.958c-.211-.148-.3-1.018-.331-1.561",
    transform: "translate(92.75 9.167)",
    fill: "#4f240b"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10758",
    "data-name": "Group 10758",
    transform: "translate(392.929 224.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10757",
    "data-name": "Group 10757",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3157",
    "data-name": "Rectangle 3157",
    width: 30.267,
    height: 34.849,
    transform: "matrix(0.879, -0.478, 0.478, 0.879, -12.975, 6.779)",
    fill: "url(#linear-gradient-14)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10763",
    "data-name": "Group 10763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10762",
    "data-name": "Group 10762",
    clipPath: "url(#clip-path)"
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29293",
    "data-name": "Path 29293",
    d: "M301.124,108.1s-1.137,12.992,1.077,24.539c1.016,5.3,5.359,14,5.359,14a32.022,32.022,0,0,0-4.6,11.272c-.943,5.9-2.2,42.888-2.2,42.888a29.189,29.189,0,0,0,7.047,1.463l2.909.237s9.51-37.522,10.872-52.239c1.539-16.624-3.587-53.621-5.327-58.691s-5.545-14.527-5.545-14.527Z",
    transform: "translate(100.448 25.732)",
    fill: "#229456"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10761",
    "data-name": "Group 10761",
    transform: "translate(408.098 172.345)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10760",
    "data-name": "Group 10760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10759",
    "data-name": "Group 10759",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29294",
    "data-name": "Path 29294",
    d: "M305.923,129.2s-.056.2,2.336.756,5.994,1.961,5.932,2.629-.47,1.282-1.279.976-6.989-4.362-6.989-4.362",
    transform: "translate(-305.923 -129.195)",
    fill: "#f2f2f2"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3159",
    "data-name": "Rectangle 3159",
    width: 163.015,
    height: 71.018,
    transform: "translate(536.061 146.483)",
    fill: "#d49d6a"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29295",
    "data-name": "Path 29295",
    d: "M490.614,296.955H446.362v-.384a7.689,7.689,0,0,1,7.688-7.689h28.877a7.689,7.689,0,0,1,7.688,7.689Z",
    transform: "translate(149.08 96.483)",
    fill: "#d49d6a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3160",
    "data-name": "Rectangle 3160",
    width: 155.947,
    height: 63.961,
    transform: "translate(539.596 150.011)",
    fill: "#f7b77c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3161",
    "data-name": "Rectangle 3161",
    width: 8.907,
    height: 179.076,
    transform: "translate(613.116 213.972)",
    fill: "#d49d6a"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29296",
    "data-name": "Path 29296",
    d: "M428.985,131.37a2.523,2.523,0,0,0-.943,2.053,2.319,2.319,0,0,0,1.153,2.033,21,21,0,0,0,5.321,1.781,15.005,15.005,0,0,1,6.477,3.082,7.608,7.608,0,0,1,2.3,5.992,7.909,7.909,0,0,1-2.953,6.391,11.776,11.776,0,0,1-7.776,2.452A17.993,17.993,0,0,1,420.037,150l3.9-4.777q4.736,4.148,8.759,4.149a4.593,4.593,0,0,0,2.829-.775,2.49,2.49,0,0,0,1.027-2.1,2.441,2.441,0,0,0-1.091-2.1,14.226,14.226,0,0,0-4.315-1.571,18.791,18.791,0,0,1-7.481-3.164q-2.369-1.949-2.369-6.119a7.581,7.581,0,0,1,3-6.432,12.05,12.05,0,0,1,7.481-2.265,18.014,18.014,0,0,1,5.867,1.006,15.737,15.737,0,0,1,5.113,2.851l-3.31,4.778a12.905,12.905,0,0,0-7.88-2.892,3.935,3.935,0,0,0-2.577.775",
    transform: "translate(140.287 41.699)",
    fill: "#db0000"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29297",
    "data-name": "Path 29297",
    d: "M466.714,150.773a15.96,15.96,0,0,1-21.877,0,15.332,15.332,0,0,1,0-21.583,15.96,15.96,0,0,1,21.877,0,15.325,15.325,0,0,1,0,21.583M464.494,140a9.583,9.583,0,0,0-2.517-6.683,8.288,8.288,0,0,0-12.362,0,10.114,10.114,0,0,0,0,13.348,8.331,8.331,0,0,0,12.362,0A9.51,9.51,0,0,0,464.494,140",
    transform: "translate(147.087 41.699)",
    fill: "#db0000"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29298",
    "data-name": "Path 29298",
    d: "M467.6,154.651v-29.3h6.538v23.47h12.49v5.826Z",
    transform: "translate(156.174 41.867)",
    fill: "#db0000"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29299",
    "data-name": "Path 29299",
    d: "M507.826,129.19q4.19,3.834,4.19,10.665t-4.085,10.815q-4.086,3.982-12.469,3.981H485.446v-29.3H495.8q7.836,0,12.029,3.835m-4.8,17.414q2.409-2.263,2.411-6.581a8.8,8.8,0,0,0-2.411-6.642q-2.411-2.325-7.4-2.326h-3.644v17.811h4.147q4.484,0,6.9-2.262",
    transform: "translate(162.133 41.867)",
    fill: "#db0000"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29300",
    "data-name": "Path 29300",
    d: "M88.247,58.495a74.684,74.684,0,0,1,11.075-.424A60.349,60.349,0,0,1,111.514,59.2l.9,7.843A35.09,35.09,0,0,1,100.712,69.6,71.4,71.4,0,0,1,88.6,68.432Z",
    transform: "translate(29.473 19.391)",
    fill: "#898f91"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10765",
    "data-name": "Group 10765",
    transform: "translate(115.646 61.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10764",
    "data-name": "Group 10764",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3163",
    "data-name": "Rectangle 3163",
    width: 26.937,
    height: 32.417,
    transform: "translate(0)",
    fill: "url(#linear-gradient-15)"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10767",
    "data-name": "Group 10767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10766",
    "data-name": "Group 10766",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29302",
    "data-name": "Path 29302",
    d: "M89.451,67.575s6.975,4.893,14.054,4.061,10.828-3.957,10.828-3.957l-6.2,44.947s-12.649-18.505-16.6-28.707-2.082-16.344-2.082-16.344",
    transform: "translate(29.727 22.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29303",
    "data-name": "Path 29303",
    d: "M98.26,74.872l-2.9,21.652L106.016,110.4l2.5-13.4-7.132-22.747Z",
    transform: "translate(31.849 24.798)",
    fill: "#22313f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29304",
    "data-name": "Path 29304",
    d: "M93.5,67.94a27.534,27.534,0,0,0,6.455,1.353c2.393,0,9.369-1.717,9.369-1.717l.312,6.766s-4.319,1.25-5.517,1.354-6.246.468-8.068-.156a26.845,26.845,0,0,1-3.9-1.822Z",
    transform: "translate(30.777 22.57)",
    fill: "#22313f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29305",
    "data-name": "Path 29305",
    d: "M96.968,67.834a.719.719,0,0,0-.724.5c-.518,1.712-2.086,7.109-1.547,7.94a13.169,13.169,0,0,0,3.032,2.451.85.85,0,0,0,.45.133l3.95.013a.738.738,0,0,0,.5-.181c.559-.494,2.082-1.853,2.545-2.416.571-.7-2.531-7.488-2.737-7.864a.86.86,0,0,0-.726-.446Z",
    transform: "translate(31.59 22.656)",
    fill: "#22313f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29306",
    "data-name": "Path 29306",
    d: "M96.15,69.6l-.884-4.19-.911,3.722Z",
    transform: "translate(31.513 21.846)",
    fill: "#a5c8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29307",
    "data-name": "Path 29307",
    d: "M88.51,60.052,98.155,67.2,95.613,81.03l-9.913-10Z",
    transform: "translate(28.623 20.057)",
    fill: "#cbedfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29308",
    "data-name": "Path 29308",
    d: "M109,60.052,100.89,67.2l3.953,13.1,8.08-8.974Z",
    transform: "translate(33.696 20.057)",
    fill: "#cbedfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29309",
    "data-name": "Path 29309",
    d: "M82.715,179.727l-6.4,88.229L65.537,286.694l.99,64.129,18.114-.312s9.16-63.661,13.533-75.216a99.948,99.948,0,0,1,8.588-17.958l13.431-68.708,2.029-23.269L84.9,164.267Z",
    transform: "translate(21.889 54.863)",
    fill: "#3e4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29310",
    "data-name": "Path 29310",
    d: "M68.574,344.457l-1.435-.023.959-59.947,9.7-22.875,8.363-84.576,1.429.141-8.384,84.795-9.677,22.817Z",
    transform: "translate(22.423 59.128)",
    fill: "#3a3d3e"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10769",
    "data-name": "Group 10769",
    transform: "translate(238.51 124.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10768",
    "data-name": "Group 10768",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3165",
    "data-name": "Rectangle 3165",
    width: 37.469,
    height: 32.023,
    transform: "translate(-6.775 2.152) rotate(-17.622)",
    fill: "url(#linear-gradient-16)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10774",
    "data-name": "Group 10774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10773",
    "data-name": "Group 10773",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10772",
    "data-name": "Group 10772",
    transform: "translate(248.698 129.027)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10771",
    "data-name": "Group 10771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10770",
    "data-name": "Group 10770",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29312",
    "data-name": "Path 29312",
    d: "M189.848,99.266a21.148,21.148,0,0,1,4.922-2.213c4.325-1.109,7.254.758,8.3,2.832a6.471,6.471,0,0,1,.524,4.993l-6.179,2.847s-7.923.6-8.836.434c-1.4-.257-2.148-2.168-2.148-2.168Z",
    transform: "translate(-186.432 -96.723)",
    fill: "#f7ede1"
  }))))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29313",
    "data-name": "Path 29313",
    d: "M195.1,106.384a5.433,5.433,0,0,0,5.3-4.331l-.85-.172a4.56,4.56,0,0,1-4.452,3.636Z",
    transform: "translate(65.161 34.027)",
    fill: "#989a9c"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29314",
    "data-name": "Path 29314",
    d: "M194,107.62l.007,5.452.634,1.443-.63.9,0,1.95.706,1.409-.7,1.551.444.84-.442.759.308.784-.306.756v.9a4.188,4.188,0,0,0,4.194,4.182l-.028-20.938Z",
    transform: "translate(64.792 35.942)",
    fill: "#bcbec0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29315",
    "data-name": "Path 29315",
    d: "M190.614,106.7l0,2.98a3.694,3.694,0,0,0,3.678,3.678l5.858-.008a3.7,3.7,0,0,0,3.678-3.687l0-2.98A3.7,3.7,0,0,0,200.14,103l-5.858.008a3.688,3.688,0,0,0-3.668,3.687m2.485-.87a1.39,1.39,0,0,1,1.385-1.389l5.459-.007a1.387,1.387,0,0,1,0,2.773l-5.457.007a1.39,1.39,0,0,1-1.389-1.385",
    transform: "translate(63.663 34.401)",
    fill: "#7d7e80"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29316",
    "data-name": "Path 29316",
    d: "M196.46,107.968V107.1a4.547,4.547,0,1,1,4.452-3.636l.85.172a5.416,5.416,0,1,0-5.3,4.331",
    transform: "translate(63.804 32.443)",
    fill: "#989a9c"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10776",
    "data-name": "Group 10776",
    transform: "translate(242.438 131.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10775",
    "data-name": "Group 10775",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3168",
    "data-name": "Rectangle 3168",
    width: 21.796,
    height: 10.811,
    transform: "translate(-1.366 0.089) rotate(-5.797)",
    fill: "url(#linear-gradient-17)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10784",
    "data-name": "Group 10784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10783",
    "data-name": "Group 10783",
    clipPath: "url(#clip-path)"
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29318",
    "data-name": "Path 29318",
    d: "M106.587,170.32s.312,18.426.936,22.175,8.59,56.841,8.59,56.841l-11.088,17.958s4.061,48.876,5.935,57.309,3.175,22.7,3.175,22.7l20.769-1.094s-3.019-15.2-1.3-66.263S140,174.067,140,174.067l-35.136-13.429Z",
    transform: "translate(35.025 53.651)",
    fill: "#3e4143"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29319",
    "data-name": "Path 29319",
    d: "M116.253,339.751l-7.545-73.26,8.842-24.852-10.888-60.06,1.413-.255,10.956,60.436-8.862,24.907,7.512,72.937Z",
    transform: "translate(35.624 60.56)",
    fill: "#3a3d3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10779",
    "data-name": "Group 10779",
    transform: "translate(104.305 219.069)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10778",
    "data-name": "Group 10778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10777",
    "data-name": "Group 10777",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29320",
    "data-name": "Path 29320",
    d: "M78.19,183.823l39.263,2.108.6-3.707,30.427-5.488.224-2.825-31.219-9.689L78.729,175.435Z",
    transform: "translate(-78.19 -164.221)",
    fill: "#e1edf7"
  }))))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29321",
    "data-name": "Path 29321",
    d: "M122.387,216.424,79.6,216.58,82.568,152.4l-7.027-26.39S61.485,89.625,61.329,87.594c-.111-1.439.168-9.945.339-14.774a4.3,4.3,0,0,1,3.394-4.053L95.1,59.534s3.862,25.25,9.639,36.806a89.336,89.336,0,0,0,12.649,18.972s5.417,65.539,6.012,82.763c.16,4.653-1.015,18.349-1.015,18.349",
    transform: "translate(20.475 19.884)",
    fill: "#3f4243"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29322",
    "data-name": "Path 29322",
    d: "M92.213,214.22l-1.435-.023,1.2-75.238L68.522,65.668l1.367-.439,23.522,73.517Z",
    transform: "translate(22.885 21.786)",
    fill: "#3a3d3e"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29323",
    "data-name": "Path 29323",
    d: "M91.707,58.386A111.2,111.2,0,0,0,98.5,87.2a266.648,266.648,0,0,0,13.352,28.5A113.657,113.657,0,0,1,90.38,96.1C79.449,83.372,77.966,81.263,77.966,81.263l9.056-5.621-9.135.78L80.356,61.5Z",
    transform: "translate(26.013 19.5)",
    fill: "#515557"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29324",
    "data-name": "Path 29324",
    d: "M132.046,69.851s18.277,43.425,24.357,57.015c18.265-10.612,45.35-16.541,45.35-16.541l6.452,12.1s-28.362,16.08-52.043,23.669c-8.191,2.625-30.051-28.106-30.579-28.9-1.8-2.721,6.462-47.337,6.462-47.337",
    transform: "translate(41.858 23.329)",
    fill: "#3e4143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10782",
    "data-name": "Group 10782",
    transform: "translate(166.374 115.026)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10781",
    "data-name": "Group 10781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10780",
    "data-name": "Group 10780",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29325",
    "data-name": "Path 29325",
    d: "M125.788,111.718c.958,1.257,1.924,2.773,3.063,4.185,1.2-15.15,3.068-29.676,3.068-29.676s-4.255,13.2-7.2,24.888c.427.388.71.132,1.069.6",
    transform: "translate(-124.719 -86.227)",
    fill: "#e1edf7"
  }))))), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29326",
    "data-name": "Path 29326",
    d: "M111.624,61.45l25.051,8.019a3.323,3.323,0,0,1,2.711,3.188c.123,5.247.3,16.782-.329,21.845-.834,6.662-8.329,31.648-8.538,37.477s12.493,76.83,12.493,76.83l-32.9,5-6.766-99.134Z",
    transform: "translate(34.517 20.524)",
    fill: "#434648"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29327",
    "data-name": "Path 29327",
    d: "M130.211,207.949c-.111-.792-11.1-79.324-11.811-84.051-.726-4.837,6.929-55.131,7.256-57.269l1.418.216c-2.752,18.042-7.809,53.141-7.254,56.84.711,4.733,11.7,83.273,11.814,84.065Z",
    transform: "translate(39.528 22.253)",
    fill: "#3f4243"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29328",
    "data-name": "Path 29328",
    d: "M84.355,148.112l21.35-1.734v5.561l-21.531,1.2Z",
    transform: "translate(28.113 48.888)",
    fill: "#515557"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29329",
    "data-name": "Path 29329",
    d: "M112.017,144.943l17.284.419.419,4.425-17.164.419Z",
    transform: "translate(37.412 48.409)",
    fill: "#626669"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29330",
    "data-name": "Path 29330",
    d: "M106.471,58.913s.468,14.444-.468,24.673-2.655,31.933-2.655,31.933,7.964-13.273,11.008-22.174,5.467-15.07,5.467-15.07L111,75.465l8.9-2.185-2.4-10.556Z",
    transform: "translate(34.517 19.676)",
    fill: "#515557"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29331",
    "data-name": "Path 29331",
    d: "M101,65.41l-.455,4.2,1.621-.339Z",
    transform: "translate(33.582 21.846)",
    fill: "#a5c8d9"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10786",
    "data-name": "Group 10786",
    transform: "translate(90.216 220.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10785",
    "data-name": "Group 10785",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3172",
    "data-name": "Rectangle 3172",
    width: 39.037,
    height: 30.085,
    transform: "translate(-6.089 34.251) rotate(-79.919)",
    fill: "url(#linear-gradient-18)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10791",
    "data-name": "Group 10791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10790",
    "data-name": "Group 10790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10789",
    "data-name": "Group 10789",
    transform: "translate(96.891 146.292)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10788",
    "data-name": "Group 10788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10787",
    "data-name": "Group 10787",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29333",
    "data-name": "Path 29333",
    d: "M72.633,109.665c1.435,1.435,10.652,17.116,10.354,20.531-.922,10.588-5.259,39.6-5.259,39.6l1.848-34.364Z",
    transform: "translate(-72.633 -109.665)",
    fill: "#e1edf7"
  }))))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29334",
    "data-name": "Path 29334",
    d: "M65,69.092C64.093,75.078,56.058,109.3,53.35,126.3c-1.283,8.065-2.27,19.057-1.23,21.244s4.241,12.11,8.507,23.765c3.62,9.885,12.2,40.025,12.2,40.025l16.052-4.5s-5.693-25.582-7.4-31.928c-3.618-13.44-8.6-32.234-8.6-32.234s4.31-12.937,6.6-18.871S65.5,74.453,65,69.092",
    transform: "translate(17.262 23.076)",
    fill: "#46494b"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29335",
    "data-name": "Path 29335",
    d: "M110.573,317.293l15.059.109,4.8-2.511,10.585,3.492,20.861-.109-.072-4.712-.747-.359-.109-5.605s-15.785-3.183-20.8-5.146-5.565-5.02-5.565-5.02-7.857,1.964-14.078,2.837a37.6,37.6,0,0,1-9.821.327,54.446,54.446,0,0,0-1.091,8.076,73.607,73.607,0,0,0,.982,8.62",
    transform: "translate(36.602 99.339)",
    fill: "#32393f"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29336",
    "data-name": "Path 29336",
    d: "M90.458,311.921,89.3,305.415a3.081,3.081,0,0,0-3.045-2.54l-18.432.083a3.076,3.076,0,0,0-2.977,2.346c-.447,1.829-1.073,4.422-1.563,6.617h-1.92v6.455H92.8v-6.455Z",
    transform: "translate(20.494 101.157)",
    fill: "#32393f"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10793",
    "data-name": "Group 10793",
    transform: "translate(112.525 9.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10792",
    "data-name": "Group 10792",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3175",
    "data-name": "Rectangle 3175",
    width: 55.755,
    height: 72.305,
    transform: "translate(-10.173 1.607) rotate(-8.982)",
    fill: "url(#linear-gradient-19)"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10795",
    "data-name": "Group 10795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10794",
    "data-name": "Group 10794",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29338",
    "data-name": "Path 29338",
    d: "M87.206,29.065s.712,16.364,4.425,21.021,13.376,5.835,13.376,5.835l.931,7.888s-12.71-3.715-16.455-11.86c-2.828-6.154-2.731-7.481-2.785-9.03a121.759,121.759,0,0,1,.508-13.853",
    transform: "translate(28.949 9.707)",
    fill: "#6e4433"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29339",
    "data-name": "Path 29339",
    d: "M89.539,37.279l4.03-10.46s3.262-5.6,2.165-6.817-9.769-9.757-9.769-9.757S78.2,11.968,81.838,26.09a126.013,126.013,0,0,1,3.048,20.086l3.447-8.313Z",
    transform: "translate(27.009 3.422)",
    fill: "#7a4535"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10797",
    "data-name": "Group 10797",
    transform: "translate(107.958 39.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10796",
    "data-name": "Group 10796",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3177",
    "data-name": "Rectangle 3177",
    width: 17.063,
    height: 17.57,
    transform: "matrix(0.744, -0.669, 0.669, 0.744, -8.466, 6.991)",
    fill: "url(#linear-gradient-20)"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10799",
    "data-name": "Group 10799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10798",
    "data-name": "Group 10798",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29341",
    "data-name": "Path 29341",
    d: "M86.614,32.659c-.568-.295-2.644-1.63-3.806-.742-.466.359-.868,1.3-.395,2.769.221.692,1.829,5.882,2.322,6.351a2.954,2.954,0,0,0,1.31.618s-2.521-5.955-2.322-7.018,2.891-1.978,2.891-1.978",
    transform: "translate(27.454 10.56)",
    fill: "#b06a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29342",
    "data-name": "Path 29342",
    d: "M94.34,28.481s2.116-2.769,2.693-3.438,2.78-.883,4.075-.924c1.439-.048,7.985-.406,7.985-.406s.009,3.176,0,3.306c-.024.3-6.287-1.265-9.257-.8s-4.709,2.727-5.173,2.773-.324-.511-.324-.511",
    transform: "translate(31.502 7.92)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29343",
    "data-name": "Path 29343",
    d: "M110.83,23.737s5.972.568,6.9.2,1.718-.476,2.14.2a22.11,22.11,0,0,1,1.39,3.271c-.081.151-.855-1.874-3.116-1.8a32.866,32.866,0,0,0-6.1,1.186c-.442.1-.707.193-.718.009-.06-.943-.5-3.062-.5-3.062",
    transform: "translate(37.016 7.896)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29344",
    "data-name": "Path 29344",
    d: "M106.25,33.684a5.045,5.045,0,0,1-1.724,1.549,4.658,4.658,0,0,1-2.206.73,8.924,8.924,0,0,1-1.942-.219,20.058,20.058,0,0,1-3.448-1.066A5.357,5.357,0,0,1,94.8,33.217a14.1,14.1,0,0,1,5.681-3.375l.015-.015c.336-.1.687-.175,1.038-.248a6.333,6.333,0,0,1,2.118.1,26.638,26.638,0,0,1,3.447.935,5.922,5.922,0,0,1-.847,3.068",
    transform: "translate(31.661 9.862)",
    fill: "#fff"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10801",
    "data-name": "Group 10801",
    transform: "translate(130.625 39.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10800",
    "data-name": "Group 10800",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3179",
    "data-name": "Rectangle 3179",
    width: 6.523,
    height: 7.133,
    transform: "matrix(0.999, -0.052, 0.052, 0.999, -0.355, 0.019)",
    fill: "url(#linear-gradient-21)"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10803",
    "data-name": "Group 10803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10802",
    "data-name": "Group 10802",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29346",
    "data-name": "Path 29346",
    d: "M102.184,30.668c0-.347-.416-.628-.931-.628s-.931.281-.931.628.418.628.931.628.931-.281.931-.628",
    transform: "translate(33.506 10.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29347",
    "data-name": "Path 29347",
    d: "M94.239,34.027a13,13,0,0,1,8.676-4,10.694,10.694,0,0,1,4.37.766s-1.673-1.729-2.768-1.785a11.744,11.744,0,0,0-10.046,4.255,1.931,1.931,0,0,0-.232.766",
    transform: "translate(31.475 9.681)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29348",
    "data-name": "Path 29348",
    d: "M105.978,44.517c.033-.556.9-1.114,2.4-.835s3.654.209,4-.418-.313-4.071-1.149-6.4a48.614,48.614,0,0,1-1.5-7.029s.452-.73.592.209,1.914,6.75,2.609,9.6,1.218,4.664,0,4.8a29.983,29.983,0,0,1-4.974.035c-.767-.139-.836.452-1.219.418a1.6,1.6,0,0,1-.764-.383",
    transform: "translate(35.395 9.874)",
    fill: "#89452e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29349",
    "data-name": "Path 29349",
    d: "M118.543,29.358a12.986,12.986,0,0,1-.233,2.381,7.425,7.425,0,0,1-.6,1.622l-.015.015a2.237,2.237,0,0,1-.891,1.051,3.849,3.849,0,0,1-2.221.351,8.266,8.266,0,0,1-1.27-.22c-2.425-.627-2.484-1.343-2.484-1.431a8.745,8.745,0,0,1,2.747-2.76,1.96,1.96,0,0,1,.379-.22,9.367,9.367,0,0,1,2.893-.847,6.148,6.148,0,0,1,1.694.059",
    transform: "translate(37.016 9.776)",
    fill: "#fff"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10805",
    "data-name": "Group 10805",
    transform: "translate(150.226 38.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10804",
    "data-name": "Group 10804",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3181",
    "data-name": "Rectangle 3181",
    width: 4.981,
    height: 6.213,
    transform: "translate(-0.311 0.016) rotate(-2.984)",
    fill: "url(#linear-gradient-22)"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10807",
    "data-name": "Group 10807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10806",
    "data-name": "Group 10806",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29351",
    "data-name": "Path 29351",
    d: "M114.876,30.657c0-.321-.362-.583-.807-.583s-.808.261-.808.583.362.583.808.583.807-.261.807-.583",
    transform: "translate(37.828 10.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29352",
    "data-name": "Path 29352",
    d: "M110.647,33.95a5.916,5.916,0,0,1,2.261-3.839c1.275-1.038,3.863-1.728,4.79-1.2s.906.627.906.627a6.883,6.883,0,0,0-2.6.116,13.693,13.693,0,0,0-3.851,2.3,13.049,13.049,0,0,0-1.507,1.994",
    transform: "translate(36.955 9.596)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29353",
    "data-name": "Path 29353",
    d: "M117.939,16.72c.723,1.553.707,3.15,1.529,5.22a59.182,59.182,0,0,1,1.773,7.694s-.4-12.972-.551-15.106c-.415-5.939-4.95-2.565-4.95-2.565s-4.89-.284-5.057,1.273c-.12,1.115,6.534,1.933,7.257,3.484",
    transform: "translate(36.966 3.677)",
    fill: "#7a4535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29354",
    "data-name": "Path 29354",
    d: "M85.545,16.517s-2.971-3.8,1.546-8.429S110.715-1.7,115.684.539s12.906,8.583,13.625,12.326-4.263,14.472-4.263,14.472.475-9.359-10.346-8.775c-16.679.9-19.982,5.971-19.982,5.971Z",
    transform: "translate(28.251 0)",
    fill: "#854c3a"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10809",
    "data-name": "Group 10809",
    transform: "translate(107.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10808",
    "data-name": "Group 10808",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29355",
    "data-name": "Path 29355",
    d: "M95.15,22.783c-.329-.271-8.1-6.651-10.16-9.2C83.956,12.3,83.387,8.7,83.326,8.3l1.445-.217c.209,1.382.763,3.85,1.357,4.585C88.092,15.1,96,21.588,96.076,21.653Z",
    transform: "translate(-80.048 2.699)",
    fill: "#6b3d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29356",
    "data-name": "Path 29356",
    d: "M125.658,27.882l-1.409-.39c.032-.113,3.114-11.459.1-15.825a17.5,17.5,0,0,0-11.546-7.316c-3.967-.631-14.022,1.431-18.233,3.056-3.881,1.5-8.455,8.308-8.5,8.376l-1.217-.81c.2-.3,4.882-7.268,9.191-8.93,3.963-1.529,14.46-3.847,18.987-3.138a18.978,18.978,0,0,1,12.521,7.932c3.4,4.925.239,16.551.1,17.043",
    transform: "translate(-79.537 0.927)",
    fill: "#6b3d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29357",
    "data-name": "Path 29357",
    d: "M123.6,26.045a31.854,31.854,0,0,0-5.377-14.2c-2.419-3.528-13.03-2.856-19.792-1.254-5.737,1.359-8.795,7.7-8.826,7.765l-1.321-.623c.135-.287,3.378-7.039,9.81-8.564,4.8-1.137,17.992-3.023,21.333,1.85a32.686,32.686,0,0,1,5.629,14.927Z",
    transform: "translate(-78.392 2.619)",
    fill: "#6b3d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29358",
    "data-name": "Path 29358",
    d: "M95.387,25.547a50.943,50.943,0,0,1-8.706-3.766c-3.48-2.085-6.465-7.4-6.589-7.621l1.275-.711c.029.052,2.921,5.2,6.064,7.079a50.534,50.534,0,0,0,8.405,3.628Z",
    transform: "translate(-81.128 4.492)",
    fill: "#6b3d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29359",
    "data-name": "Path 29359",
    d: "M92.826,28.457c-.163-.033-4-.826-5.535-1.385-1.519-.552-6.731-2.98-6.953-3.083l.618-1.325c.053.025,5.375,2.5,6.834,3.035,1.441.523,5.292,1.319,5.331,1.326Z",
    transform: "translate(-81.046 7.57)",
    fill: "#6b3d2f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10817",
    "data-name": "Group 10817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10816",
    "data-name": "Group 10816",
    clipPath: "url(#clip-path)"
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29361",
    "data-name": "Path 29361",
    d: "M119.327,43.613c-1.183-1.1-6.722-1.453-6.722-1.453s-10.284.627-11.57,1.461c-1.271.818-1.826,12.592-1.343,13.5.467.92.658,2.286,5.084,3.6,4.411,1.3,9.918,1.467,11.876-.444s3.426-9.823,3.426-9.823-.359.864-.32.474c.172-1.716.544-6.42-.431-7.313m-1.374,6.839c-.136.962-.091,2.816-5.974,3.2-1.134.075-6.793-.359-8.049-2.009a8.057,8.057,0,0,1-1.369-5.508c1.082-.291,8.886-.791,10.256-.914a23.6,23.6,0,0,1,4.992.852,9.432,9.432,0,0,1,.144,4.374",
    transform: "translate(33.238 14.081)",
    fill: "#6e4433"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29362",
    "data-name": "Path 29362",
    d: "M102.117,45.3s1.776,3.208,3.027,3.723c1.776.731,11,.244,11.379-.173s.371-2.576-.081-2.576-6.391.592-8.444.418a43.663,43.663,0,0,1-5.88-1.391",
    transform: "translate(34.106 15.131)",
    fill: "#fff"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29363",
    "data-name": "Path 29363",
    d: "M131,31.149a7.047,7.047,0,0,0-.379-1.8,4.168,4.168,0,0,0-1.519-2.06,5.091,5.091,0,0,0-3.142-.847,21,21,0,0,0-3.344.41,5.521,5.521,0,0,0-3.258,1.869,3.615,3.615,0,0,0-.468.876c-.16.015-.351.015-.584.029-.292,0-.628.015-.994.029s-.73.015-1.154.015a20.82,20.82,0,0,0-2.161.161c-.263.015-.483.029-.658.043a4.21,4.21,0,0,0-.658-1.007,5.766,5.766,0,0,0-2.585-1.3,16.224,16.224,0,0,0-3.857-.336,21.6,21.6,0,0,0-4.119.351,5.969,5.969,0,0,0-3.8,2.1c-.087.132-.145.277-.219.41l-12.768.73,1.94,1.043L97.5,31.806a7.94,7.94,0,0,0-.059,1.942,5.986,5.986,0,0,0,1.988,3.682,8.689,8.689,0,0,0,3.71,1.958,10.316,10.316,0,0,0,3.974.248,9.407,9.407,0,0,0,3.374-1.139,7.519,7.519,0,0,0,3.4-3.77,5.606,5.606,0,0,0,.351-1.387c.029-.336.044-.511.044-.511V32.8s0-.161-.015-.468a5.447,5.447,0,0,0-.235-1.154c.073-.029.147-.059.235-.088.263-.087.57-.175.906-.277a8.3,8.3,0,0,1,1.066-.175,4.6,4.6,0,0,1,1.1-.044,3.738,3.738,0,0,1,.95.117,2.251,2.251,0,0,1,.351.072,6.5,6.5,0,0,0,.015,1.418,8,8,0,0,0,1.1,3.258,7.1,7.1,0,0,0,2.4,2.483,5.15,5.15,0,0,0,3.331.672,6.676,6.676,0,0,0,2.863-.935,5.324,5.324,0,0,0,1.725-1.768,6.087,6.087,0,0,0,.686-1.68,6.582,6.582,0,0,0,.191-1.125c.029-.264.043-.41.043-.41v-.015s.015-.131.029-.38A10.585,10.585,0,0,0,131,31.149m-17.837,2.1a4.624,4.624,0,0,1-.233,1.183,6.6,6.6,0,0,1-2.877,3.462,7.987,7.987,0,0,1-3.024,1.067,8.918,8.918,0,0,1-3.652-.263,7.645,7.645,0,0,1-3.287-1.841,5.139,5.139,0,0,1-.715-6.545,4.817,4.817,0,0,1,3.054-1.475,20.985,20.985,0,0,1,3.8-.277,16.219,16.219,0,0,1,3.462.233,4.689,4.689,0,0,1,2.089.906,4.623,4.623,0,0,1,1.053,1.593,4.255,4.255,0,0,1,.321,1.1,2.142,2.142,0,0,0,.043.452,2.525,2.525,0,0,0-.029.41m17.063-.584s-.015.132-.029.38a6.573,6.573,0,0,1-.16,1.037,4.778,4.778,0,0,1-2.074,3.083,5.985,5.985,0,0,1-2.543.788,4.244,4.244,0,0,1-2.819-.628,6.82,6.82,0,0,1-2.893-5.185,3.868,3.868,0,0,1,.687-2.761,4.25,4.25,0,0,1,2.556-1.242,25.834,25.834,0,0,1,3.068-.394,3.935,3.935,0,0,1,2.337.467,3.249,3.249,0,0,1,1.315,1.475,4.814,4.814,0,0,1,.467,1.549,8.4,8.4,0,0,1,.088,1.431",
    transform: "translate(28.501 8.831)",
    fill: "#6f4127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10812",
    "data-name": "Group 10812",
    transform: "translate(148.193 36.559)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10811",
    "data-name": "Group 10811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10810",
    "data-name": "Group 10810",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29364",
    "data-name": "Path 29364",
    d: "M119.753,27.89a3.935,3.935,0,0,0-2.337-.467,25.835,25.835,0,0,0-3.068.394,4.25,4.25,0,0,0-2.556,1.242,3.861,3.861,0,0,0-.687,2.761,7.417,7.417,0,0,0,.763,2.717c.025.019.053.035.079.052.78-1.321,2.02-3.376,3.877-4.307a44.934,44.934,0,0,1,4.415-2.042,2.545,2.545,0,0,0-.486-.35",
    transform: "translate(-111.09 -27.406)",
    fill: "#053261"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10815",
    "data-name": "Group 10815",
    transform: "translate(127.027 37.392)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10814",
    "data-name": "Group 10814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10813",
    "data-name": "Group 10813",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29365",
    "data-name": "Path 29365",
    d: "M104.7,30.978c1.4-.267,4.1-.121,4.828-.215a4.606,4.606,0,0,0-1.051-1.591,4.674,4.674,0,0,0-2.089-.906,16.225,16.225,0,0,0-3.463-.233,20.875,20.875,0,0,0-3.8.277,4.817,4.817,0,0,0-3.053,1.475,5.06,5.06,0,0,0-.832,3.359,4.838,4.838,0,0,0,1.082,2.64c2.68-2.623,3.6-3.9,8.377-4.806",
    transform: "translate(-95.224 -28.03)",
    fill: "#053261"
  }))))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10819",
    "data-name": "Group 10819",
    transform: "translate(391.836 204.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10818",
    "data-name": "Group 10818",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3186",
    "data-name": "Rectangle 3186",
    width: 6.856,
    height: 4.769,
    transform: "matrix(0.977, -0.212, 0.212, 0.977, -0.729, 0.158)",
    fill: "url(#linear-gradient-23)"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10821",
    "data-name": "Group 10821",
    transform: "translate(391.836 200.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10820",
    "data-name": "Group 10820",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3187",
    "data-name": "Rectangle 3187",
    width: 23.012,
    height: 20.488,
    transform: "translate(-3.442 0.745) rotate(-12.216)",
    fill: "url(#linear-gradient-24)"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10823",
    "data-name": "Group 10823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10822",
    "data-name": "Group 10822",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29368",
    "data-name": "Path 29368",
    d: "M334.881,59.054l-5.445,34.278a129.583,129.583,0,0,0,29.328,2.688c13.747-.195,16.253-2.627,16.253-2.627s-8.28-17.97-1.65-52.55c-14.42-17.354-38.486,18.21-38.486,18.21",
    transform: "translate(110.028 12.048)",
    fill: "#451f0a"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10825",
    "data-name": "Group 10825",
    transform: "translate(439.464 48.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10824",
    "data-name": "Group 10824",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3189",
    "data-name": "Rectangle 3189",
    width: 11.139,
    height: 1.55,
    transform: "translate(2.348 59.153) rotate(-80.887)",
    fill: "#361807"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3190",
    "data-name": "Rectangle 3190",
    width: 11.113,
    height: 1.55,
    transform: "matrix(0.111, -0.994, 0.994, 0.111, 9.702, 59.877)",
    fill: "#361807"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29369",
    "data-name": "Path 29369",
    d: "M344.749,85.591l-1.547-.12c1.225-15.8,1.53-16.216,1.693-16.439l1.25.918-.626-.459.714.3c-.253.835-1.046,10.137-1.483,15.8",
    transform: "translate(-324.838 -25.064)",
    fill: "#361807"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3191",
    "data-name": "Rectangle 3191",
    width: 1.55,
    height: 12.19,
    transform: "translate(34.19 48.277)",
    fill: "#361807"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10827",
    "data-name": "Group 10827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10826",
    "data-name": "Group 10826",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29371",
    "data-name": "Path 29371",
    d: "M319.867,47.22s-1.926-9.211,5.987-17.4a34.977,34.977,0,0,1,25.424-10.859c16.14.88,22.966,12.541,25.231,18.588,4.186,11.173.544,25.559.092,38.155-.358,9.982,1.68,23.407,1.68,23.407s-11.467-6.144-13.036-11.426a49.671,49.671,0,0,1-1.553-12.009s-8.614-18.206-10.785-24.309-9.127-15.958-9.127-15.958-16.213,11.232-20.246,14.024-3.667-2.214-3.667-2.214",
    transform: "translate(106.763 6.327)",
    fill: "#4f240b"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10829",
    "data-name": "Group 10829",
    transform: "translate(460.145 74.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10828",
    "data-name": "Group 10828",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3193",
    "data-name": "Rectangle 3193",
    width: 11.648,
    height: 38.301,
    transform: "translate(-0.855 0.019) rotate(-1.287)",
    fill: "url(#linear-gradient-25)"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10831",
    "data-name": "Group 10831",
    transform: "translate(428.837 35.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10830",
    "data-name": "Group 10830",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3194",
    "data-name": "Rectangle 3194",
    width: 69.937,
    height: 49.397,
    transform: "matrix(0.049, -0.999, 0.999, 0.049, -3.459, 67.601)",
    fill: "url(#linear-gradient-26)"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10833",
    "data-name": "Group 10833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10832",
    "data-name": "Group 10832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29374",
    "data-name": "Path 29374",
    d: "M333.69,43.909s.79-.155,1.974-.39c.592-.12,1.283-.253,2.02-.427.368-.087.75-.172,1.139-.247s.783-.16,1.181-.219c.1-.017.2-.027.3-.039l.084-.007h.281a3.591,3.591,0,0,1,.744.153,6.253,6.253,0,0,1,1.145.506c.691.376,1.275.794,1.784,1.133,1.006.691,1.634,1.207,1.634,1.207a.172.172,0,0,1,.025.244.175.175,0,0,1-.227.039s-.682-.42-1.746-.96a14.538,14.538,0,0,0-1.86-.783,8.858,8.858,0,0,0-1.038-.284,3.1,3.1,0,0,0-.43-.053l-.149.005-.076,0h-.065c-.016,0,.121-.009.061-.005h-.005c-.1.016-.2.033-.3.044-.4.053-.8.077-1.2.115s-.784.059-1.162.076c-.755.032-1.457.092-2.058.139-1.2.1-2,.165-2,.165a.211.211,0,0,1-.229-.193.214.214,0,0,1,.172-.227",
    transform: "translate(111.391 14.222)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29375",
    "data-name": "Path 29375",
    d: "M333.092,50.413a4.8,4.8,0,0,0,4.078,2.652c5.9-.1,7.113-4.227,7.113-4.227s-4.782-2.285-6.515-1.889c-3.847.878-4.676,3.464-4.676,3.464",
    transform: "translate(111.249 15.665)",
    fill: "#fff"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10835",
    "data-name": "Group 10835",
    transform: "translate(445.834 62.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10834",
    "data-name": "Group 10834",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3196",
    "data-name": "Rectangle 3196",
    width: 5.337,
    height: 5.923,
    transform: "translate(-0.099 0.002) rotate(-0.971)",
    fill: "url(#linear-gradient-27)"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10837",
    "data-name": "Group 10837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10836",
    "data-name": "Group 10836",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29377",
    "data-name": "Path 29377",
    d: "M332.541,51.472a5.717,5.717,0,0,1,.253-.712,8.752,8.752,0,0,1,.975-1.75,7.211,7.211,0,0,1,.882-1.049,5.689,5.689,0,0,1,1.257-.967,4.359,4.359,0,0,1,1.7-.595,6.581,6.581,0,0,1,1.74.025,16.324,16.324,0,0,1,3.16.771c.488.156.943.349,1.378.519s.832.362,1.2.532a18.847,18.847,0,0,1,2.376,1.31.162.162,0,0,1-.129.291s-1.053-.252-2.589-.675c-.77-.207-1.663-.452-2.617-.688-.475-.127-.967-.241-1.466-.34a13.627,13.627,0,0,0-1.5-.267,6.663,6.663,0,0,0-1.443-.061,4.164,4.164,0,0,0-1.219.338,8.163,8.163,0,0,0-2.076,1.437c-.567.526-1.018,1.012-1.329,1.362s-.482.562-.482.562a.045.045,0,0,1-.064.007.048.048,0,0,1-.016-.048",
    transform: "translate(111.064 15.481)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29378",
    "data-name": "Path 29378",
    d: "M337.864,48.575c.3.528.334,1.081.067,1.233s-.727-.152-1.03-.682-.332-1.081-.067-1.233.727.153,1.03.682",
    transform: "translate(112.438 15.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29379",
    "data-name": "Path 29379",
    d: "M322.563,49.031s.871,3.531,3.843,3.594a4.567,4.567,0,0,0,4.512-3.236s-2.829-2.194-4.938-2.158a5.78,5.78,0,0,0-3.416,1.8",
    transform: "translate(107.732 15.774)",
    fill: "#fff"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10839",
    "data-name": "Group 10839",
    transform: "translate(431.618 62.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10838",
    "data-name": "Group 10838",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29380",
    "data-name": "Path 29380",
    d: "M323.559,52.775l-.1-5.977,4.822.064.1,5.977Z",
    transform: "translate(-323.586 -46.863)",
    fill: "url(#linear-gradient-28)"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10841",
    "data-name": "Group 10841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10840",
    "data-name": "Group 10840",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29382",
    "data-name": "Path 29382",
    d: "M326.654,48.63c.215.559.208,1.117-.013,1.245s-.576-.221-.79-.78-.208-1.117.013-1.245.575.221.79.78",
    transform: "translate(108.778 15.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29383",
    "data-name": "Path 29383",
    d: "M331.059,49a6.566,6.566,0,0,0-3.294-2.372,5.181,5.181,0,0,0-1.9-.235,3.887,3.887,0,0,0-1.862.678,5.547,5.547,0,0,0-1.434,1.513,6.909,6.909,0,0,0-.894,1.988.233.233,0,0,0,.055.221.139.139,0,0,0,.227-.044,6.848,6.848,0,0,1,2.493-2.572,3.452,3.452,0,0,1,1.5-.407,3.1,3.1,0,0,1,.386.011l.187.019.217.033a8.089,8.089,0,0,1,3.666,1.549,8.687,8.687,0,0,1,1.622,2.505A6.566,6.566,0,0,0,331.059,49",
    transform: "translate(107.435 15.488)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29384",
    "data-name": "Path 29384",
    d: "M327.956,61.936c.56-2.02,3.418-11.46,3.7-12.577.036-.151.1-1.161-.1-1.219a6.665,6.665,0,0,0-.411,1.086c-.308,1.075-3.8,10.677-4.685,12.769a.655.655,0,0,0,.327.856s4.905,2.683,5.095,2.408a.191.191,0,0,0,.008-.205c-.009-.02-3.331-2.707-3.934-3.118",
    transform: "translate(109.016 16.078)",
    fill: "#89452e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29385",
    "data-name": "Path 29385",
    d: "M331.036,44.205s-.165-.011-.455-.033l-1.194-.115c-.975-.116-2.277-.271-3.578-.428a8.51,8.51,0,0,0-.914-.064c-.16,0-.149.011-.179.028a1.963,1.963,0,0,0-.288.224c-.41.375-.8.8-1.138,1.15-.671.711-1.173,1.162-1.173,1.162a.184.184,0,0,1-.295-.2,8.8,8.8,0,0,1,.786-1.493c.141-.211.288-.444.469-.675a6.534,6.534,0,0,1,.622-.718,2.926,2.926,0,0,1,.446-.364,1.257,1.257,0,0,1,.744-.193,9.746,9.746,0,0,1,1.049.091,30.425,30.425,0,0,1,3.584.771l1.155.347.434.149a.187.187,0,0,1-.076.364",
    transform: "translate(107.481 14.189)",
    fill: "#171317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29386",
    "data-name": "Path 29386",
    d: "M347.925,19.084c-7.562-.651-18.02,3.254-23.3,10.128-8.307,10.82-5.216,24.8-5.216,24.8a78.242,78.242,0,0,0,28.726-16.533c2.28-11.64,2.8-13.061-.213-18.4",
    transform: "translate(106.492 6.35)",
    fill: "#4f240b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29387",
    "data-name": "Path 29387",
    d: "M343.365,61.5c-.063.087-.459.578-1.006,1.254a54.3,54.3,0,0,1-4.177,4.71c-1.85,1.651-3.8,2.4-5.742,1.125a7.859,7.859,0,0,1-2.639-4.035s3.1,1.82,5.7,1.087c2.52-.714,7.548-3.942,7.864-4.141",
    transform: "translate(110.15 20.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29388",
    "data-name": "Path 29388",
    d: "M343.378,61.494c-.211.267-3.62,5.183-5.2,6.6-1.849,1.651-3.8,2.4-5.741,1.123s-2.639-4.657-2.639-4.657.157.5.249.759a6.987,6.987,0,0,0,2.389,3.278c1.937,1.279,3.893.528,5.741-1.123a54.552,54.552,0,0,0,4.178-4.712c.427-.528.939-1.217,1.019-1.266",
    transform: "translate(110.15 20.538)",
    fill: "#8c0c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29389",
    "data-name": "Path 29389",
    d: "M344.843,56.115c-.5-2.082-2.991-3.268-5.565-2.651s-4.257,2.805-3.757,4.888,2.991,3.268,5.565,2.651,4.255-2.807,3.757-4.888",
    transform: "translate(112.031 17.802)",
    fill: "#fa9a80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29390",
    "data-name": "Path 29390",
    d: "M344.415,45.71c.005.068-.036-.623,0,0",
    transform: "translate(115.025 15.179)",
    fill: "#96281b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29391",
    "data-name": "Path 29391",
    d: "M350.372,50.608s.143-.205.4-.518a13.4,13.4,0,0,1,1.154-1.269,7.421,7.421,0,0,1,.9-.758,2.394,2.394,0,0,1,.631-.324,1.116,1.116,0,0,1,.921.083A1.665,1.665,0,0,1,355,49.354c-.008.141-.025.281-.04.422s-.057.243-.087.364a5.63,5.63,0,0,1-.223.7c-.075.232-.171.451-.263.67s-.183.438-.285.647c-.192.426-.408.827-.614,1.218-.418.776-.846,1.477-1.217,2.072-.748,1.189-1.3,1.949-1.3,1.949a.14.14,0,0,1-.232-.157s.5-.783,1.171-2c.332-.611.715-1.326,1.082-2.11.179-.394.367-.8.528-1.219a9.789,9.789,0,0,0,.435-1.282,4.206,4.206,0,0,0,.136-.647l.052-.316a2.542,2.542,0,0,1,.012-.267,1.258,1.258,0,0,0-.209-.914c-.083-.125-.492-.067-.814.1a4.616,4.616,0,0,0-.9.587,12.7,12.7,0,0,0-1.211,1.138c-.275.3-.4.476-.4.476l0,0a.151.151,0,0,1-.244-.176",
    transform: "translate(117.011 15.924)",
    fill: "#89452e"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10843",
    "data-name": "Group 10843",
    transform: "translate(452.805 109.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10842",
    "data-name": "Group 10842",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3199",
    "data-name": "Rectangle 3199",
    width: 20.425,
    height: 25.024,
    transform: "matrix(0.511, -0.859, 0.859, 0.511, -4.382, 7.363)",
    fill: "url(#linear-gradient-29)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10866",
    "data-name": "Group 10866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10865",
    "data-name": "Group 10865",
    clipPath: "url(#clip-path)"
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29393",
    "data-name": "Path 29393",
    d: "M351.9,108.2a30.023,30.023,0,0,1-.073,3.865c-.416,6.355-1.833,17.6-2.541,21.461-.9,4.913-5.136,20.454-7,23.976s-34.209,21.349-34.209,21.349l-3.7-5.555s18.246-14.038,23.778-18.932c4.936-4.366,7.649-4.073,7.649-4.073a48.766,48.766,0,0,1-1.136-13.877c.406-8.264,1.271-25.519,3.041-36.036.814-4.84,1.159-6.794,1.833-8.691a10.145,10.145,0,0,1,1.6-3.134c.067-.075,5.812,1.2,6.569,3.112A114.461,114.461,0,0,1,351.9,108.2",
    transform: "translate(101.66 29.575)",
    fill: "#1fbdb4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10846",
    "data-name": "Group 10846",
    transform: "translate(439.879 128.623)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10845",
    "data-name": "Group 10845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10844",
    "data-name": "Group 10844",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29394",
    "data-name": "Path 29394",
    d: "M333.96,96.42a94.685,94.685,0,0,1-1.825,10.573c-.772,3.875-2.365,11.571-2.387,12.592-.04,1.889,1.729,6.613,4.1,9.582,3.436,4.3,4.578,11.542,4.578,11.542l2.2-8.9Z",
    transform: "translate(-329.747 -96.42)",
    fill: "#ededed"
  }))))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29395",
    "data-name": "Path 29395",
    d: "M335.558,159.244s-3.123,17.951-3.484,27.365S348,354.6,348,354.6l4.828.724c1.315-31.366,5.794-79.771,4.768-85.745a29.079,29.079,0,0,0-4.526-10.8s.834-8.974,1.327-11.827c2.173-12.551,4.1-38.378,3.922-47.791-.133-7-2.835-41.274-2.835-41.274Z",
    transform: "translate(110.907 52.732)",
    fill: "#edb638"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10849",
    "data-name": "Group 10849",
    transform: "translate(459.695 242.304)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10848",
    "data-name": "Group 10848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10847",
    "data-name": "Group 10847",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29396",
    "data-name": "Path 29396",
    d: "M351.063,306.661l-.9,11.4-1.094-6.821s-4.155-111.143-4.41-115.187c-.143-2.412.032-7.074.207-10.437.079-1.523.143-2.792.189-3.458v-.016c.016-.333.032-.508.032-.508l3.712,1.586Z",
    transform: "translate(-344.602 -181.639)",
    fill: "#ededed"
  }))))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29397",
    "data-name": "Path 29397",
    d: "M343.652,161.964s.332,24.348.724,26.369a24.39,24.39,0,0,0,2.112,5.189l6.2,161.958,5.069.964s9.489-78.685,10.453-83.995-2.655-12.793-2.655-12.793a230.92,230.92,0,0,1,4.465-30.835c4.01-19.478,7.482-35.541,7.061-48.7-.391-12.179-10.017-20.4-10.017-22.326s-23.413,4.163-23.413,4.163",
    transform: "translate(114.776 52.577)",
    fill: "#f9bf3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10852",
    "data-name": "Group 10852",
    transform: "translate(470.762 216.774)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10851",
    "data-name": "Group 10851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10850",
    "data-name": "Group 10850",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29398",
    "data-name": "Path 29398",
    d: "M353.624,351.435a.6.6,0,0,1-.084-.005.724.724,0,0,1-.636-.8l.337-2.92a.724.724,0,1,1,1.438.167l-.336,2.919a.725.725,0,0,1-.719.642m.674-5.836q-.042,0-.084,0a.724.724,0,0,1-.636-.8l.334-2.913a.724.724,0,0,1,1.439.165l-.335,2.913a.725.725,0,0,1-.718.642m.668-5.826c-.028,0-.055,0-.084,0a.724.724,0,0,1-.636-.8l.332-2.911a.724.724,0,1,1,1.439.164l-.332,2.911a.725.725,0,0,1-.719.642m.666-5.82q-.042,0-.084,0a.723.723,0,0,1-.636-.8l.331-2.909a.724.724,0,0,1,1.439.164l-.332,2.909a.723.723,0,0,1-.718.642m.663-5.818a.589.589,0,0,1-.084-.005.722.722,0,0,1-.636-.8l.33-2.909a.724.724,0,0,1,1.439.164l-.331,2.909a.723.723,0,0,1-.718.642m.66-5.817a.578.578,0,0,1-.083-.005.722.722,0,0,1-.638-.8l.328-2.908a.724.724,0,1,1,1.439.163l-.329,2.908a.724.724,0,0,1-.718.643m.658-5.818c-.028,0-.055,0-.083,0a.725.725,0,0,1-.639-.8l.328-2.908a.724.724,0,0,1,1.439.161l-.328,2.908a.723.723,0,0,1-.718.643m.654-5.816c-.028,0-.055,0-.083,0a.725.725,0,0,1-.639-.8l.327-2.909a.723.723,0,0,1,1.438.16l-.326,2.911a.724.724,0,0,1-.718.643m.65-5.81a.806.806,0,0,1-.081,0,.725.725,0,0,1-.64-.8l.323-2.908a.724.724,0,1,1,1.439.16l-.323,2.908a.724.724,0,0,1-.718.644m.644-5.818c-.027,0-.053,0-.081,0a.725.725,0,0,1-.64-.8l.32-2.909a.725.725,0,0,1,1.441.159l-.32,2.911a.725.725,0,0,1-.719.644m.638-5.826a.754.754,0,0,1-.077,0,.719.719,0,0,1-.643-.794l.316-2.909a.724.724,0,0,1,1.439.156l-.315,2.9a.728.728,0,0,1-.72.651m.63-5.816a.739.739,0,0,1-.077,0,.725.725,0,0,1-.643-.8l.311-2.911a.724.724,0,0,1,1.441.152l-.312,2.913a.724.724,0,0,1-.719.647m.618-5.827a.739.739,0,0,1-.076,0,.724.724,0,0,1-.644-.8c.107-1.022.207-2,.3-2.913a.724.724,0,1,1,1.441.145c-.093.92-.193,1.9-.3,2.919a.725.725,0,0,1-.72.648m.592-5.835a.633.633,0,0,1-.071,0,.724.724,0,0,1-.651-.791c.108-1.1.2-2.081.275-2.917a.724.724,0,1,1,1.442.128c-.075.84-.167,1.824-.275,2.929a.725.725,0,0,1-.72.654m.492-5.859h-.023a.725.725,0,0,1-.7-.747l0-.177c0-.036,0-.065,0-.087a15.432,15.432,0,0,0-.476-2.4.723.723,0,1,1,1.4-.363,16.338,16.338,0,0,1,.518,2.644c.005.052.008.121.008.209l0,.224a.725.725,0,0,1-.724.7m-1.291-5.687a.723.723,0,0,1-.695-.52l-.043-.144c-.261-.892-.527-1.8-.764-2.681a.724.724,0,1,1,1.4-.378c.235.87.5,1.77.756,2.652l.043.144a.725.725,0,0,1-.7.927m-1.455-5.66a.725.725,0,0,1-.714-.6,10.328,10.328,0,0,1-.161-1.673,14.5,14.5,0,0,1,.124-1.446.724.724,0,1,1,1.438.163c-.1.88-.113,1.181-.113,1.282a9.054,9.054,0,0,0,.141,1.435.721.721,0,0,1-.715.843m.333-5.83a.593.593,0,0,1-.1-.007.722.722,0,0,1-.622-.812c.113-.863.247-1.838.395-2.909a.724.724,0,0,1,1.434.2c-.148,1.069-.28,2.04-.394,2.9a.724.724,0,0,1-.718.628m.8-5.806a.665.665,0,0,1-.1-.008.725.725,0,0,1-.616-.818l.415-2.9a.724.724,0,1,1,1.433.205l-.414,2.9a.723.723,0,0,1-.715.623m.832-5.8a.939.939,0,0,1-.105-.007.724.724,0,0,1-.612-.822l.422-2.9a.724.724,0,0,1,1.433.209l-.422,2.9a.724.724,0,0,1-.715.62m.843-5.794a.706.706,0,0,1-.105-.007.724.724,0,0,1-.611-.822l.426-2.9a.724.724,0,0,1,1.433.211l-.426,2.9a.725.725,0,0,1-.716.618m.852-5.791a.735.735,0,0,1-.107-.008.723.723,0,0,1-.61-.822l.427-2.895a.724.724,0,0,1,1.433.211l-.427,2.9a.725.725,0,0,1-.716.618m.856-5.79a.7.7,0,0,1-.107-.008.724.724,0,0,1-.611-.822l.428-2.895a.724.724,0,1,1,1.433.212l-.428,2.893a.725.725,0,0,1-.715.619m.856-5.794a.726.726,0,0,1-.718-.83l.428-2.891a.724.724,0,0,1,1.433.212l-.428,2.891a.724.724,0,0,1-.715.618m.855-5.786a.726.726,0,0,1-.718-.83l.427-2.895a.724.724,0,1,1,1.433.211l-.427,2.895a.725.725,0,0,1-.715.619m.854-5.79a.726.726,0,0,1-.718-.83l.424-2.895a.724.724,0,1,1,1.433.209l-.424,2.9a.725.725,0,0,1-.715.619m.847-5.794a.718.718,0,0,1-.718-.828l.42-2.9a.724.724,0,0,1,1.434.207l-.422,2.9a.723.723,0,0,1-.715.619m.838-5.795a.945.945,0,0,1-.1-.007.725.725,0,0,1-.614-.819l.412-2.9a.724.724,0,0,1,1.434.2l-.412,2.9a.724.724,0,0,1-.716.622m.818-5.8a.84.84,0,0,1-.1-.007.726.726,0,0,1-.619-.816c.148-1.073.279-2.045.391-2.9a.724.724,0,1,1,1.437.188c-.112.859-.244,1.834-.392,2.911a.724.724,0,0,1-.716.626m.738-5.816-.063,0a.724.724,0,0,1-.659-.783c.067-.778.1-1.563.1-2.339,0-.168,0-.337-.005-.5a.724.724,0,0,1,1.449-.027c0,.176.005.354.005.531,0,.816-.036,1.645-.107,2.463a.723.723,0,0,1-.72.662M370,177.338a.723.723,0,0,1-.716-.635,27.66,27.66,0,0,0-.5-2.8.725.725,0,0,1,1.411-.328,29.065,29.065,0,0,1,.526,2.949.723.723,0,0,1-.63.807.692.692,0,0,1-.091.007m-1.318-5.68a.726.726,0,0,1-.686-.49,27.987,27.987,0,0,0-1.06-2.643.724.724,0,1,1,1.315-.606,29.377,29.377,0,0,1,1.115,2.779.726.726,0,0,1-.684.959m-2.445-5.3a.724.724,0,0,1-.623-.354,18.771,18.771,0,0,0-1.582-2.314.724.724,0,0,1,1.1-.938,19.986,19.986,0,0,1,1.724,2.512.723.723,0,0,1-.622,1.094",
    transform: "translate(-352.898 -162.501)",
    fill: "#ededed"
  }))))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29399",
    "data-name": "Path 29399",
    d: "M382.308,94.724s-6.578-6.535-10.468-8.868a30.326,30.326,0,0,0-6.09-2.64c-.032.016-.059.035-.091.051-.652.315-.64.3-1.307.588-3.378,1.744-7.238,5.623-12.221,5.747s-8.447-4.458-9.016-4.905c-.72.221-5.153,2.439-5.369,2.548s-3.519,2.049-5.062,3.092a21.664,21.664,0,0,1,1.2,5.545,91.478,91.478,0,0,1-.487,14.266c-.679,4.762-2.576,8.676-3.556,12.894-1.394,6.007,9.353,11.58,9.3,15.013-.224,12.613-.7,24.887-1.211,32.643-.9,13.938-3.619,17.834-3.619,17.834a12.946,12.946,0,0,0,3.75,1.846c.42.152.884.3,1.385.45a37.58,37.58,0,0,0,8.355,1.289c.268.015.535.028.811.036.209.007.42.015.636.015a56.5,56.5,0,0,0,6.887-.376c.478-.051.963-.109,1.447-.167,2.1-.268,4.2-.6,6.191-.956.486-.087.956-.173,1.427-.268,1.92-.362,3.692-.738,5.22-1.078.5-.116.971-.217,1.413-.327,2.3-.535,3.75-.919,3.75-.919s-4.757-15.568-6.7-26.249c-1.527-8.421,2.695-33.809,4.556-44.163v-.007c.224-1.275.419-2.325.558-3.086.165-.89.26-1.382.26-1.382a10.069,10.069,0,0,0,3.135-.45,8.293,8.293,0,0,0,1.383-.558A6.22,6.22,0,0,0,382,108.33a15.131,15.131,0,0,0,.478-2.244v-.008a25.046,25.046,0,0,0,.259-2.679,52.1,52.1,0,0,0-.426-8.675",
    transform: "translate(110.122 27.793)",
    fill: "#20c2b9"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29400",
    "data-name": "Path 29400",
    d: "M357.24,304.814l.584,11.295-12.853.195-21.615-.195s-2.142-2.727,1.753-5.648,15.61-1.9,17.168-2.872a35.25,35.25,0,0,0,4.43-3.991Z",
    transform: "translate(107.801 101.398)",
    fill: "#232c38"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29401",
    "data-name": "Path 29401",
    d: "M349.81,304.506l0,11.643a75.181,75.181,0,0,0,7.441,1.8c4.316.827,9.525,1.621,14.933.628a8.637,8.637,0,0,0-.447-3.77c-1.836-4.2-9.23-3.262-10.288-4.56s-1.321-5.164-1.321-5.164Z",
    transform: "translate(116.832 101.701)",
    fill: "#232c38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10855",
    "data-name": "Group 10855",
    transform: "translate(468.323 219.549)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10854",
    "data-name": "Group 10854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10853",
    "data-name": "Group 10853",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29402",
    "data-name": "Path 29402",
    d: "M370.259,180.753a.726.726,0,0,1-.184-.024,102.24,102.24,0,0,1-10.949-3.77c-6.579-2.657-7.989-11.18-8.047-11.542a.724.724,0,0,1,1.43-.225c.013.081,1.346,8.076,7.16,10.424a101.054,101.054,0,0,0,10.775,3.713.724.724,0,0,1-.184,1.425",
    transform: "translate(-351.07 -164.581)",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10858",
    "data-name": "Group 10858",
    transform: "translate(457.458 221.177)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10857",
    "data-name": "Group 10857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10856",
    "data-name": "Group 10856",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29403",
    "data-name": "Path 29403",
    d: "M345.611,187.436v.016c-.048.666-.111,1.934-.191,3.458a.28.28,0,0,1-.079-.111,24.015,24.015,0,0,1-1.411-3.759c-1.063-3.156-1.015-19.811-1-20.526a.71.71,0,0,1,.714-.714h.016a.725.725,0,0,1,.714.73c-.016,4.744.111,17.607.935,20.05.111.318.207.6.3.856",
    transform: "translate(-342.925 -165.801)",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10861",
    "data-name": "Group 10861",
    transform: "translate(443.977 220.303)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10860",
    "data-name": "Group 10860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10859",
    "data-name": "Group 10859",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29404",
    "data-name": "Path 29404",
    d: "M333.543,181.077a.724.724,0,0,1-.5-1.247,12.994,12.994,0,0,0,2.723-4.086c.963-2.452,2.575-9.949,2.591-10.025a.724.724,0,1,1,1.415.3,105.352,105.352,0,0,1-2.659,10.25,14.228,14.228,0,0,1-3.071,4.6.722.722,0,0,1-.5.2",
    transform: "translate(-332.819 -165.146)",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10864",
    "data-name": "Group 10864",
    transform: "translate(466.969 221.705)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10863",
    "data-name": "Group 10863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10862",
    "data-name": "Group 10862",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29405",
    "data-name": "Path 29405",
    d: "M371.671,166.752s.217,13.3-4.9,19.356-13.284,9-14.951,8.892a1.726,1.726,0,0,1-1.768-1.5s15.409-9.513,17.036-16.12a74.045,74.045,0,0,1,3.658-11.179Z",
    transform: "translate(-350.055 -166.197)",
    fill: "#ededed"
  }))))))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10868",
    "data-name": "Group 10868",
    transform: "translate(466.379 220.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10867",
    "data-name": "Group 10867",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3208",
    "data-name": "Rectangle 3208",
    width: 33.866,
    height: 35.876,
    transform: "matrix(0.837, -0.547, 0.547, 0.837, -13.181, 8.586)",
    fill: "url(#linear-gradient-30)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10879",
    "data-name": "Group 10879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10878",
    "data-name": "Group 10878",
    clipPath: "url(#clip-path)"
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29407",
    "data-name": "Path 29407",
    d: "M383.908,150.59c-.471,3.946-14.518,43.525-14.518,43.525l-2.245-1.065-1.318-.623-.34-.165-1.333-.623v-.008l-1.166-.55s5.069-31.411,7.27-37.632,5.018-7.277,5.018-7.277a48.729,48.729,0,0,1-6.032-12.555c-1.282-3.918-3.266-9.978-5.184-16.359-.3-.962-.587-1.933-.87-2.9a61.224,61.224,0,0,1-2.3-17.711c.305-5.069,1.314-10.852,1.314-10.852s.247.159.682.442c2.571,1.658,11.248,8.476,12.6,11.171,1.57,3.15,5.452,23.381,6.364,28.29s2.527,20.941,2.049,24.895",
    transform: "translate(120.52 28.654)",
    fill: "#21c9c0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10871",
    "data-name": "Group 10871",
    transform: "translate(448.363 160.855)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10870",
    "data-name": "Group 10870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10869",
    "data-name": "Group 10869",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29408",
    "data-name": "Path 29408",
    d: "M336.107,120.582c0,.415,1.158,1.808,3.272,2.429s21.378.233,21.378.233-16.18,1.65-17.854,1.84c-2.2.249-3.774,2.116-3.731,2.613s-1.479,6.789-1.479,6.789.1-8.551-.1-9.765a27.617,27.617,0,0,0-1.487-4.139",
    transform: "translate(-336.107 -120.582)",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10874",
    "data-name": "Group 10874",
    transform: "translate(496.856 173.064)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10873",
    "data-name": "Group 10873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10872",
    "data-name": "Group 10872",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29409",
    "data-name": "Path 29409",
    d: "M372.459,131.43A17.941,17.941,0,0,0,374.244,130c.991-.892,2.973.712,2.973.712s-2.378-.041-2.378.714,1.586.06,1.09,1.25-3.47-1.25-3.47-1.25",
    transform: "translate(-372.459 -129.734)",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10877",
    "data-name": "Group 10877",
    transform: "translate(438.267 178.898)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10876",
    "data-name": "Group 10876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10875",
    "data-name": "Group 10875",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29410",
    "data-name": "Path 29410",
    d: "M328.539,135.086s-.027-1.487,1.573-.792a4.01,4.01,0,0,1,2.1,1.884,1.612,1.612,0,0,1-1.091,0c-.694-.2-2.577-1.091-2.577-1.091",
    transform: "translate(-328.539 -134.108)",
    fill: "#ededed"
  }))))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10881",
    "data-name": "Group 10881",
    transform: "translate(425.341 25.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10880",
    "data-name": "Group 10880",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29411",
    "data-name": "Path 29411",
    d: "M341.374,39.612l-1.515-.333c.015-.068,1.5-6.822,2.273-11.623.723-4.508-2.112-8.419-2.141-8.457l1.25-.919a14,14,0,0,1,2.421,9.622c-.779,4.845-2.274,11.643-2.288,11.711",
    transform: "translate(-311.832 -19.169)",
    fill: "#421e09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29412",
    "data-name": "Path 29412",
    d: "M320,53.706l-1.507-.363c.175-.726,4.338-17.818,9.6-23.458,11.9-12.757,22.047-6.092,22.15-6.024l-.87,1.283c-.371-.248-9.193-5.95-20.146,5.8-4.982,5.345-9.182,22.591-9.223,22.765",
    transform: "translate(-318.968 -17.906)",
    fill: "#421e09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29413",
    "data-name": "Path 29413",
    d: "M319.971,52.218l-1.459-.522c.145-.408,3.7-10.112,14.766-19.175,8.047-6.587,15.741-4.769,16.063-4.69l-.372,1.5c-.072-.016-7.292-1.686-14.707,4.385-10.717,8.774-14.255,18.4-14.29,18.5",
    transform: "translate(-318.962 -16.075)",
    fill: "#421e09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29414",
    "data-name": "Path 29414",
    d: "M370.176,99.159c-.2-.419-4.821-10.441-5.145-27.871a103.656,103.656,0,0,1,.506-11.112c.694-8.279,1.291-15.429-4.453-26.662-5.9-11.539-18.365-8.71-18.892-8.582l-.363-1.506c.14-.037,14.17-3.258,20.635,9.382,5.946,11.627,5.329,18.981,4.617,27.5a102.965,102.965,0,0,0-.5,10.955c.318,17.068,4.952,27.14,5,27.24Z",
    transform: "translate(-311.174 -17.581)",
    fill: "#421e09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29415",
    "data-name": "Path 29415",
    d: "M372.153,98.862c-.414-.244-10.168-6.19-11.927-24.884-.229-2.437-.2-5.345-.179-8.424.064-7.442.135-15.877-2.963-23.317-5.317-12.773-14.733-13.128-15.131-13.136l.028-1.551c.439.008,10.809.339,16.533,14.091,3.22,7.733,3.144,16.711,3.083,23.925-.025,3.039-.049,5.908.173,8.267,1.678,17.846,11.076,23.638,11.171,23.7Z",
    transform: "translate(-311.133 -16.072)",
    fill: "#421e09"
  })))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10922",
    "data-name": "Group 10922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10921",
    "data-name": "Group 10921",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29417",
    "data-name": "Path 29417",
    d: "M356.129,169.475,317.482,194.92l-36.114-54.726L320.011,114.7Z",
    transform: "translate(93.974 38.31)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 44.879,
    height: 64.045,
    transform: "translate(376.293 178.751) rotate(-33.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10884",
    "data-name": "Group 10884",
    transform: "translate(383.368 162.148)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10883",
    "data-name": "Group 10883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10882",
    "data-name": "Group 10882",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29418",
    "data-name": "Path 29418",
    d: "M316.774,121.675l-29.053,19.136a.752.752,0,0,0-.212,1.041l.2.3a.749.749,0,0,0,1.039.212L317.8,123.229a.752.752,0,0,0,.213-1.041l-.2-.3a.751.751,0,0,0-1.041-.213",
    transform: "translate(-287.385 -121.551)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10887",
    "data-name": "Group 10887",
    transform: "translate(385.102 164.773)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10886",
    "data-name": "Group 10886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10885",
    "data-name": "Group 10885",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29419",
    "data-name": "Path 29419",
    d: "M318.074,123.644,289.021,142.78a.752.752,0,0,0-.212,1.041l.2.3a.75.75,0,0,0,1.039.212L319.1,125.2a.751.751,0,0,0,.212-1.04l-.2-.3a.751.751,0,0,0-1.041-.213",
    transform: "translate(-288.685 -123.519)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10890",
    "data-name": "Group 10890",
    transform: "translate(386.835 167.4)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10889",
    "data-name": "Group 10889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10888",
    "data-name": "Group 10888",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29420",
    "data-name": "Path 29420",
    d: "M319.374,125.612l-29.053,19.136a.752.752,0,0,0-.212,1.04l.2.3a.75.75,0,0,0,1.039.212L320.4,127.165a.751.751,0,0,0,.213-1.039l-.2-.3a.751.751,0,0,0-1.04-.213",
    transform: "translate(-289.984 -125.488)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10893",
    "data-name": "Group 10893",
    transform: "translate(388.583 170.046)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10892",
    "data-name": "Group 10892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10891",
    "data-name": "Group 10891",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29421",
    "data-name": "Path 29421",
    d: "M320.684,127.6l-29.053,19.136a.752.752,0,0,0-.212,1.041l.2.3a.749.749,0,0,0,1.039.212l29.053-19.136a.749.749,0,0,0,.212-1.039l-.2-.3a.751.751,0,0,0-1.04-.213",
    transform: "translate(-291.294 -127.472)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10896",
    "data-name": "Group 10896",
    transform: "translate(390.33 172.693)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10895",
    "data-name": "Group 10895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10894",
    "data-name": "Group 10894",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29422",
    "data-name": "Path 29422",
    d: "M321.994,129.58l-29.053,19.136a.752.752,0,0,0-.212,1.041l.2.3a.749.749,0,0,0,1.039.212l29.053-19.135a.752.752,0,0,0,.214-1.04l-.2-.3a.751.751,0,0,0-1.04-.213",
    transform: "translate(-292.604 -129.456)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10899",
    "data-name": "Group 10899",
    transform: "translate(392.078 175.338)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10898",
    "data-name": "Group 10898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10897",
    "data-name": "Group 10897",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29423",
    "data-name": "Path 29423",
    d: "M323.3,131.564,294.251,150.7a.752.752,0,0,0-.212,1.04l.2.3a.751.751,0,0,0,1.041.212l29.053-19.135a.751.751,0,0,0,.212-1.04l-.2-.3a.751.751,0,0,0-1.041-.213",
    transform: "translate(-293.914 -131.439)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10902",
    "data-name": "Group 10902",
    transform: "translate(395.349 180.184)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10901",
    "data-name": "Group 10901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10900",
    "data-name": "Group 10900",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29424",
    "data-name": "Path 29424",
    d: "M325.878,135.2,296.7,154.462a.751.751,0,0,0-.212,1.04l.2.3a.749.749,0,0,0,1.039.212L326.9,136.75a.751.751,0,0,0,.212-1.04l-.2-.3a.751.751,0,0,0-1.041-.213",
    transform: "translate(-296.366 -135.072)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10905",
    "data-name": "Group 10905",
    transform: "translate(397.083 182.81)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10904",
    "data-name": "Group 10904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10903",
    "data-name": "Group 10903",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29425",
    "data-name": "Path 29425",
    d: "M327.178,137.164,298,156.43a.751.751,0,0,0-.213,1.041l.2.3a.751.751,0,0,0,1.039.213L328.2,138.718a.752.752,0,0,0,.213-1.04l-.2-.3a.751.751,0,0,0-1.041-.213",
    transform: "translate(-297.666 -137.04)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10908",
    "data-name": "Group 10908",
    transform: "translate(398.817 185.436)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10907",
    "data-name": "Group 10907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10906",
    "data-name": "Group 10906",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29426",
    "data-name": "Path 29426",
    d: "M328.478,139.133,299.3,158.4a.751.751,0,0,0-.213,1.041l.2.3a.749.749,0,0,0,1.039.212L329.5,140.687a.751.751,0,0,0,.212-1.041l-.2-.3a.751.751,0,0,0-1.04-.213",
    transform: "translate(-298.966 -139.009)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10911",
    "data-name": "Group 10911",
    transform: "translate(400.565 188.083)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10910",
    "data-name": "Group 10910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10909",
    "data-name": "Group 10909",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29427",
    "data-name": "Path 29427",
    d: "M329.788,141.117l-29.174,19.265a.751.751,0,0,0-.213,1.04l.2.3a.749.749,0,0,0,1.039.212l29.176-19.264a.752.752,0,0,0,.213-1.041l-.2-.3a.751.751,0,0,0-1.04-.213",
    transform: "translate(-300.276 -140.993)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10914",
    "data-name": "Group 10914",
    transform: "translate(402.312 190.728)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10913",
    "data-name": "Group 10913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10912",
    "data-name": "Group 10912",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29428",
    "data-name": "Path 29428",
    d: "M331.1,143.1l-29.176,19.265a.752.752,0,0,0-.212,1.041l.2.3a.749.749,0,0,0,1.039.212l29.176-19.264a.751.751,0,0,0,.212-1.04l-.2-.3a.751.751,0,0,0-1.04-.213",
    transform: "translate(-301.586 -142.976)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10917",
    "data-name": "Group 10917",
    transform: "translate(404.06 193.375)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10916",
    "data-name": "Group 10916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10915",
    "data-name": "Group 10915",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29429",
    "data-name": "Path 29429",
    d: "M332.408,145.085l-29.176,19.265a.752.752,0,0,0-.212,1.041l.2.3a.749.749,0,0,0,1.039.212l29.176-19.264a.752.752,0,0,0,.213-1.041l-.2-.3a.751.751,0,0,0-1.04-.213",
    transform: "translate(-302.896 -144.96)",
    fill: "#919191"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10920",
    "data-name": "Group 10920",
    transform: "translate(412.795 204.287)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10919",
    "data-name": "Group 10919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10918",
    "data-name": "Group 10918",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29430",
    "data-name": "Path 29430",
    d: "M333.542,153.225l-23.853,15.752a.69.69,0,0,0-.1.964l.2.3a.693.693,0,0,0,.927.288l23.853-15.752a.693.693,0,0,0,.1-.964l-.2-.3a.693.693,0,0,0-.926-.288",
    transform: "translate(-309.444 -153.14)",
    fill: "#919191"
  }))))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10924",
    "data-name": "Group 10924",
    transform: "translate(392.176 208.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10923",
    "data-name": "Group 10923",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29431",
    "data-name": "Path 29431",
    d: "M302.81,153.5l5.036,11.679-12.221,4.64-5.036-11.679Z",
    transform: "translate(-295.122 -156.765)",
    fill: "url(#linear-gradient-31)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarImage);
export default __webpack_public_path__ + "static/media/car_image.6797747bce841e5be14b83e6edfc39a3.svg";
export { ForwardRef as ReactComponent };